(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6bc6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6bc6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lXx6D", function(module, exports) {

var $8dWjV = parcelRequire("8dWjV");
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    return function(e) {
        var n = {};
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                enumerable: !0,
                get: r
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, n) {
            if (1 & n && (e = t(e)), 8 & n) return e;
            if (4 & n && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (t.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & n && "string" != typeof e) for(var o in e)t.d(r, o, (function(n) {
                return e[n];
            }).bind(null, o));
            return r;
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, n) {
            return Object.prototype.hasOwnProperty.call(e, n);
        }, t.p = "/", t(t.s = 8);
    }([
        function(e, n, t) {
            "use strict";
            t.r(n), t.d(n, "h", function() {
                return a;
            }), t.d(n, "createElement", function() {
                return a;
            }), t.d(n, "cloneElement", function() {
                return l;
            }), t.d(n, "createRef", function() {
                return _;
            }), t.d(n, "Component", function() {
                return Y;
            }), t.d(n, "render", function() {
                return Q;
            }), t.d(n, "rerender", function() {
                return y;
            }), t.d(n, "options", function() {
                return o;
            });
            var r = function() {}, o = {}, i = [], M = [];
            function a(e, n) {
                var t, a, u, s, c = M;
                for(s = arguments.length; s-- > 2;)i.push(arguments[s]);
                for(n && null != n.children && (i.length || i.push(n.children), delete n.children); i.length;)if ((a = i.pop()) && void 0 !== a.pop) for(s = a.length; s--;)i.push(a[s]);
                else "boolean" == typeof a && (a = null), (u = "function" != typeof e) && (null == a ? a = "" : "number" == typeof a ? a = String(a) : "string" != typeof a && (u = !1)), u && t ? c[c.length - 1] += a : c === M ? c = [
                    a
                ] : c.push(a), t = u;
                var l = new r;
                return l.nodeName = e, l.children = c, l.attributes = null == n ? void 0 : n, l.key = null == n ? void 0 : n.key, void 0 !== o.vnode && o.vnode(l), l;
            }
            function u(e, n) {
                for(var t in n)e[t] = n[t];
                return e;
            }
            function s(e, n) {
                e && ("function" == typeof e ? e(n) : e.current = n);
            }
            var c = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
            function l(e, n) {
                return a(e.nodeName, u(u({}, e.attributes), n), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
            }
            var N = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, D = [];
            function g(e) {
                !e._dirty && (e._dirty = !0) && 1 == D.push(e) && (o.debounceRendering || c)(y);
            }
            function y() {
                for(var e; e = D.pop();)e._dirty && S(e);
            }
            function j(e, n, t) {
                return "string" == typeof n || "number" == typeof n ? void 0 !== e.splitText : "string" == typeof n.nodeName ? !e._componentConstructor && z(e, n.nodeName) : t || e._componentConstructor === n.nodeName;
            }
            function z(e, n) {
                return e.normalizedNodeName === n || e.nodeName.toLowerCase() === n.toLowerCase();
            }
            function T(e) {
                var n = u({}, e.attributes);
                n.children = e.children;
                var t = e.nodeName.defaultProps;
                if (void 0 !== t) for(var r in t)void 0 === n[r] && (n[r] = t[r]);
                return n;
            }
            function f(e) {
                var n = e.parentNode;
                n && n.removeChild(e);
            }
            function A(e, n, t, r, o) {
                if ("className" === n && (n = "class"), "key" === n) ;
                else if ("ref" === n) s(t, null), s(r, e);
                else if ("class" !== n || o) {
                    if ("style" === n) {
                        if (r && "string" != typeof r && "string" != typeof t || (e.style.cssText = r || ""), r && "object" == typeof r) {
                            if ("string" != typeof t) for(var i in t)i in r || (e.style[i] = "");
                            for(var i in r)e.style[i] = "number" == typeof r[i] && !1 === N.test(i) ? r[i] + "px" : r[i];
                        }
                    } else if ("dangerouslySetInnerHTML" === n) r && (e.innerHTML = r.__html || "");
                    else if ("o" == n[0] && "n" == n[1]) {
                        var M = n !== (n = n.replace(/Capture$/, ""));
                        n = n.toLowerCase().substring(2), r ? t || e.addEventListener(n, d, M) : e.removeEventListener(n, d, M), (e._listeners || (e._listeners = {}))[n] = r;
                    } else if ("list" !== n && "type" !== n && !o && n in e) {
                        try {
                            e[n] = null == r ? "" : r;
                        } catch (e) {}
                        null != r && !1 !== r || "spellcheck" == n || e.removeAttribute(n);
                    } else {
                        var a = o && n !== (n = n.replace(/^xlink:?/, ""));
                        null == r || !1 === r ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase()) : e.removeAttribute(n) : "function" != typeof r && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase(), r) : e.setAttribute(n, r));
                    }
                } else e.className = r || "";
            }
            function d(e) {
                return this._listeners[e.type](o.event && o.event(e) || e);
            }
            var p = [], E = 0, w = !1, I = !1;
            function O() {
                for(var e; e = p.shift();)o.afterMount && o.afterMount(e), e.componentDidMount && e.componentDidMount();
            }
            function x(e, n, t, r, o, i) {
                E++ || (w = null != o && void 0 !== o.ownerSVGElement, I = null != e && !("__preactattr_" in e));
                var M = L(e, n, t, r, i);
                return o && M.parentNode !== o && o.appendChild(M), --E || (I = !1, i || O()), M;
            }
            function L(e, n, t, r, o) {
                var i = e, M = w;
                if (null != n && "boolean" != typeof n || (n = ""), "string" == typeof n || "number" == typeof n) return e && void 0 !== e.splitText && e.parentNode && (!e._component || o) ? e.nodeValue != n && (e.nodeValue = n) : (i = document.createTextNode(n), e && (e.parentNode && e.parentNode.replaceChild(i, e), h(e, !0))), i.__preactattr_ = !0, i;
                var a, u, s = n.nodeName;
                if ("function" == typeof s) return function(e, n, t, r) {
                    var o = e && e._component, i = o, M = e, a = o && e._componentConstructor === n.nodeName, u = a, s = T(n);
                    for(; o && !u && (o = o._parentComponent);)u = o.constructor === n.nodeName;
                    o && u && (!r || o._component) ? (C(o, s, 3, t, r), e = o.base) : (i && !a && (U(i), e = M = null), o = b(n.nodeName, s, t), e && !o.nextBase && (o.nextBase = e, M = null), C(o, s, 1, t, r), e = o.base, M && e !== M && (M._component = null, h(M, !1)));
                    return e;
                }(e, n, t, r);
                if (w = "svg" === s || "foreignObject" !== s && w, s = String(s), (!e || !z(e, s)) && (a = s, (u = w ? document.createElementNS("http://www.w3.org/2000/svg", a) : document.createElement(a)).normalizedNodeName = a, i = u, e)) {
                    for(; e.firstChild;)i.appendChild(e.firstChild);
                    e.parentNode && e.parentNode.replaceChild(i, e), h(e, !0);
                }
                var c = i.firstChild, l = i.__preactattr_, N = n.children;
                if (null == l) {
                    l = i.__preactattr_ = {};
                    for(var D = i.attributes, g = D.length; g--;)l[D[g].name] = D[g].value;
                }
                return !I && N && 1 === N.length && "string" == typeof N[0] && null != c && void 0 !== c.splitText && null == c.nextSibling ? c.nodeValue != N[0] && (c.nodeValue = N[0]) : (N && N.length || null != c) && function(e, n, t, r, o) {
                    var i, M, a, u, s, c = e.childNodes, l = [], N = {}, D = 0, g = 0, y = c.length, z = 0, T = n ? n.length : 0;
                    if (0 !== y) for(var A = 0; A < y; A++){
                        var d = c[A], p = d.__preactattr_;
                        null != (E = T && p ? d._component ? d._component.__key : p.key : null) ? (D++, N[E] = d) : (p || (void 0 !== d.splitText ? !o || d.nodeValue.trim() : o)) && (l[z++] = d);
                    }
                    if (0 !== T) for(A = 0; A < T; A++){
                        var E;
                        if (u = n[A], s = null, null != (E = u.key)) D && void 0 !== N[E] && (s = N[E], N[E] = void 0, D--);
                        else if (g < z) {
                            for(i = g; i < z; i++)if (void 0 !== l[i] && j(M = l[i], u, o)) {
                                s = M, l[i] = void 0, i === z - 1 && z--, i === g && g++;
                                break;
                            }
                        }
                        s = L(s, u, t, r), a = c[A], s && s !== e && s !== a && (null == a ? e.appendChild(s) : s === a.nextSibling ? f(a) : e.insertBefore(s, a));
                    }
                    if (D) for(var A in N)void 0 !== N[A] && h(N[A], !1);
                    for(; g <= z;)void 0 !== (s = l[z--]) && h(s, !1);
                }(i, N, t, r, I || null != l.dangerouslySetInnerHTML), function(e, n, t) {
                    var r;
                    for(r in t)n && null != n[r] || null == t[r] || A(e, r, t[r], t[r] = void 0, w);
                    for(r in n)"children" === r || "innerHTML" === r || r in t && n[r] === ("value" === r || "checked" === r ? e[r] : t[r]) || A(e, r, t[r], t[r] = n[r], w);
                }(i, n.attributes, l), w = M, i;
            }
            function h(e, n) {
                var t = e._component;
                t ? U(t) : (null != e.__preactattr_ && s(e.__preactattr_.ref, null), !1 !== n && null != e.__preactattr_ || f(e), v(e));
            }
            function v(e) {
                for(e = e.lastChild; e;){
                    var n = e.previousSibling;
                    h(e, !0), e = n;
                }
            }
            var m = [];
            function b(e, n, t) {
                var r, o = m.length;
                for(e.prototype && e.prototype.render ? (r = new e(n, t), Y.call(r, n, t)) : ((r = new Y(n, t)).constructor = e, r.render = k); o--;)if (m[o].constructor === e) return r.nextBase = m[o].nextBase, m.splice(o, 1), r;
                return r;
            }
            function k(e, n, t) {
                return this.constructor(e, t);
            }
            function C(e, n, t, r, i) {
                e._disable || (e._disable = !0, e.__ref = n.ref, e.__key = n.key, delete n.ref, delete n.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(n, r)), r && r !== e.context && (e.prevContext || (e.prevContext = e.context), e.context = r), e.prevProps || (e.prevProps = e.props), e.props = n, e._disable = !1, 0 !== t && (1 !== t && !1 === o.syncComponentUpdates && e.base ? g(e) : S(e, 1, i)), s(e.__ref, e));
            }
            function S(e, n, t, r) {
                if (!e._disable) {
                    var i, M, a, s = e.props, c = e.state, l = e.context, N = e.prevProps || s, D = e.prevState || c, g = e.prevContext || l, y = e.base, j = e.nextBase, z = y || j, f = e._component, A = !1, d = g;
                    if (e.constructor.getDerivedStateFromProps && (c = u(u({}, c), e.constructor.getDerivedStateFromProps(s, c)), e.state = c), y && (e.props = N, e.state = D, e.context = g, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(s, c, l) ? A = !0 : e.componentWillUpdate && e.componentWillUpdate(s, c, l), e.props = s, e.state = c, e.context = l), e.prevProps = e.prevState = e.prevContext = e.nextBase = null, e._dirty = !1, !A) {
                        i = e.render(s, c, l), e.getChildContext && (l = u(u({}, l), e.getChildContext())), y && e.getSnapshotBeforeUpdate && (d = e.getSnapshotBeforeUpdate(N, D));
                        var w, I, L = i && i.nodeName;
                        if ("function" == typeof L) {
                            var v = T(i);
                            (M = f) && M.constructor === L && v.key == M.__key ? C(M, v, 1, l, !1) : (w = M, e._component = M = b(L, v, l), M.nextBase = M.nextBase || j, M._parentComponent = e, C(M, v, 0, l, !1), S(M, 1, t, !0)), I = M.base;
                        } else a = z, (w = f) && (a = e._component = null), (z || 1 === n) && (a && (a._component = null), I = x(a, i, l, t || !y, z && z.parentNode, !0));
                        if (z && I !== z && M !== f) {
                            var m = z.parentNode;
                            m && I !== m && (m.replaceChild(I, z), w || (z._component = null, h(z, !1)));
                        }
                        if (w && U(w), e.base = I, I && !r) {
                            for(var k = e, Y = e; Y = Y._parentComponent;)(k = Y).base = I;
                            I._component = k, I._componentConstructor = k.constructor;
                        }
                    }
                    for(!y || t ? p.push(e) : A || (e.componentDidUpdate && e.componentDidUpdate(N, D, d), o.afterUpdate && o.afterUpdate(e)); e._renderCallbacks.length;)e._renderCallbacks.pop().call(e);
                    E || r || O();
                }
            }
            function U(e) {
                o.beforeUnmount && o.beforeUnmount(e);
                var n = e.base;
                e._disable = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;
                var t = e._component;
                t ? U(t) : n && (null != n.__preactattr_ && s(n.__preactattr_.ref, null), e.nextBase = n, f(n), m.push(e), v(n)), s(e.__ref, null);
            }
            function Y(e, n) {
                this._dirty = !0, this.context = n, this.props = e, this.state = this.state || {}, this._renderCallbacks = [];
            }
            function Q(e, n, t) {
                return x(t, e, {}, !1, n, !1);
            }
            function _() {
                return {};
            }
            u(Y.prototype, {
                setState: function(e, n) {
                    this.prevState || (this.prevState = this.state), this.state = u(u({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this._renderCallbacks.push(n), g(this);
                },
                forceUpdate: function(e) {
                    e && this._renderCallbacks.push(e), S(this, 2);
                },
                render: function() {}
            });
            var B = {
                h: a,
                createElement: a,
                cloneElement: l,
                createRef: _,
                Component: Y,
                render: Q,
                rerender: y,
                options: o
            };
            n.default = B;
        },
        function(e, n, t) {
            "use strict";
            t.r(n), (function(e) {
                t.d(n, "$mobx", function() {
                    return d;
                }), t.d(n, "FlowCancellationError", function() {
                    return On;
                }), t.d(n, "IDerivationState", function() {
                    return K;
                }), t.d(n, "ObservableMap", function() {
                    return At;
                }), t.d(n, "ObservableSet", function() {
                    return Et;
                }), t.d(n, "Reaction", function() {
                    return Ve;
                }), t.d(n, "_allowStateChanges", function() {
                    return Ee;
                }), t.d(n, "_allowStateChangesInsideComputed", function() {
                    return Oe;
                }), t.d(n, "_allowStateReadsEnd", function() {
                    return ge;
                }), t.d(n, "_allowStateReadsStart", function() {
                    return De;
                }), t.d(n, "_endAction", function() {
                    return pe;
                }), t.d(n, "_getAdministration", function() {
                    return kt;
                }), t.d(n, "_getGlobalState", function() {
                    return Qe;
                }), t.d(n, "_interceptReads", function() {
                    return vn;
                }), t.d(n, "_isComputingDerivation", function() {
                    return Me;
                }), t.d(n, "_resetGlobalState", function() {
                    return _e;
                }), t.d(n, "_startAction", function() {
                    return de;
                }), t.d(n, "action", function() {
                    return on;
                }), t.d(n, "autorun", function() {
                    return sn;
                }), t.d(n, "comparer", function() {
                    return I;
                }), t.d(n, "computed", function() {
                    return te;
                }), t.d(n, "configure", function() {
                    return jn;
                }), t.d(n, "createAtom", function() {
                    return w;
                }), t.d(n, "decorate", function() {
                    return zn;
                }), t.d(n, "entries", function() {
                    return Bn;
                }), t.d(n, "extendObservable", function() {
                    return Tn;
                }), t.d(n, "flow", function() {
                    return Ln;
                }), t.d(n, "get", function() {
                    return Gn;
                }), t.d(n, "getAtom", function() {
                    return bt;
                }), t.d(n, "getDebugName", function() {
                    return Ct;
                }), t.d(n, "getDependencyTree", function() {
                    return dn;
                }), t.d(n, "getObserverTree", function() {
                    return En;
                }), t.d(n, "has", function() {
                    return Zn;
                }), t.d(n, "intercept", function() {
                    return mn;
                }), t.d(n, "isAction", function() {
                    return an;
                }), t.d(n, "isArrayLike", function() {
                    return g;
                }), t.d(n, "isBoxedObservable", function() {
                    return Le;
                }), t.d(n, "isComputed", function() {
                    return kn;
                }), t.d(n, "isComputedProp", function() {
                    return Cn;
                }), t.d(n, "isFlowCancellationError", function() {
                    return xn;
                }), t.d(n, "isObservable", function() {
                    return Un;
                }), t.d(n, "isObservableArray", function() {
                    return zt;
                }), t.d(n, "isObservableMap", function() {
                    return dt;
                }), t.d(n, "isObservableObject", function() {
                    return mt;
                }), t.d(n, "isObservableProp", function() {
                    return Yn;
                }), t.d(n, "isObservableSet", function() {
                    return wt;
                }), t.d(n, "keys", function() {
                    return Qn;
                }), t.d(n, "observable", function() {
                    return q;
                }), t.d(n, "observe", function() {
                    return Hn;
                }), t.d(n, "onBecomeObserved", function() {
                    return Dn;
                }), t.d(n, "onBecomeUnobserved", function() {
                    return gn;
                }), t.d(n, "onReactionError", function() {
                    return Je;
                }), t.d(n, "reaction", function() {
                    return Nn;
                }), t.d(n, "remove", function() {
                    return Rn;
                }), t.d(n, "runInAction", function() {
                    return Mn;
                }), t.d(n, "set", function() {
                    return Pn;
                }), t.d(n, "spy", function() {
                    return en;
                }), t.d(n, "toJS", function() {
                    return Jn;
                }), t.d(n, "trace", function() {
                    return Fn;
                }), t.d(n, "transaction", function() {
                    return Xn;
                }), t.d(n, "untracked", function() {
                    return ce;
                }), t.d(n, "values", function() {
                    return _n;
                }), t.d(n, "when", function() {
                    return Kn;
                });
                var r = [];
                Object.freeze(r);
                var o = {};
                function i() {
                    return ++Ye.mobxGuid;
                }
                function M(e) {
                    throw a(!1, e), "X";
                }
                function a(e, n) {
                    if (!e) throw new Error("[mobx] " + (n || "An invariant failed, however the error is obfuscated because this is a production build."));
                }
                Object.freeze(o);
                function u(e) {
                    var n = !1;
                    return function() {
                        if (!n) return n = !0, e.apply(this, arguments);
                    };
                }
                var s = function() {};
                function c(e) {
                    return null !== e && "object" == typeof e;
                }
                function l(e) {
                    if (null === e || "object" != typeof e) return !1;
                    var n = Object.getPrototypeOf(e);
                    return n === Object.prototype || null === n;
                }
                function N(e, n, t) {
                    Object.defineProperty(e, n, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: t
                    });
                }
                function D(e, n) {
                    var t = "isMobX" + e;
                    return n.prototype[t] = !0, function(e) {
                        return c(e) && !0 === e[t];
                    };
                }
                function g(e) {
                    return Array.isArray(e) || zt(e);
                }
                function y(e) {
                    return e instanceof Map;
                }
                function j(e) {
                    return e instanceof Set;
                }
                function z(e) {
                    var n = new Set;
                    for(var t in e)n.add(t);
                    return Object.getOwnPropertySymbols(e).forEach(function(t) {
                        Object.getOwnPropertyDescriptor(e, t).enumerable && n.add(t);
                    }), Array.from(n);
                }
                function T(e) {
                    return e && e.toString ? e.toString() : new String(e).toString();
                }
                function f(e) {
                    return null === e ? null : "object" == typeof e ? "" + e : e;
                }
                var A = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : Object.getOwnPropertyNames, d = Symbol("mobx administration"), p = function() {
                    function e(e) {
                        void 0 === e && (e = "Atom@" + i()), this.name = e, this.isPendingUnobservation = !1, this.isBeingObserved = !1, this.observers = new Set, this.diffValue = 0, this.lastAccessedBy = 0, this.lowestObserverState = K.NOT_TRACKING;
                    }
                    return e.prototype.onBecomeObserved = function() {
                        this.onBecomeObservedListeners && this.onBecomeObservedListeners.forEach(function(e) {
                            return e();
                        });
                    }, e.prototype.onBecomeUnobserved = function() {
                        this.onBecomeUnobservedListeners && this.onBecomeUnobservedListeners.forEach(function(e) {
                            return e();
                        });
                    }, e.prototype.reportObserved = function() {
                        return He(this);
                    }, e.prototype.reportChanged = function() {
                        Ze(), function(e) {
                            if (e.lowestObserverState === K.STALE) return;
                            e.lowestObserverState = K.STALE, e.observers.forEach(function(n) {
                                n.dependenciesState === K.UP_TO_DATE && (n.isTracing !== $.NONE && We(n, e), n.onBecomeStale()), n.dependenciesState = K.STALE;
                            });
                        }(this), Ge();
                    }, e.prototype.toString = function() {
                        return this.name;
                    }, e;
                }(), E = D("Atom", p);
                function w(e, n, t) {
                    void 0 === n && (n = s), void 0 === t && (t = s);
                    var r = new p(e);
                    return n !== s && Dn(r, n), t !== s && gn(r, t), r;
                }
                var I = {
                    identity: function(e, n) {
                        return e === n;
                    },
                    structural: function(e, n) {
                        return Ut(e, n);
                    },
                    default: function(e, n) {
                        return Object.is(e, n);
                    },
                    shallow: function(e, n) {
                        return Ut(e, n, 1);
                    }
                }, O = function(e, n) {
                    return (O = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, n) {
                        e.__proto__ = n;
                    } || function(e, n) {
                        for(var t in n)n.hasOwnProperty(t) && (e[t] = n[t]);
                    })(e, n);
                };
                /*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var x = function() {
                    return (x = Object.assign || function(e) {
                        for(var n, t = 1, r = arguments.length; t < r; t++)for(var o in n = arguments[t])Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
                        return e;
                    }).apply(this, arguments);
                };
                function L(e) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator], t = 0;
                    return n ? n.call(e) : {
                        next: function() {
                            return e && t >= e.length && (e = void 0), {
                                value: e && e[t++],
                                done: !e
                            };
                        }
                    };
                }
                function h(e, n) {
                    var t = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!t) return e;
                    var r, o, i = t.call(e), M = [];
                    try {
                        for(; (void 0 === n || n-- > 0) && !(r = i.next()).done;)M.push(r.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (t = i.return) && t.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return M;
                }
                function v() {
                    for(var e = [], n = 0; n < arguments.length; n++)e = e.concat(h(arguments[n]));
                    return e;
                }
                var m = Symbol("mobx did run lazy initializers"), b = Symbol("mobx pending decorators"), k = {}, C = {};
                function S(e, n) {
                    var t = n ? k : C;
                    return t[e] || (t[e] = {
                        configurable: !0,
                        enumerable: n,
                        get: function() {
                            return U(this), this[e];
                        },
                        set: function(n) {
                            U(this), this[e] = n;
                        }
                    });
                }
                function U(e) {
                    var n, t;
                    if (!0 !== e[m]) {
                        var r = e[b];
                        if (r) {
                            N(e, m, !0);
                            var o = v(Object.getOwnPropertySymbols(r), Object.keys(r));
                            try {
                                for(var i = L(o), M = i.next(); !M.done; M = i.next()){
                                    var a = r[M.value];
                                    a.propertyCreator(e, a.prop, a.descriptor, a.decoratorTarget, a.decoratorArguments);
                                }
                            } catch (e) {
                                n = {
                                    error: e
                                };
                            } finally{
                                try {
                                    M && !M.done && (t = i.return) && t.call(i);
                                } finally{
                                    if (n) throw n.error;
                                }
                            }
                        }
                    }
                }
                function Y(e, n) {
                    return function() {
                        var t, o = function(r, o, i, M) {
                            if (!0 === M) return n(r, o, i, r, t), null;
                            if (!Object.prototype.hasOwnProperty.call(r, b)) {
                                var a = r[b];
                                N(r, b, x({}, a));
                            }
                            return r[b][o] = {
                                prop: o,
                                propertyCreator: n,
                                descriptor: i,
                                decoratorTarget: r,
                                decoratorArguments: t
                            }, S(o, e);
                        };
                        return Q(arguments) ? (t = r, o.apply(null, arguments)) : (t = Array.prototype.slice.call(arguments), o);
                    };
                }
                function Q(e) {
                    return (2 === e.length || 3 === e.length) && ("string" == typeof e[1] || "symbol" == typeof e[1]) || 4 === e.length && !0 === e[3];
                }
                function _(e, n, t) {
                    return Un(e) ? e : Array.isArray(e) ? q.array(e, {
                        name: t
                    }) : l(e) ? q.object(e, void 0, {
                        name: t
                    }) : y(e) ? q.map(e, {
                        name: t
                    }) : j(e) ? q.set(e, {
                        name: t
                    }) : e;
                }
                function B(e) {
                    return e;
                }
                function P(e) {
                    a(e);
                    var n = Y(!0, function(n, t, r, o, i) {
                        var M = r ? r.initializer ? r.initializer.call(n) : r.value : void 0;
                        Ot(n).addObservableProp(t, M, e);
                    }), t = ("undefined" != typeof $8dWjV && $8dWjV.env, n);
                    return t.enhancer = e, t;
                }
                var R = {
                    deep: !0,
                    name: void 0,
                    defaultDecorator: void 0,
                    proxy: !0
                };
                function Z(e) {
                    return null == e ? R : "string" == typeof e ? {
                        name: e,
                        deep: !0,
                        proxy: !0
                    } : e;
                }
                Object.freeze(R);
                var G = P(_), H = P(function(e, n, t) {
                    return null == e || mt(e) || zt(e) || dt(e) || wt(e) ? e : Array.isArray(e) ? q.array(e, {
                        name: t,
                        deep: !1
                    }) : l(e) ? q.object(e, void 0, {
                        name: t,
                        deep: !1
                    }) : y(e) ? q.map(e, {
                        name: t,
                        deep: !1
                    }) : j(e) ? q.set(e, {
                        name: t,
                        deep: !1
                    }) : M(!1);
                }), W = P(B), V = P(function(e, n, t) {
                    return Ut(e, n) ? n : e;
                });
                function J(e) {
                    return e.defaultDecorator ? e.defaultDecorator.enhancer : !1 === e.deep ? B : _;
                }
                var F = {
                    box: function(e, n) {
                        arguments.length > 2 && X("box");
                        var t = Z(n);
                        return new xe(e, J(t), t.name, !0, t.equals);
                    },
                    array: function(e, n) {
                        arguments.length > 2 && X("array");
                        var t = Z(n);
                        return Nt(e, J(t), t.name);
                    },
                    map: function(e, n) {
                        arguments.length > 2 && X("map");
                        var t = Z(n);
                        return new At(e, J(t), t.name);
                    },
                    set: function(e, n) {
                        arguments.length > 2 && X("set");
                        var t = Z(n);
                        return new Et(e, J(t), t.name);
                    },
                    object: function(e, n, t) {
                        "string" == typeof arguments[1] && X("object");
                        var r = Z(t);
                        if (!1 === r.proxy) return Tn({}, e, n, r);
                        var o = fn(r), i = Tn({}, void 0, void 0, r), M = ot(i);
                        return An(M, e, n, o), M;
                    },
                    ref: W,
                    shallow: H,
                    deep: G,
                    struct: V
                }, q = function(e, n, t) {
                    if ("string" == typeof arguments[1] || "symbol" == typeof arguments[1]) return G.apply(null, arguments);
                    if (Un(e)) return e;
                    var r = l(e) ? q.object(e, n, t) : Array.isArray(e) ? q.array(e, n) : y(e) ? q.map(e, n) : j(e) ? q.set(e, n) : e;
                    if (r !== e) return r;
                    M(!1);
                };
                function X(e) {
                    M("Expected one or two arguments to observable." + e + ". Did you accidentally try to use observable." + e + " as decorator?");
                }
                Object.keys(F).forEach(function(e) {
                    return q[e] = F[e];
                });
                var K, $, ee = Y(!1, function(e, n, t, r, o) {
                    var i = t.get, M = t.set, a = o[0] || {};
                    Ot(e).addComputedProp(e, n, x({
                        get: i,
                        set: M,
                        context: e
                    }, a));
                }), ne = ee({
                    equals: I.structural
                }), te = function(e, n, t) {
                    if ("string" == typeof n) return ee.apply(null, arguments);
                    if (null !== e && "object" == typeof e && 1 === arguments.length) return ee.apply(null, arguments);
                    var r = "object" == typeof n ? n : {};
                    return r.get = e, r.set = "function" == typeof n ? n : r.set, r.name = r.name || e.name || "", new he(r);
                };
                te.struct = ne, function(e) {
                    e[e.NOT_TRACKING = -1] = "NOT_TRACKING", e[e.UP_TO_DATE = 0] = "UP_TO_DATE", e[e.POSSIBLY_STALE = 1] = "POSSIBLY_STALE", e[e.STALE = 2] = "STALE";
                }(K || (K = {})), function(e) {
                    e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
                }($ || ($ = {}));
                var re = function(e) {
                    this.cause = e;
                };
                function oe(e) {
                    return e instanceof re;
                }
                function ie(e) {
                    switch(e.dependenciesState){
                        case K.UP_TO_DATE:
                            return !1;
                        case K.NOT_TRACKING:
                        case K.STALE:
                            return !0;
                        case K.POSSIBLY_STALE:
                            for(var n = De(!0), t = le(), r = e.observing, o = r.length, i = 0; i < o; i++){
                                var M = r[i];
                                if (ve(M)) {
                                    if (Ye.disableErrorBoundaries) M.get();
                                    else try {
                                        M.get();
                                    } catch (e) {
                                        return Ne(t), ge(n), !0;
                                    }
                                    if (e.dependenciesState === K.STALE) return Ne(t), ge(n), !0;
                                }
                            }
                            return ye(e), Ne(t), ge(n), !1;
                    }
                }
                function Me() {
                    return null !== Ye.trackingDerivation;
                }
                function ae(e) {
                    var n = e.observers.size > 0;
                    Ye.computationDepth > 0 && n && M(!1), Ye.allowStateChanges || !n && "strict" !== Ye.enforceActions || M(!1);
                }
                function ue(e, n, t) {
                    var r = De(!0);
                    ye(e), e.newObserving = new Array(e.observing.length + 100), e.unboundDepsCount = 0, e.runId = ++Ye.runId;
                    var o, i = Ye.trackingDerivation;
                    if (Ye.trackingDerivation = e, !0 === Ye.disableErrorBoundaries) o = n.call(t);
                    else try {
                        o = n.call(t);
                    } catch (e) {
                        o = new re(e);
                    }
                    return Ye.trackingDerivation = i, function(e) {
                        for(var n = e.observing, t = e.observing = e.newObserving, r = K.UP_TO_DATE, o = 0, i = e.unboundDepsCount, M = 0; M < i; M++)0 === (a = t[M]).diffValue && (a.diffValue = 1, o !== M && (t[o] = a), o++), a.dependenciesState > r && (r = a.dependenciesState);
                        t.length = o, e.newObserving = null, i = n.length;
                        for(; i--;)0 === (a = n[i]).diffValue && Pe(a, e), a.diffValue = 0;
                        for(; o--;){
                            var a;
                            1 === (a = t[o]).diffValue && (a.diffValue = 0, Be(a, e));
                        }
                        r !== K.UP_TO_DATE && (e.dependenciesState = r, e.onBecomeStale());
                    }(e), ge(r), o;
                }
                function se(e) {
                    var n = e.observing;
                    e.observing = [];
                    for(var t = n.length; t--;)Pe(n[t], e);
                    e.dependenciesState = K.NOT_TRACKING;
                }
                function ce(e) {
                    var n = le();
                    try {
                        return e();
                    } finally{
                        Ne(n);
                    }
                }
                function le() {
                    var e = Ye.trackingDerivation;
                    return Ye.trackingDerivation = null, e;
                }
                function Ne(e) {
                    Ye.trackingDerivation = e;
                }
                function De(e) {
                    var n = Ye.allowStateReads;
                    return Ye.allowStateReads = e, n;
                }
                function ge(e) {
                    Ye.allowStateReads = e;
                }
                function ye(e) {
                    if (e.dependenciesState !== K.UP_TO_DATE) {
                        e.dependenciesState = K.UP_TO_DATE;
                        for(var n = e.observing, t = n.length; t--;)n[t].lowestObserverState = K.UP_TO_DATE;
                    }
                }
                var je = 0, ze = 1, Te = Object.getOwnPropertyDescriptor(function() {}, "name");
                Te && Te.configurable;
                function fe(e, n, t) {
                    var r = function() {
                        return Ae(e, n, t || this, arguments);
                    };
                    return r.isMobxAction = !0, r;
                }
                function Ae(e, n, t, r) {
                    var o = de(e, t, r);
                    try {
                        return n.apply(t, r);
                    } catch (e) {
                        throw o.error = e, e;
                    } finally{
                        pe(o);
                    }
                }
                function de(e, n, t) {
                    var r = 0, o = le();
                    Ze();
                    var i = {
                        prevDerivation: o,
                        prevAllowStateChanges: we(!0),
                        prevAllowStateReads: De(!0),
                        notifySpy: !1,
                        startTime: r,
                        actionId: ze++,
                        parentActionId: je
                    };
                    return je = i.actionId, i;
                }
                function pe(e) {
                    je !== e.actionId && M("invalid action stack. did you forget to finish an action?"), je = e.parentActionId, void 0 !== e.error && (Ye.suppressReactionErrors = !0), Ie(e.prevAllowStateChanges), ge(e.prevAllowStateReads), Ge(), Ne(e.prevDerivation), e.notifySpy, Ye.suppressReactionErrors = !1;
                }
                function Ee(e, n) {
                    var t, r = we(e);
                    try {
                        t = n();
                    } finally{
                        Ie(r);
                    }
                    return t;
                }
                function we(e) {
                    var n = Ye.allowStateChanges;
                    return Ye.allowStateChanges = e, n;
                }
                function Ie(e) {
                    Ye.allowStateChanges = e;
                }
                function Oe(e) {
                    var n, t = Ye.computationDepth;
                    Ye.computationDepth = 0;
                    try {
                        n = e();
                    } finally{
                        Ye.computationDepth = t;
                    }
                    return n;
                }
                var xe = function(e) {
                    function n(n, t, r, o, M) {
                        void 0 === r && (r = "ObservableValue@" + i()), void 0 === o && (o = !0), void 0 === M && (M = I.default);
                        var a = e.call(this, r) || this;
                        return a.enhancer = t, a.name = r, a.equals = M, a.hasUnreportedChange = !1, a.value = t(n, void 0, r), a;
                    }
                    return function(e, n) {
                        function t() {
                            this.constructor = e;
                        }
                        O(e, n), e.prototype = null === n ? Object.create(n) : (t.prototype = n.prototype, new t);
                    }(n, e), n.prototype.dehanceValue = function(e) {
                        return void 0 !== this.dehancer ? this.dehancer(e) : e;
                    }, n.prototype.set = function(e) {
                        this.value;
                        if ((e = this.prepareNewValue(e)) !== Ye.UNCHANGED) this.setNewValue(e);
                    }, n.prototype.prepareNewValue = function(e) {
                        if (ae(this), it(this)) {
                            var n = at(this, {
                                object: this,
                                type: "update",
                                newValue: e
                            });
                            if (!n) return Ye.UNCHANGED;
                            e = n.newValue;
                        }
                        return e = this.enhancer(e, this.value, this.name), this.equals(this.value, e) ? Ye.UNCHANGED : e;
                    }, n.prototype.setNewValue = function(e) {
                        var n = this.value;
                        this.value = e, this.reportChanged(), ut(this) && ct(this, {
                            type: "update",
                            object: this,
                            newValue: e,
                            oldValue: n
                        });
                    }, n.prototype.get = function() {
                        return this.reportObserved(), this.dehanceValue(this.value);
                    }, n.prototype.intercept = function(e) {
                        return Mt(this, e);
                    }, n.prototype.observe = function(e, n) {
                        return n && e({
                            object: this,
                            type: "update",
                            newValue: this.value,
                            oldValue: void 0
                        }), st(this, e);
                    }, n.prototype.toJSON = function() {
                        return this.get();
                    }, n.prototype.toString = function() {
                        return this.name + "[" + this.value + "]";
                    }, n.prototype.valueOf = function() {
                        return f(this.get());
                    }, n.prototype[Symbol.toPrimitive] = function() {
                        return this.valueOf();
                    }, n;
                }(p), Le = D("ObservableValue", xe), he = function() {
                    function e(e) {
                        this.dependenciesState = K.NOT_TRACKING, this.observing = [], this.newObserving = null, this.isBeingObserved = !1, this.isPendingUnobservation = !1, this.observers = new Set, this.diffValue = 0, this.runId = 0, this.lastAccessedBy = 0, this.lowestObserverState = K.UP_TO_DATE, this.unboundDepsCount = 0, this.__mapid = "#" + i(), this.value = new re(null), this.isComputing = !1, this.isRunningSetter = !1, this.isTracing = $.NONE, a(e.get, "missing option for computed: get"), this.derivation = e.get, this.name = e.name || "ComputedValue@" + i(), e.set && (this.setter = fe(this.name + "-setter", e.set)), this.equals = e.equals || (e.compareStructural || e.struct ? I.structural : I.default), this.scope = e.context, this.requiresReaction = !!e.requiresReaction, this.keepAlive = !!e.keepAlive;
                    }
                    return e.prototype.onBecomeStale = function() {
                        !function(e) {
                            if (e.lowestObserverState !== K.UP_TO_DATE) return;
                            e.lowestObserverState = K.POSSIBLY_STALE, e.observers.forEach(function(n) {
                                n.dependenciesState === K.UP_TO_DATE && (n.dependenciesState = K.POSSIBLY_STALE, n.isTracing !== $.NONE && We(n, e), n.onBecomeStale());
                            });
                        }(this);
                    }, e.prototype.onBecomeObserved = function() {
                        this.onBecomeObservedListeners && this.onBecomeObservedListeners.forEach(function(e) {
                            return e();
                        });
                    }, e.prototype.onBecomeUnobserved = function() {
                        this.onBecomeUnobservedListeners && this.onBecomeUnobservedListeners.forEach(function(e) {
                            return e();
                        });
                    }, e.prototype.get = function() {
                        this.isComputing && M("Cycle detected in computation " + this.name + ": " + this.derivation), 0 !== Ye.inBatch || 0 !== this.observers.size || this.keepAlive ? (He(this), ie(this) && this.trackAndCompute() && function(e) {
                            if (e.lowestObserverState === K.STALE) return;
                            e.lowestObserverState = K.STALE, e.observers.forEach(function(n) {
                                n.dependenciesState === K.POSSIBLY_STALE ? n.dependenciesState = K.STALE : n.dependenciesState === K.UP_TO_DATE && (e.lowestObserverState = K.UP_TO_DATE);
                            });
                        }(this)) : ie(this) && (this.warnAboutUntrackedRead(), Ze(), this.value = this.computeValue(!1), Ge());
                        var e = this.value;
                        if (oe(e)) throw e.cause;
                        return e;
                    }, e.prototype.peek = function() {
                        var e = this.computeValue(!1);
                        if (oe(e)) throw e.cause;
                        return e;
                    }, e.prototype.set = function(e) {
                        if (this.setter) {
                            a(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"), this.isRunningSetter = !0;
                            try {
                                this.setter.call(this.scope, e);
                            } finally{
                                this.isRunningSetter = !1;
                            }
                        } else a(!1, !1);
                    }, e.prototype.trackAndCompute = function() {
                        var e = this.value, n = this.dependenciesState === K.NOT_TRACKING, t = this.computeValue(!0), r = n || oe(e) || oe(t) || !this.equals(e, t);
                        return r && (this.value = t), r;
                    }, e.prototype.computeValue = function(e) {
                        var n;
                        if (this.isComputing = !0, Ye.computationDepth++, e) n = ue(this, this.derivation, this.scope);
                        else if (!0 === Ye.disableErrorBoundaries) n = this.derivation.call(this.scope);
                        else try {
                            n = this.derivation.call(this.scope);
                        } catch (e) {
                            n = new re(e);
                        }
                        return Ye.computationDepth--, this.isComputing = !1, n;
                    }, e.prototype.suspend = function() {
                        this.keepAlive || (se(this), this.value = void 0);
                    }, e.prototype.observe = function(e, n) {
                        var t = this, r = !0, o = void 0;
                        return sn(function() {
                            var i = t.get();
                            if (!r || n) {
                                var M = le();
                                e({
                                    type: "update",
                                    object: t,
                                    newValue: i,
                                    oldValue: o
                                }), Ne(M);
                            }
                            r = !1, o = i;
                        });
                    }, e.prototype.warnAboutUntrackedRead = function() {}, e.prototype.toJSON = function() {
                        return this.get();
                    }, e.prototype.toString = function() {
                        return this.name + "[" + this.derivation.toString() + "]";
                    }, e.prototype.valueOf = function() {
                        return f(this.get());
                    }, e.prototype[Symbol.toPrimitive] = function() {
                        return this.valueOf();
                    }, e;
                }(), ve = D("ComputedValue", he), me = [
                    "mobxGuid",
                    "spyListeners",
                    "enforceActions",
                    "computedRequiresReaction",
                    "reactionRequiresObservable",
                    "observableRequiresReaction",
                    "allowStateReads",
                    "disableErrorBoundaries",
                    "runId",
                    "UNCHANGED"
                ], be = function() {
                    this.version = 5, this.UNCHANGED = {}, this.trackingDerivation = null, this.computationDepth = 0, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !0, this.allowStateReads = !0, this.enforceActions = !1, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.computedConfigurable = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1;
                }, ke = {};
                function Ce() {
                    return "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : ke;
                }
                var Se = !0, Ue = !1, Ye = function() {
                    var e = Ce();
                    return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Se = !1), e.__mobxGlobals && e.__mobxGlobals.version !== (new be).version && (Se = !1), Se ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = new be) : (setTimeout(function() {
                        Ue || M("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
                    }, 1), new be);
                }();
                function Qe() {
                    return Ye;
                }
                function _e() {
                    var e = new be;
                    for(var n in e)-1 === me.indexOf(n) && (Ye[n] = e[n]);
                    Ye.allowStateChanges = !Ye.enforceActions;
                }
                function Be(e, n) {
                    e.observers.add(n), e.lowestObserverState > n.dependenciesState && (e.lowestObserverState = n.dependenciesState);
                }
                function Pe(e, n) {
                    e.observers.delete(n), 0 === e.observers.size && Re(e);
                }
                function Re(e) {
                    !1 === e.isPendingUnobservation && (e.isPendingUnobservation = !0, Ye.pendingUnobservations.push(e));
                }
                function Ze() {
                    Ye.inBatch++;
                }
                function Ge() {
                    if (0 == --Ye.inBatch) {
                        qe();
                        for(var e = Ye.pendingUnobservations, n = 0; n < e.length; n++){
                            var t = e[n];
                            t.isPendingUnobservation = !1, 0 === t.observers.size && (t.isBeingObserved && (t.isBeingObserved = !1, t.onBecomeUnobserved()), t instanceof he && t.suspend());
                        }
                        Ye.pendingUnobservations = [];
                    }
                }
                function He(e) {
                    var n = Ye.trackingDerivation;
                    return null !== n ? (n.runId !== e.lastAccessedBy && (e.lastAccessedBy = n.runId, n.newObserving[n.unboundDepsCount++] = e, e.isBeingObserved || (e.isBeingObserved = !0, e.onBecomeObserved())), !0) : (0 === e.observers.size && Ye.inBatch > 0 && Re(e), !1);
                }
                function We(e, n) {
                    if (console.log("[mobx.trace] '" + e.name + "' is invalidated due to a change in: '" + n.name + "'"), e.isTracing === $.BREAK) {
                        var t = [];
                        !function e(n, t, r) {
                            if (t.length >= 1e3) return void t.push("(and many more)");
                            t.push("" + new Array(r).join("	") + n.name), n.dependencies && n.dependencies.forEach(function(n) {
                                return e(n, t, r + 1);
                            });
                        }(dn(e), t, 1), new Function("debugger;\n/*\nTracing '" + e.name + "'\n\nYou are entering this break point because derivation '" + e.name + "' is being traced and '" + n.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (e instanceof he ? e.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + t.join("\n") + "\n*/\n    ")();
                    }
                }
                var Ve = function() {
                    function e(e, n, t, r) {
                        void 0 === e && (e = "Reaction@" + i()), void 0 === r && (r = !1), this.name = e, this.onInvalidate = n, this.errorHandler = t, this.requiresObservable = r, this.observing = [], this.newObserving = [], this.dependenciesState = K.NOT_TRACKING, this.diffValue = 0, this.runId = 0, this.unboundDepsCount = 0, this.__mapid = "#" + i(), this.isDisposed = !1, this._isScheduled = !1, this._isTrackPending = !1, this._isRunning = !1, this.isTracing = $.NONE;
                    }
                    return e.prototype.onBecomeStale = function() {
                        this.schedule();
                    }, e.prototype.schedule = function() {
                        this._isScheduled || (this._isScheduled = !0, Ye.pendingReactions.push(this), qe());
                    }, e.prototype.isScheduled = function() {
                        return this._isScheduled;
                    }, e.prototype.runReaction = function() {
                        if (!this.isDisposed) {
                            if (Ze(), this._isScheduled = !1, ie(this)) {
                                this._isTrackPending = !0;
                                try {
                                    this.onInvalidate(), this._isTrackPending;
                                } catch (e) {
                                    this.reportExceptionInDerivation(e);
                                }
                            }
                            Ge();
                        }
                    }, e.prototype.track = function(e) {
                        if (!this.isDisposed) {
                            Ze();
                            this._isRunning = !0;
                            var n = ue(this, e, void 0);
                            this._isRunning = !1, this._isTrackPending = !1, this.isDisposed && se(this), oe(n) && this.reportExceptionInDerivation(n.cause), Ge();
                        }
                    }, e.prototype.reportExceptionInDerivation = function(e) {
                        var n = this;
                        if (this.errorHandler) this.errorHandler(e, this);
                        else {
                            if (Ye.disableErrorBoundaries) throw e;
                            var t = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
                            Ye.suppressReactionErrors ? console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)") : console.error(t, e), Ye.globalReactionErrorHandlers.forEach(function(t) {
                                return t(e, n);
                            });
                        }
                    }, e.prototype.dispose = function() {
                        this.isDisposed || (this.isDisposed = !0, this._isRunning || (Ze(), se(this), Ge()));
                    }, e.prototype.getDisposer = function() {
                        var e = this.dispose.bind(this);
                        return e[d] = this, e;
                    }, e.prototype.toString = function() {
                        return "Reaction[" + this.name + "]";
                    }, e.prototype.trace = function(e) {
                        void 0 === e && (e = !1), Fn(this, e);
                    }, e;
                }();
                function Je(e) {
                    return Ye.globalReactionErrorHandlers.push(e), function() {
                        var n = Ye.globalReactionErrorHandlers.indexOf(e);
                        n >= 0 && Ye.globalReactionErrorHandlers.splice(n, 1);
                    };
                }
                var Fe = function(e) {
                    return e();
                };
                function qe() {
                    Ye.inBatch > 0 || Ye.isRunningReactions || Fe(Xe);
                }
                function Xe() {
                    Ye.isRunningReactions = !0;
                    for(var e = Ye.pendingReactions, n = 0; e.length > 0;){
                        100 == ++n && (console.error("Reaction doesn't converge to a stable state after 100 iterations. Probably there is a cycle in the reactive function: " + e[0]), e.splice(0));
                        for(var t = e.splice(0), r = 0, o = t.length; r < o; r++)t[r].runReaction();
                    }
                    Ye.isRunningReactions = !1;
                }
                var Ke = D("Reaction", Ve);
                function $e(e) {
                    var n = Fe;
                    Fe = function(t) {
                        return e(function() {
                            return n(t);
                        });
                    };
                }
                function en(e) {
                    return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
                }
                function nn() {
                    M(!1);
                }
                function tn(e) {
                    return function(n, t, r) {
                        if (r) {
                            if (r.value) return {
                                value: fe(e, r.value),
                                enumerable: !1,
                                configurable: !0,
                                writable: !0
                            };
                            var o = r.initializer;
                            return {
                                enumerable: !1,
                                configurable: !0,
                                writable: !0,
                                initializer: function() {
                                    return fe(e, o.call(this));
                                }
                            };
                        }
                        return rn(e).apply(this, arguments);
                    };
                }
                function rn(e) {
                    return function(n, t, r) {
                        Object.defineProperty(n, t, {
                            configurable: !0,
                            enumerable: !1,
                            get: function() {},
                            set: function(n) {
                                N(this, t, on(e, n));
                            }
                        });
                    };
                }
                var on = function(e, n, t, r) {
                    return 1 === arguments.length && "function" == typeof e ? fe(e.name || "<unnamed action>", e) : 2 === arguments.length && "function" == typeof n ? fe(e, n) : 1 === arguments.length && "string" == typeof e ? tn(e) : !0 !== r ? tn(n).apply(null, arguments) : void N(e, n, fe(e.name || n, t.value, this));
                };
                function Mn(e, n) {
                    return Ae("string" == typeof e ? e : e.name || "<unnamed action>", "function" == typeof e ? e : n, this, void 0);
                }
                function an(e) {
                    return "function" == typeof e && !0 === e.isMobxAction;
                }
                function un(e, n, t) {
                    N(e, n, fe(n, t.bind(e)));
                }
                function sn(e, n) {
                    void 0 === n && (n = o);
                    var t, r = n && n.name || e.name || "Autorun@" + i();
                    if (!n.scheduler && !n.delay) t = new Ve(r, function() {
                        this.track(u);
                    }, n.onError, n.requiresObservable);
                    else {
                        var M = ln(n), a = !1;
                        t = new Ve(r, function() {
                            a || (a = !0, M(function() {
                                a = !1, t.isDisposed || t.track(u);
                            }));
                        }, n.onError, n.requiresObservable);
                    }
                    function u() {
                        e(t);
                    }
                    return t.schedule(), t.getDisposer();
                }
                on.bound = function(e, n, t, r) {
                    return !0 === r ? (un(e, n, t.value), null) : t ? {
                        configurable: !0,
                        enumerable: !1,
                        get: function() {
                            return un(this, n, t.value || t.initializer.call(this)), this[n];
                        },
                        set: nn
                    } : {
                        enumerable: !1,
                        configurable: !0,
                        set: function(e) {
                            un(this, n, e);
                        },
                        get: function() {}
                    };
                };
                var cn = function(e) {
                    return e();
                };
                function ln(e) {
                    return e.scheduler ? e.scheduler : e.delay ? function(n) {
                        return setTimeout(n, e.delay);
                    } : cn;
                }
                function Nn(e, n, t) {
                    void 0 === t && (t = o);
                    var r, M, a, u = t.name || "Reaction@" + i(), s = on(u, t.onError ? (r = t.onError, M = n, function() {
                        try {
                            return M.apply(this, arguments);
                        } catch (e) {
                            r.call(this, e);
                        }
                    }) : n), c = !t.scheduler && !t.delay, l = ln(t), N = !0, D = !1, g = t.compareStructural ? I.structural : t.equals || I.default, y = new Ve(u, function() {
                        N || c ? j() : D || (D = !0, l(j));
                    }, t.onError, t.requiresObservable);
                    function j() {
                        if (D = !1, !y.isDisposed) {
                            var n = !1;
                            y.track(function() {
                                var t = e(y);
                                n = N || !g(a, t), a = t;
                            }), N && t.fireImmediately && s(a, y), N || !0 !== n || s(a, y), N && (N = !1);
                        }
                    }
                    return y.schedule(), y.getDisposer();
                }
                function Dn(e, n, t) {
                    return yn("onBecomeObserved", e, n, t);
                }
                function gn(e, n, t) {
                    return yn("onBecomeUnobserved", e, n, t);
                }
                function yn(e, n, t, r) {
                    var o = "function" == typeof r ? bt(n, t) : bt(n), i = "function" == typeof r ? r : t, a = e + "Listeners";
                    return o[a] ? o[a].add(i) : o[a] = new Set([
                        i
                    ]), "function" != typeof o[e] ? M(!1) : function() {
                        var e = o[a];
                        e && (e.delete(i), 0 === e.size && delete o[a]);
                    };
                }
                function jn(e) {
                    var n = e.enforceActions, t = e.computedRequiresReaction, r = e.computedConfigurable, o = e.disableErrorBoundaries, i = e.reactionScheduler, a = e.reactionRequiresObservable, u = e.observableRequiresReaction;
                    if (!0 === e.isolateGlobalState && ((Ye.pendingReactions.length || Ye.inBatch || Ye.isRunningReactions) && M("isolateGlobalState should be called before MobX is running any reactions"), Ue = !0, Se && (0 == --Ce().__mobxInstanceCount && (Ce().__mobxGlobals = void 0), Ye = new be)), void 0 !== n) {
                        var s = void 0;
                        switch(n){
                            case !0:
                            case "observed":
                                s = !0;
                                break;
                            case !1:
                            case "never":
                                s = !1;
                                break;
                            case "strict":
                            case "always":
                                s = "strict";
                                break;
                            default:
                                M("Invalid value for 'enforceActions': '" + n + "', expected 'never', 'always' or 'observed'");
                        }
                        Ye.enforceActions = s, Ye.allowStateChanges = !0 !== s && "strict" !== s;
                    }
                    void 0 !== t && (Ye.computedRequiresReaction = !!t), void 0 !== a && (Ye.reactionRequiresObservable = !!a), void 0 !== u && (Ye.observableRequiresReaction = !!u, Ye.allowStateReads = !Ye.observableRequiresReaction), void 0 !== r && (Ye.computedConfigurable = !!r), void 0 !== o && (!0 === o && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), Ye.disableErrorBoundaries = !!o), i && $e(i);
                }
                function zn(e, n) {
                    var t = "function" == typeof e ? e.prototype : e, r = function(e) {
                        var r = n[e];
                        Array.isArray(r) || (r = [
                            r
                        ]);
                        var o = Object.getOwnPropertyDescriptor(t, e), i = r.reduce(function(n, r) {
                            return r(t, e, n);
                        }, o);
                        i && Object.defineProperty(t, e, i);
                    };
                    for(var o in n)r(o);
                    return e;
                }
                function Tn(e, n, t, r) {
                    var o = fn(r = Z(r));
                    return U(e), Ot(e, r.name, o.enhancer), n && An(e, n, t, o), e;
                }
                function fn(e) {
                    return e.defaultDecorator || (!1 === e.deep ? W : G);
                }
                function An(e, n, t, r) {
                    var o, i;
                    Ze();
                    try {
                        var M = A(n);
                        try {
                            for(var a = L(M), u = a.next(); !u.done; u = a.next()){
                                var s = u.value, c = Object.getOwnPropertyDescriptor(n, s);
                                var l = (t && s in t ? t[s] : c.get ? ee : r)(e, s, c, !0);
                                l && Object.defineProperty(e, s, l);
                            }
                        } catch (e) {
                            o = {
                                error: e
                            };
                        } finally{
                            try {
                                u && !u.done && (i = a.return) && i.call(a);
                            } finally{
                                if (o) throw o.error;
                            }
                        }
                    } finally{
                        Ge();
                    }
                }
                function dn(e, n) {
                    return pn(bt(e, n));
                }
                function pn(e) {
                    var n, t, r = {
                        name: e.name
                    };
                    return e.observing && e.observing.length > 0 && (r.dependencies = (n = e.observing, t = [], n.forEach(function(e) {
                        -1 === t.indexOf(e) && t.push(e);
                    }), t).map(pn)), r;
                }
                function En(e, n) {
                    return wn(bt(e, n));
                }
                function wn(e) {
                    var n = {
                        name: e.name
                    };
                    return function(e) {
                        return e.observers && e.observers.size > 0;
                    }(e) && (n.observers = Array.from(function(e) {
                        return e.observers;
                    }(e)).map(wn)), n;
                }
                var In = 0;
                function On() {
                    this.message = "FLOW_CANCELLED";
                }
                function xn(e) {
                    return e instanceof On;
                }
                function Ln(e) {
                    1 !== arguments.length && M("Flow expects 1 argument and cannot be used as decorator");
                    var n = e.name || "<unnamed flow>";
                    return function() {
                        var t, r = this, o = arguments, i = ++In, M = on(n + " - runid: " + i + " - init", e).apply(r, o), a = void 0, u = new Promise(function(e, r) {
                            var o = 0;
                            function u(e) {
                                var t;
                                a = void 0;
                                try {
                                    t = on(n + " - runid: " + i + " - yield " + o++, M.next).call(M, e);
                                } catch (e) {
                                    return r(e);
                                }
                                c(t);
                            }
                            function s(e) {
                                var t;
                                a = void 0;
                                try {
                                    t = on(n + " - runid: " + i + " - yield " + o++, M.throw).call(M, e);
                                } catch (e) {
                                    return r(e);
                                }
                                c(t);
                            }
                            function c(n) {
                                if (!n || "function" != typeof n.then) return n.done ? e(n.value) : (a = Promise.resolve(n.value)).then(u, s);
                                n.then(c, r);
                            }
                            t = r, u(void 0);
                        });
                        return u.cancel = on(n + " - runid: " + i + " - cancel", function() {
                            try {
                                a && hn(a);
                                var e = M.return(void 0), n = Promise.resolve(e.value);
                                n.then(s, s), hn(n), t(new On);
                            } catch (e) {
                                t(e);
                            }
                        }), u;
                    };
                }
                function hn(e) {
                    "function" == typeof e.cancel && e.cancel();
                }
                function vn(e, n, t) {
                    var r;
                    if (dt(e) || zt(e) || Le(e)) r = kt(e);
                    else {
                        if (!mt(e)) return M(!1);
                        if ("string" != typeof n) return M(!1);
                        r = kt(e, n);
                    }
                    return void 0 !== r.dehancer ? M(!1) : (r.dehancer = "function" == typeof n ? n : t, function() {
                        r.dehancer = void 0;
                    });
                }
                function mn(e, n, t) {
                    return "function" == typeof t ? function(e, n, t) {
                        return kt(e, n).intercept(t);
                    }(e, n, t) : function(e, n) {
                        return kt(e).intercept(n);
                    }(e, n);
                }
                function bn(e, n) {
                    if (null == e) return !1;
                    if (void 0 !== n) {
                        if (!1 === mt(e)) return !1;
                        if (!e[d].values.has(n)) return !1;
                        var t = bt(e, n);
                        return ve(t);
                    }
                    return ve(e);
                }
                function kn(e) {
                    return arguments.length > 1 ? M(!1) : bn(e);
                }
                function Cn(e, n) {
                    return "string" != typeof n ? M(!1) : bn(e, n);
                }
                function Sn(e, n) {
                    return null != e && (void 0 !== n ? !!mt(e) && e[d].values.has(n) : mt(e) || !!e[d] || E(e) || Ke(e) || ve(e));
                }
                function Un(e) {
                    return 1 !== arguments.length && M(!1), Sn(e);
                }
                function Yn(e, n) {
                    return "string" != typeof n ? M(!1) : Sn(e, n);
                }
                function Qn(e) {
                    return mt(e) ? e[d].getKeys() : dt(e) || wt(e) ? Array.from(e.keys()) : zt(e) ? e.map(function(e, n) {
                        return n;
                    }) : M(!1);
                }
                function _n(e) {
                    return mt(e) ? Qn(e).map(function(n) {
                        return e[n];
                    }) : dt(e) ? Qn(e).map(function(n) {
                        return e.get(n);
                    }) : wt(e) ? Array.from(e.values()) : zt(e) ? e.slice() : M(!1);
                }
                function Bn(e) {
                    return mt(e) ? Qn(e).map(function(n) {
                        return [
                            n,
                            e[n]
                        ];
                    }) : dt(e) ? Qn(e).map(function(n) {
                        return [
                            n,
                            e.get(n)
                        ];
                    }) : wt(e) ? Array.from(e.entries()) : zt(e) ? e.map(function(e, n) {
                        return [
                            n,
                            e
                        ];
                    }) : M(!1);
                }
                function Pn(e, n, t) {
                    if (2 !== arguments.length || wt(e)) {
                        if (mt(e)) {
                            var r = e[d], o = r.values.get(n);
                            o ? r.write(n, t) : r.addObservableProp(n, t, r.defaultEnhancer);
                        } else if (dt(e)) e.set(n, t);
                        else if (wt(e)) e.add(n);
                        else {
                            if (!zt(e)) return M(!1);
                            "number" != typeof n && (n = parseInt(n, 10)), a(n >= 0, "Not a valid index: '" + n + "'"), Ze(), n >= e.length && (e.length = n + 1), e[n] = t, Ge();
                        }
                    } else {
                        Ze();
                        var i = n;
                        try {
                            for(var u in i)Pn(e, u, i[u]);
                        } finally{
                            Ge();
                        }
                    }
                }
                function Rn(e, n) {
                    if (mt(e)) e[d].remove(n);
                    else if (dt(e)) e.delete(n);
                    else if (wt(e)) e.delete(n);
                    else {
                        if (!zt(e)) return M(!1);
                        "number" != typeof n && (n = parseInt(n, 10)), a(n >= 0, "Not a valid index: '" + n + "'"), e.splice(n, 1);
                    }
                }
                function Zn(e, n) {
                    return mt(e) ? kt(e).has(n) : dt(e) || wt(e) ? e.has(n) : zt(e) ? n >= 0 && n < e.length : M(!1);
                }
                function Gn(e, n) {
                    if (Zn(e, n)) return mt(e) ? e[n] : dt(e) ? e.get(n) : zt(e) ? e[n] : M(!1);
                }
                function Hn(e, n, t, r) {
                    return "function" == typeof t ? function(e, n, t, r) {
                        return kt(e, n).observe(t, r);
                    }(e, n, t, r) : function(e, n, t) {
                        return kt(e).observe(n, t);
                    }(e, n, t);
                }
                On.prototype = Object.create(Error.prototype);
                var Wn = {
                    detectCycles: !0,
                    exportMapsAsObjects: !0,
                    recurseEverything: !1
                };
                function Vn(e, n, t, r) {
                    return r.detectCycles && e.set(n, t), t;
                }
                function Jn(e, n) {
                    var t;
                    return "boolean" == typeof n && (n = {
                        detectCycles: n
                    }), n || (n = Wn), n.detectCycles = void 0 === n.detectCycles ? !0 === n.recurseEverything : !0 === n.detectCycles, n.detectCycles && (t = new Map), function e(n, t, r) {
                        if (!t.recurseEverything && !Un(n)) return n;
                        if ("object" != typeof n) return n;
                        if (null === n) return null;
                        if (n instanceof Date) return n;
                        if (Le(n)) return e(n.get(), t, r);
                        if (Un(n) && Qn(n), !0 === t.detectCycles && null !== n && r.has(n)) return r.get(n);
                        if (zt(n) || Array.isArray(n)) {
                            var o = Vn(r, n, [], t), i = n.map(function(n) {
                                return e(n, t, r);
                            });
                            o.length = i.length;
                            for(var M = 0, a = i.length; M < a; M++)o[M] = i[M];
                            return o;
                        }
                        if (wt(n) || Object.getPrototypeOf(n) === Set.prototype) {
                            if (!1 === t.exportMapsAsObjects) {
                                var u = Vn(r, n, new Set, t);
                                return n.forEach(function(n) {
                                    u.add(e(n, t, r));
                                }), u;
                            }
                            var s = Vn(r, n, [], t);
                            return n.forEach(function(n) {
                                s.push(e(n, t, r));
                            }), s;
                        }
                        if (dt(n) || Object.getPrototypeOf(n) === Map.prototype) {
                            if (!1 === t.exportMapsAsObjects) {
                                var c = Vn(r, n, new Map, t);
                                return n.forEach(function(n, o) {
                                    c.set(o, e(n, t, r));
                                }), c;
                            }
                            var l = Vn(r, n, {}, t);
                            return n.forEach(function(n, o) {
                                l[o] = e(n, t, r);
                            }), l;
                        }
                        var N = Vn(r, n, {}, t);
                        return z(n).forEach(function(o) {
                            N[o] = e(n[o], t, r);
                        }), N;
                    }(e, n, t);
                }
                function Fn() {
                    for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
                    var t = !1;
                    "boolean" == typeof e[e.length - 1] && (t = e.pop());
                    var r = qn(e);
                    if (!r) return M(!1);
                    r.isTracing === $.NONE && console.log("[mobx.trace] '" + r.name + "' tracing enabled"), r.isTracing = t ? $.BREAK : $.LOG;
                }
                function qn(e) {
                    switch(e.length){
                        case 0:
                            return Ye.trackingDerivation;
                        case 1:
                            return bt(e[0]);
                        case 2:
                            return bt(e[0], e[1]);
                    }
                }
                function Xn(e, n) {
                    void 0 === n && (n = void 0), Ze();
                    try {
                        return e.apply(n);
                    } finally{
                        Ge();
                    }
                }
                function Kn(e, n, t) {
                    return 1 === arguments.length || n && "object" == typeof n ? et(e, n) : $n(e, n, t || {});
                }
                function $n(e, n, t) {
                    var r;
                    "number" == typeof t.timeout && (r = setTimeout(function() {
                        if (!M[d].isDisposed) {
                            M();
                            var e = new Error("WHEN_TIMEOUT");
                            if (!t.onError) throw e;
                            t.onError(e);
                        }
                    }, t.timeout)), t.name = t.name || "When@" + i();
                    var o = fe(t.name + "-effect", n), M = sn(function(n) {
                        e() && (n.dispose(), r && clearTimeout(r), o());
                    }, t);
                    return M;
                }
                function et(e, n) {
                    var t;
                    var r = new Promise(function(r, o) {
                        var i = $n(e, r, x(x({}, n), {
                            onError: o
                        }));
                        t = function() {
                            i(), o("WHEN_CANCELLED");
                        };
                    });
                    return r.cancel = t, r;
                }
                function nt(e) {
                    return e[d];
                }
                function tt(e) {
                    return "string" == typeof e || "number" == typeof e || "symbol" == typeof e;
                }
                var rt = {
                    has: function(e, n) {
                        if (n === d || "constructor" === n || n === m) return !0;
                        var t = nt(e);
                        return tt(n) ? t.has(n) : n in e;
                    },
                    get: function(e, n) {
                        if (n === d || "constructor" === n || n === m) return e[n];
                        var t = nt(e), r = t.values.get(n);
                        if (r instanceof p) {
                            var o = r.get();
                            return void 0 === o && t.has(n), o;
                        }
                        return tt(n) && t.has(n), e[n];
                    },
                    set: function(e, n, t) {
                        return !!tt(n) && (Pn(e, n, t), !0);
                    },
                    deleteProperty: function(e, n) {
                        return !!tt(n) && (nt(e).remove(n), !0);
                    },
                    ownKeys: function(e) {
                        return nt(e).keysAtom.reportObserved(), Reflect.ownKeys(e);
                    },
                    preventExtensions: function(e) {
                        return M("Dynamic observable objects cannot be frozen"), !1;
                    }
                };
                function ot(e) {
                    var n = new Proxy(e, rt);
                    return e[d].proxy = n, n;
                }
                function it(e) {
                    return void 0 !== e.interceptors && e.interceptors.length > 0;
                }
                function Mt(e, n) {
                    var t = e.interceptors || (e.interceptors = []);
                    return t.push(n), u(function() {
                        var e = t.indexOf(n);
                        -1 !== e && t.splice(e, 1);
                    });
                }
                function at(e, n) {
                    var t = le();
                    try {
                        for(var r = v(e.interceptors || []), o = 0, i = r.length; o < i && (a(!(n = r[o](n)) || n.type, "Intercept handlers should return nothing or a change object"), n); o++);
                        return n;
                    } finally{
                        Ne(t);
                    }
                }
                function ut(e) {
                    return void 0 !== e.changeListeners && e.changeListeners.length > 0;
                }
                function st(e, n) {
                    var t = e.changeListeners || (e.changeListeners = []);
                    return t.push(n), u(function() {
                        var e = t.indexOf(n);
                        -1 !== e && t.splice(e, 1);
                    });
                }
                function ct(e, n) {
                    var t = le(), r = e.changeListeners;
                    if (r) {
                        for(var o = 0, i = (r = r.slice()).length; o < i; o++)r[o](n);
                        Ne(t);
                    }
                }
                var lt = {
                    get: function(e, n) {
                        return n === d ? e[d] : "length" === n ? e[d].getArrayLength() : "number" == typeof n ? gt.get.call(e, n) : "string" != typeof n || isNaN(n) ? gt.hasOwnProperty(n) ? gt[n] : e[n] : gt.get.call(e, parseInt(n));
                    },
                    set: function(e, n, t) {
                        return "length" === n && e[d].setArrayLength(t), "number" == typeof n && gt.set.call(e, n, t), "symbol" == typeof n || isNaN(n) ? e[n] = t : gt.set.call(e, parseInt(n), t), !0;
                    },
                    preventExtensions: function(e) {
                        return M("Observable arrays cannot be frozen"), !1;
                    }
                };
                function Nt(e, n, t, r) {
                    void 0 === t && (t = "ObservableArray@" + i()), void 0 === r && (r = !1);
                    var o, M, a, u = new Dt(t, n, r);
                    o = u.values, M = d, a = u, Object.defineProperty(o, M, {
                        enumerable: !1,
                        writable: !1,
                        configurable: !0,
                        value: a
                    });
                    var s = new Proxy(u.values, lt);
                    if (u.proxy = s, e && e.length) {
                        var c = we(!0);
                        u.spliceWithArray(0, 0, e), Ie(c);
                    }
                    return s;
                }
                var Dt = function() {
                    function e(e, n, t) {
                        this.owned = t, this.values = [], this.proxy = void 0, this.lastKnownLength = 0, this.atom = new p(e || "ObservableArray@" + i()), this.enhancer = function(t, r) {
                            return n(t, r, e + "[..]");
                        };
                    }
                    return e.prototype.dehanceValue = function(e) {
                        return void 0 !== this.dehancer ? this.dehancer(e) : e;
                    }, e.prototype.dehanceValues = function(e) {
                        return void 0 !== this.dehancer && e.length > 0 ? e.map(this.dehancer) : e;
                    }, e.prototype.intercept = function(e) {
                        return Mt(this, e);
                    }, e.prototype.observe = function(e, n) {
                        return void 0 === n && (n = !1), n && e({
                            object: this.proxy,
                            type: "splice",
                            index: 0,
                            added: this.values.slice(),
                            addedCount: this.values.length,
                            removed: [],
                            removedCount: 0
                        }), st(this, e);
                    }, e.prototype.getArrayLength = function() {
                        return this.atom.reportObserved(), this.values.length;
                    }, e.prototype.setArrayLength = function(e) {
                        if ("number" != typeof e || e < 0) throw new Error("[mobx.array] Out of range: " + e);
                        var n = this.values.length;
                        if (e !== n) {
                            if (e > n) {
                                for(var t = new Array(e - n), r = 0; r < e - n; r++)t[r] = void 0;
                                this.spliceWithArray(n, 0, t);
                            } else this.spliceWithArray(e, n - e);
                        }
                    }, e.prototype.updateArrayLength = function(e, n) {
                        if (e !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
                        this.lastKnownLength += n;
                    }, e.prototype.spliceWithArray = function(e, n, t) {
                        var o = this;
                        ae(this.atom);
                        var i = this.values.length;
                        if (void 0 === e ? e = 0 : e > i ? e = i : e < 0 && (e = Math.max(0, i + e)), n = 1 === arguments.length ? i - e : null == n ? 0 : Math.max(0, Math.min(n, i - e)), void 0 === t && (t = r), it(this)) {
                            var M = at(this, {
                                object: this.proxy,
                                type: "splice",
                                index: e,
                                removedCount: n,
                                added: t
                            });
                            if (!M) return r;
                            n = M.removedCount, t = M.added;
                        }
                        t = 0 === t.length ? t : t.map(function(e) {
                            return o.enhancer(e, void 0);
                        });
                        var a = this.spliceItemsIntoValues(e, n, t);
                        return 0 === n && 0 === t.length || this.notifyArraySplice(e, t, a), this.dehanceValues(a);
                    }, e.prototype.spliceItemsIntoValues = function(e, n, t) {
                        var r;
                        if (t.length < 1e4) return (r = this.values).splice.apply(r, v([
                            e,
                            n
                        ], t));
                        var o = this.values.slice(e, e + n);
                        return this.values = this.values.slice(0, e).concat(t, this.values.slice(e + n)), o;
                    }, e.prototype.notifyArrayChildUpdate = function(e, n, t) {
                        var r = !this.owned && !1, o = ut(this), i = o || r ? {
                            object: this.proxy,
                            type: "update",
                            index: e,
                            newValue: n,
                            oldValue: t
                        } : null;
                        this.atom.reportChanged(), o && ct(this, i);
                    }, e.prototype.notifyArraySplice = function(e, n, t) {
                        var r = !this.owned && !1, o = ut(this), i = o || r ? {
                            object: this.proxy,
                            type: "splice",
                            index: e,
                            removed: t,
                            added: n,
                            removedCount: t.length,
                            addedCount: n.length
                        } : null;
                        this.atom.reportChanged(), o && ct(this, i);
                    }, e;
                }(), gt = {
                    intercept: function(e) {
                        return this[d].intercept(e);
                    },
                    observe: function(e, n) {
                        return void 0 === n && (n = !1), this[d].observe(e, n);
                    },
                    clear: function() {
                        return this.splice(0);
                    },
                    replace: function(e) {
                        var n = this[d];
                        return n.spliceWithArray(0, n.values.length, e);
                    },
                    toJS: function() {
                        return this.slice();
                    },
                    toJSON: function() {
                        return this.toJS();
                    },
                    splice: function(e, n) {
                        for(var t = [], r = 2; r < arguments.length; r++)t[r - 2] = arguments[r];
                        var o = this[d];
                        switch(arguments.length){
                            case 0:
                                return [];
                            case 1:
                                return o.spliceWithArray(e);
                            case 2:
                                return o.spliceWithArray(e, n);
                        }
                        return o.spliceWithArray(e, n, t);
                    },
                    spliceWithArray: function(e, n, t) {
                        return this[d].spliceWithArray(e, n, t);
                    },
                    push: function() {
                        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
                        var t = this[d];
                        return t.spliceWithArray(t.values.length, 0, e), t.values.length;
                    },
                    pop: function() {
                        return this.splice(Math.max(this[d].values.length - 1, 0), 1)[0];
                    },
                    shift: function() {
                        return this.splice(0, 1)[0];
                    },
                    unshift: function() {
                        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
                        var t = this[d];
                        return t.spliceWithArray(0, 0, e), t.values.length;
                    },
                    reverse: function() {
                        var e = this.slice();
                        return e.reverse.apply(e, arguments);
                    },
                    sort: function(e) {
                        var n = this.slice();
                        return n.sort.apply(n, arguments);
                    },
                    remove: function(e) {
                        var n = this[d], t = n.dehanceValues(n.values).indexOf(e);
                        return t > -1 && (this.splice(t, 1), !0);
                    },
                    get: function(e) {
                        var n = this[d];
                        if (n) {
                            if (e < n.values.length) return n.atom.reportObserved(), n.dehanceValue(n.values[e]);
                            console.warn("[mobx.array] Attempt to read an array index (" + e + ") that is out of bounds (" + n.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
                        }
                    },
                    set: function(e, n) {
                        var t = this[d], r = t.values;
                        if (e < r.length) {
                            ae(t.atom);
                            var o = r[e];
                            if (it(t)) {
                                var i = at(t, {
                                    type: "update",
                                    object: t.proxy,
                                    index: e,
                                    newValue: n
                                });
                                if (!i) return;
                                n = i.newValue;
                            }
                            (n = t.enhancer(n, o)) !== o && (r[e] = n, t.notifyArrayChildUpdate(e, n, o));
                        } else {
                            if (e !== r.length) throw new Error("[mobx.array] Index out of bounds, " + e + " is larger than " + r.length);
                            t.spliceWithArray(e, 0, [
                                n
                            ]);
                        }
                    }
                };
                [
                    "concat",
                    "flat",
                    "includes",
                    "indexOf",
                    "join",
                    "lastIndexOf",
                    "slice",
                    "toString",
                    "toLocaleString"
                ].forEach(function(e) {
                    "function" == typeof Array.prototype[e] && (gt[e] = function() {
                        var n = this[d];
                        n.atom.reportObserved();
                        var t = n.dehanceValues(n.values);
                        return t[e].apply(t, arguments);
                    });
                }), [
                    "every",
                    "filter",
                    "find",
                    "findIndex",
                    "flatMap",
                    "forEach",
                    "map",
                    "some"
                ].forEach(function(e) {
                    "function" == typeof Array.prototype[e] && (gt[e] = function(n, t) {
                        var r = this, o = this[d];
                        return o.atom.reportObserved(), o.dehanceValues(o.values)[e](function(e, o) {
                            return n.call(t, e, o, r);
                        }, t);
                    });
                }), [
                    "reduce",
                    "reduceRight"
                ].forEach(function(e) {
                    gt[e] = function() {
                        var n = this, t = this[d];
                        t.atom.reportObserved();
                        var r = arguments[0];
                        return arguments[0] = function(e, o, i) {
                            return o = t.dehanceValue(o), r(e, o, i, n);
                        }, t.values[e].apply(t.values, arguments);
                    };
                });
                var yt, jt = D("ObservableArrayAdministration", Dt);
                function zt(e) {
                    return c(e) && jt(e[d]);
                }
                var Tt, ft = {}, At = function() {
                    function e(e, n, t) {
                        if (void 0 === n && (n = _), void 0 === t && (t = "ObservableMap@" + i()), this.enhancer = n, this.name = t, this[yt] = ft, this._keysAtom = w(this.name + ".keys()"), this[Symbol.toStringTag] = "Map", "function" != typeof Map) throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
                        this._data = new Map, this._hasMap = new Map, this.merge(e);
                    }
                    return e.prototype._has = function(e) {
                        return this._data.has(e);
                    }, e.prototype.has = function(e) {
                        var n = this;
                        if (!Ye.trackingDerivation) return this._has(e);
                        var t = this._hasMap.get(e);
                        if (!t) {
                            var r = t = new xe(this._has(e), B, this.name + "." + T(e) + "?", !1);
                            this._hasMap.set(e, r), gn(r, function() {
                                return n._hasMap.delete(e);
                            });
                        }
                        return t.get();
                    }, e.prototype.set = function(e, n) {
                        var t = this._has(e);
                        if (it(this)) {
                            var r = at(this, {
                                type: t ? "update" : "add",
                                object: this,
                                newValue: n,
                                name: e
                            });
                            if (!r) return this;
                            n = r.newValue;
                        }
                        return t ? this._updateValue(e, n) : this._addValue(e, n), this;
                    }, e.prototype.delete = function(e) {
                        var n = this;
                        if ((ae(this._keysAtom), it(this)) && !(r = at(this, {
                            type: "delete",
                            object: this,
                            name: e
                        }))) return !1;
                        if (this._has(e)) {
                            var t = ut(this), r = t ? {
                                type: "delete",
                                object: this,
                                oldValue: this._data.get(e).value,
                                name: e
                            } : null;
                            return Xn(function() {
                                n._keysAtom.reportChanged(), n._updateHasMapEntry(e, !1), n._data.get(e).setNewValue(void 0), n._data.delete(e);
                            }), t && ct(this, r), !0;
                        }
                        return !1;
                    }, e.prototype._updateHasMapEntry = function(e, n) {
                        var t = this._hasMap.get(e);
                        t && t.setNewValue(n);
                    }, e.prototype._updateValue = function(e, n) {
                        var t = this._data.get(e);
                        if ((n = t.prepareNewValue(n)) !== Ye.UNCHANGED) {
                            var r = ut(this), o = r ? {
                                type: "update",
                                object: this,
                                oldValue: t.value,
                                name: e,
                                newValue: n
                            } : null;
                            t.setNewValue(n), r && ct(this, o);
                        }
                    }, e.prototype._addValue = function(e, n) {
                        var t = this;
                        ae(this._keysAtom), Xn(function() {
                            var r = new xe(n, t.enhancer, t.name + "." + T(e), !1);
                            t._data.set(e, r), n = r.value, t._updateHasMapEntry(e, !0), t._keysAtom.reportChanged();
                        });
                        var r = ut(this), o = r ? {
                            type: "add",
                            object: this,
                            name: e,
                            newValue: n
                        } : null;
                        r && ct(this, o);
                    }, e.prototype.get = function(e) {
                        return this.has(e) ? this.dehanceValue(this._data.get(e).get()) : this.dehanceValue(void 0);
                    }, e.prototype.dehanceValue = function(e) {
                        return void 0 !== this.dehancer ? this.dehancer(e) : e;
                    }, e.prototype.keys = function() {
                        return this._keysAtom.reportObserved(), this._data.keys();
                    }, e.prototype.values = function() {
                        var e = this, n = this.keys();
                        return _t({
                            next: function() {
                                var t = n.next(), r = t.done, o = t.value;
                                return {
                                    done: r,
                                    value: r ? void 0 : e.get(o)
                                };
                            }
                        });
                    }, e.prototype.entries = function() {
                        var e = this, n = this.keys();
                        return _t({
                            next: function() {
                                var t = n.next(), r = t.done, o = t.value;
                                return {
                                    done: r,
                                    value: r ? void 0 : [
                                        o,
                                        e.get(o)
                                    ]
                                };
                            }
                        });
                    }, e.prototype[yt = d, Symbol.iterator] = function() {
                        return this.entries();
                    }, e.prototype.forEach = function(e, n) {
                        var t, r;
                        try {
                            for(var o = L(this), i = o.next(); !i.done; i = o.next()){
                                var M = h(i.value, 2), a = M[0], u = M[1];
                                e.call(n, u, a, this);
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                i && !i.done && (r = o.return) && r.call(o);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                    }, e.prototype.merge = function(e) {
                        var n = this;
                        return dt(e) && (e = e.toJS()), Xn(function() {
                            var t = we(!0);
                            try {
                                l(e) ? z(e).forEach(function(t) {
                                    return n.set(t, e[t]);
                                }) : Array.isArray(e) ? e.forEach(function(e) {
                                    var t = h(e, 2), r = t[0], o = t[1];
                                    return n.set(r, o);
                                }) : y(e) ? (e.constructor !== Map && M("Cannot initialize from classes that inherit from Map: " + e.constructor.name), e.forEach(function(e, t) {
                                    return n.set(t, e);
                                })) : null != e && M("Cannot initialize map from " + e);
                            } finally{
                                Ie(t);
                            }
                        }), this;
                    }, e.prototype.clear = function() {
                        var e = this;
                        Xn(function() {
                            ce(function() {
                                var n, t;
                                try {
                                    for(var r = L(e.keys()), o = r.next(); !o.done; o = r.next()){
                                        var i = o.value;
                                        e.delete(i);
                                    }
                                } catch (e) {
                                    n = {
                                        error: e
                                    };
                                } finally{
                                    try {
                                        o && !o.done && (t = r.return) && t.call(r);
                                    } finally{
                                        if (n) throw n.error;
                                    }
                                }
                            });
                        });
                    }, e.prototype.replace = function(e) {
                        var n = this;
                        return Xn(function() {
                            var t, r, o, i, a = function(e) {
                                if (y(e) || dt(e)) return e;
                                if (Array.isArray(e)) return new Map(e);
                                if (l(e)) {
                                    var n = new Map;
                                    for(var t in e)n.set(t, e[t]);
                                    return n;
                                }
                                return M("Cannot convert to map from '" + e + "'");
                            }(e), u = new Map, s = !1;
                            try {
                                for(var c = L(n._data.keys()), N = c.next(); !N.done; N = c.next()){
                                    var D = N.value;
                                    if (!a.has(D)) {
                                        if (n.delete(D)) s = !0;
                                        else {
                                            var g = n._data.get(D);
                                            u.set(D, g);
                                        }
                                    }
                                }
                            } catch (e) {
                                t = {
                                    error: e
                                };
                            } finally{
                                try {
                                    N && !N.done && (r = c.return) && r.call(c);
                                } finally{
                                    if (t) throw t.error;
                                }
                            }
                            try {
                                for(var j = L(a.entries()), z = j.next(); !z.done; z = j.next()){
                                    var T = h(z.value, 2), f = (D = T[0], g = T[1], n._data.has(D));
                                    if (n.set(D, g), n._data.has(D)) {
                                        var A = n._data.get(D);
                                        u.set(D, A), f || (s = !0);
                                    }
                                }
                            } catch (e) {
                                o = {
                                    error: e
                                };
                            } finally{
                                try {
                                    z && !z.done && (i = j.return) && i.call(j);
                                } finally{
                                    if (o) throw o.error;
                                }
                            }
                            if (!s) {
                                if (n._data.size !== u.size) n._keysAtom.reportChanged();
                                else for(var d = n._data.keys(), p = u.keys(), E = d.next(), w = p.next(); !E.done;){
                                    if (E.value !== w.value) {
                                        n._keysAtom.reportChanged();
                                        break;
                                    }
                                    E = d.next(), w = p.next();
                                }
                            }
                            n._data = u;
                        }), this;
                    }, Object.defineProperty(e.prototype, "size", {
                        get: function() {
                            return this._keysAtom.reportObserved(), this._data.size;
                        },
                        enumerable: !0,
                        configurable: !0
                    }), e.prototype.toPOJO = function() {
                        var e, n, t = {};
                        try {
                            for(var r = L(this), o = r.next(); !o.done; o = r.next()){
                                var i = h(o.value, 2), M = i[0], a = i[1];
                                t["symbol" == typeof M ? M : T(M)] = a;
                            }
                        } catch (n) {
                            e = {
                                error: n
                            };
                        } finally{
                            try {
                                o && !o.done && (n = r.return) && n.call(r);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        return t;
                    }, e.prototype.toJS = function() {
                        return new Map(this);
                    }, e.prototype.toJSON = function() {
                        return this.toPOJO();
                    }, e.prototype.toString = function() {
                        var e = this;
                        return this.name + "[{ " + Array.from(this.keys()).map(function(n) {
                            return T(n) + ": " + e.get(n);
                        }).join(", ") + " }]";
                    }, e.prototype.observe = function(e, n) {
                        return st(this, e);
                    }, e.prototype.intercept = function(e) {
                        return Mt(this, e);
                    }, e;
                }(), dt = D("ObservableMap", At), pt = {}, Et = function() {
                    function e(e, n, t) {
                        if (void 0 === n && (n = _), void 0 === t && (t = "ObservableSet@" + i()), this.name = t, this[Tt] = pt, this._data = new Set, this._atom = w(this.name), this[Symbol.toStringTag] = "Set", "function" != typeof Set) throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
                        this.enhancer = function(e, r) {
                            return n(e, r, t);
                        }, e && this.replace(e);
                    }
                    return e.prototype.dehanceValue = function(e) {
                        return void 0 !== this.dehancer ? this.dehancer(e) : e;
                    }, e.prototype.clear = function() {
                        var e = this;
                        Xn(function() {
                            ce(function() {
                                var n, t;
                                try {
                                    for(var r = L(e._data.values()), o = r.next(); !o.done; o = r.next()){
                                        var i = o.value;
                                        e.delete(i);
                                    }
                                } catch (e) {
                                    n = {
                                        error: e
                                    };
                                } finally{
                                    try {
                                        o && !o.done && (t = r.return) && t.call(r);
                                    } finally{
                                        if (n) throw n.error;
                                    }
                                }
                            });
                        });
                    }, e.prototype.forEach = function(e, n) {
                        var t, r;
                        try {
                            for(var o = L(this), i = o.next(); !i.done; i = o.next()){
                                var M = i.value;
                                e.call(n, M, M, this);
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                i && !i.done && (r = o.return) && r.call(o);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                    }, Object.defineProperty(e.prototype, "size", {
                        get: function() {
                            return this._atom.reportObserved(), this._data.size;
                        },
                        enumerable: !0,
                        configurable: !0
                    }), e.prototype.add = function(e) {
                        var n = this;
                        if ((ae(this._atom), it(this)) && !(r = at(this, {
                            type: "add",
                            object: this,
                            newValue: e
                        }))) return this;
                        if (!this.has(e)) {
                            Xn(function() {
                                n._data.add(n.enhancer(e, void 0)), n._atom.reportChanged();
                            });
                            var t = ut(this), r = t ? {
                                type: "add",
                                object: this,
                                newValue: e
                            } : null;
                            t && ct(this, r);
                        }
                        return this;
                    }, e.prototype.delete = function(e) {
                        var n = this;
                        if (it(this) && !(r = at(this, {
                            type: "delete",
                            object: this,
                            oldValue: e
                        }))) return !1;
                        if (this.has(e)) {
                            var t = ut(this), r = t ? {
                                type: "delete",
                                object: this,
                                oldValue: e
                            } : null;
                            return Xn(function() {
                                n._atom.reportChanged(), n._data.delete(e);
                            }), t && ct(this, r), !0;
                        }
                        return !1;
                    }, e.prototype.has = function(e) {
                        return this._atom.reportObserved(), this._data.has(this.dehanceValue(e));
                    }, e.prototype.entries = function() {
                        var e = 0, n = Array.from(this.keys()), t = Array.from(this.values());
                        return _t({
                            next: function() {
                                var r = e;
                                return e += 1, r < t.length ? {
                                    value: [
                                        n[r],
                                        t[r]
                                    ],
                                    done: !1
                                } : {
                                    done: !0
                                };
                            }
                        });
                    }, e.prototype.keys = function() {
                        return this.values();
                    }, e.prototype.values = function() {
                        this._atom.reportObserved();
                        var e = this, n = 0, t = Array.from(this._data.values());
                        return _t({
                            next: function() {
                                return n < t.length ? {
                                    value: e.dehanceValue(t[n++]),
                                    done: !1
                                } : {
                                    done: !0
                                };
                            }
                        });
                    }, e.prototype.replace = function(e) {
                        var n = this;
                        return wt(e) && (e = e.toJS()), Xn(function() {
                            var t = we(!0);
                            try {
                                Array.isArray(e) || j(e) ? (n.clear(), e.forEach(function(e) {
                                    return n.add(e);
                                })) : null != e && M("Cannot initialize set from " + e);
                            } finally{
                                Ie(t);
                            }
                        }), this;
                    }, e.prototype.observe = function(e, n) {
                        return st(this, e);
                    }, e.prototype.intercept = function(e) {
                        return Mt(this, e);
                    }, e.prototype.toJS = function() {
                        return new Set(this);
                    }, e.prototype.toString = function() {
                        return this.name + "[ " + Array.from(this).join(", ") + " ]";
                    }, e.prototype[Tt = d, Symbol.iterator] = function() {
                        return this.values();
                    }, e;
                }(), wt = D("ObservableSet", Et), It = function() {
                    function e(e, n, t, r) {
                        void 0 === n && (n = new Map), this.target = e, this.values = n, this.name = t, this.defaultEnhancer = r, this.keysAtom = new p(t + ".keys");
                    }
                    return e.prototype.read = function(e) {
                        return this.values.get(e).get();
                    }, e.prototype.write = function(e, n) {
                        var t = this.target, r = this.values.get(e);
                        if (r instanceof he) r.set(n);
                        else {
                            if (it(this)) {
                                if (!(i = at(this, {
                                    type: "update",
                                    object: this.proxy || t,
                                    name: e,
                                    newValue: n
                                }))) return;
                                n = i.newValue;
                            }
                            if ((n = r.prepareNewValue(n)) !== Ye.UNCHANGED) {
                                var o = ut(this), i = o ? {
                                    type: "update",
                                    object: this.proxy || t,
                                    oldValue: r.value,
                                    name: e,
                                    newValue: n
                                } : null;
                                r.setNewValue(n), o && ct(this, i);
                            }
                        }
                    }, e.prototype.has = function(e) {
                        var n = this.pendingKeys || (this.pendingKeys = new Map), t = n.get(e);
                        if (t) return t.get();
                        var r = !!this.values.get(e);
                        return t = new xe(r, B, this.name + "." + T(e) + "?", !1), n.set(e, t), t.get();
                    }, e.prototype.addObservableProp = function(e, n, t) {
                        void 0 === t && (t = this.defaultEnhancer);
                        var r = this.target;
                        if (it(this)) {
                            var o = at(this, {
                                object: this.proxy || r,
                                name: e,
                                type: "add",
                                newValue: n
                            });
                            if (!o) return;
                            n = o.newValue;
                        }
                        var i = new xe(n, t, this.name + "." + T(e), !1);
                        this.values.set(e, i), n = i.value, Object.defineProperty(r, e, function(e) {
                            return xt[e] || (xt[e] = {
                                configurable: !0,
                                enumerable: !0,
                                get: function() {
                                    return this[d].read(e);
                                },
                                set: function(n) {
                                    this[d].write(e, n);
                                }
                            });
                        }(e)), this.notifyPropertyAddition(e, n);
                    }, e.prototype.addComputedProp = function(e, n, t) {
                        var r, o, i, M = this.target;
                        t.name = t.name || this.name + "." + T(n), this.values.set(n, new he(t)), (e === M || (r = e, o = n, !(i = Object.getOwnPropertyDescriptor(r, o)) || !1 !== i.configurable && !1 !== i.writable)) && Object.defineProperty(e, n, function(e) {
                            return Lt[e] || (Lt[e] = {
                                configurable: Ye.computedConfigurable,
                                enumerable: !1,
                                get: function() {
                                    return ht(this).read(e);
                                },
                                set: function(n) {
                                    ht(this).write(e, n);
                                }
                            });
                        }(n));
                    }, e.prototype.remove = function(e) {
                        if (this.values.has(e)) {
                            var n = this.target;
                            if (it(this)) {
                                if (!(M = at(this, {
                                    object: this.proxy || n,
                                    name: e,
                                    type: "remove"
                                }))) return;
                            }
                            try {
                                Ze();
                                var t = ut(this), r = this.values.get(e), o = r && r.get();
                                if (r && r.set(void 0), this.keysAtom.reportChanged(), this.values.delete(e), this.pendingKeys) {
                                    var i = this.pendingKeys.get(e);
                                    i && i.set(!1);
                                }
                                delete this.target[e];
                                var M = t ? {
                                    type: "remove",
                                    object: this.proxy || n,
                                    oldValue: o,
                                    name: e
                                } : null;
                                t && ct(this, M);
                            } finally{
                                Ge();
                            }
                        }
                    }, e.prototype.illegalAccess = function(e, n) {
                        console.warn("Property '" + n + "' of '" + e + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
                    }, e.prototype.observe = function(e, n) {
                        return st(this, e);
                    }, e.prototype.intercept = function(e) {
                        return Mt(this, e);
                    }, e.prototype.notifyPropertyAddition = function(e, n) {
                        var t = ut(this), r = t ? {
                            type: "add",
                            object: this.proxy || this.target,
                            name: e,
                            newValue: n
                        } : null;
                        if (t && ct(this, r), this.pendingKeys) {
                            var o = this.pendingKeys.get(e);
                            o && o.set(!0);
                        }
                        this.keysAtom.reportChanged();
                    }, e.prototype.getKeys = function() {
                        var e, n;
                        this.keysAtom.reportObserved();
                        var t = [];
                        try {
                            for(var r = L(this.values), o = r.next(); !o.done; o = r.next()){
                                var i = h(o.value, 2), M = i[0];
                                i[1] instanceof xe && t.push(M);
                            }
                        } catch (n) {
                            e = {
                                error: n
                            };
                        } finally{
                            try {
                                o && !o.done && (n = r.return) && n.call(r);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        return t;
                    }, e;
                }();
                function Ot(e, n, t) {
                    if (void 0 === n && (n = ""), void 0 === t && (t = _), Object.prototype.hasOwnProperty.call(e, d)) return e[d];
                    l(e) || (n = (e.constructor.name || "ObservableObject") + "@" + i()), n || (n = "ObservableObject@" + i());
                    var r = new It(e, new Map, T(n), t);
                    return N(e, d, r), r;
                }
                var xt = Object.create(null), Lt = Object.create(null);
                function ht(e) {
                    var n = e[d];
                    return n || (U(e), e[d]);
                }
                var vt = D("ObservableObjectAdministration", It);
                function mt(e) {
                    return !!c(e) && (U(e), vt(e[d]));
                }
                function bt(e, n) {
                    if ("object" == typeof e && null !== e) {
                        if (zt(e)) return void 0 !== n && M(!1), e[d].atom;
                        if (wt(e)) return e[d];
                        if (dt(e)) {
                            var t = e;
                            return void 0 === n ? t._keysAtom : ((r = t._data.get(n) || t._hasMap.get(n)) || M(!1), r);
                        }
                        var r;
                        if (U(e), n && !e[d] && e[n], mt(e)) return n ? ((r = e[d].values.get(n)) || M(!1), r) : M(!1);
                        if (E(e) || ve(e) || Ke(e)) return e;
                    } else if ("function" == typeof e && Ke(e[d])) return e[d];
                    return M(!1);
                }
                function kt(e, n) {
                    return e || M("Expecting some object"), void 0 !== n ? kt(bt(e, n)) : E(e) || ve(e) || Ke(e) || dt(e) || wt(e) ? e : (U(e), e[d] ? e[d] : void M(!1));
                }
                function Ct(e, n) {
                    return (void 0 !== n ? bt(e, n) : mt(e) || dt(e) || wt(e) ? kt(e) : bt(e)).name;
                }
                var St = Object.prototype.toString;
                function Ut(e, n, t) {
                    return void 0 === t && (t = -1), function e(n, t, r, o, i) {
                        if (n === t) return 0 !== n || 1 / n == 1 / t;
                        if (null == n || null == t) return !1;
                        if (n != n) return t != t;
                        var M = typeof n;
                        if ("function" !== M && "object" !== M && "object" != typeof t) return !1;
                        var a = St.call(n);
                        if (a !== St.call(t)) return !1;
                        switch(a){
                            case "[object RegExp]":
                            case "[object String]":
                                return "" + n == "" + t;
                            case "[object Number]":
                                return +n != +n ? +t != +t : 0 == +n ? 1 / +n == 1 / t : +n == +t;
                            case "[object Date]":
                            case "[object Boolean]":
                                return +n == +t;
                            case "[object Symbol]":
                                return "undefined" != typeof Symbol && Symbol.valueOf.call(n) === Symbol.valueOf.call(t);
                            case "[object Map]":
                            case "[object Set]":
                                r >= 0 && r++;
                        }
                        n = Yt(n), t = Yt(t);
                        var u = "[object Array]" === a;
                        if (!u) {
                            if ("object" != typeof n || "object" != typeof t) return !1;
                            var s = n.constructor, c = t.constructor;
                            if (s !== c && !("function" == typeof s && s instanceof s && "function" == typeof c && c instanceof c) && "constructor" in n && "constructor" in t) return !1;
                        }
                        if (0 === r) return !1;
                        r < 0 && (r = -1);
                        i = i || [];
                        var l = (o = o || []).length;
                        for(; l--;)if (o[l] === n) return i[l] === t;
                        if (o.push(n), i.push(t), u) {
                            if ((l = n.length) !== t.length) return !1;
                            for(; l--;)if (!e(n[l], t[l], r - 1, o, i)) return !1;
                        } else {
                            var N = Object.keys(n), D = void 0;
                            if (l = N.length, Object.keys(t).length !== l) return !1;
                            for(; l--;)if (D = N[l], !Qt(t, D) || !e(n[D], t[D], r - 1, o, i)) return !1;
                        }
                        return o.pop(), i.pop(), !0;
                    }(e, n, t);
                }
                function Yt(e) {
                    return zt(e) ? e.slice() : y(e) || dt(e) || j(e) || wt(e) ? Array.from(e.entries()) : e;
                }
                function Qt(e, n) {
                    return Object.prototype.hasOwnProperty.call(e, n);
                }
                function _t(e) {
                    return e[Symbol.iterator] = Bt, e;
                }
                function Bt() {
                    return this;
                }
                if ("undefined" == typeof Proxy || "undefined" == typeof Symbol) throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
                "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
                    spy: en,
                    extras: {
                        getDebugName: Ct
                    },
                    $mobx: d
                });
            }).call(this, t(3));
        },
        function(e, n, t) {
            "use strict";
            t.r(n), (function(e) {
                t.d(n, "observer", function() {
                    return f;
                }), t.d(n, "Observer", function() {
                    return d;
                }), t.d(n, "useStaticRendering", function() {
                    return g;
                }), t.d(n, "connect", function() {
                    return x;
                }), t.d(n, "inject", function() {
                    return O;
                }), t.d(n, "Provider", function() {
                    return v;
                });
                var r = t(0), o = t(1);
                function i(e) {
                    return !(e.prototype && e.prototype.render || r.Component.isPrototypeOf(e));
                }
                function M(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, t = n.prefix, r = void 0 === t ? "" : t, o = n.suffix, i = void 0 === o ? "" : o, M = e.displayName || e.name || e.constructor && e.constructor.name || "<component>";
                    return r + M + i;
                }
                var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, u = function(e, n) {
                    if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
                }, s = function() {
                    function e(e, n) {
                        for(var t = 0; t < n.length; t++){
                            var r = n[t];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(n, t, r) {
                        return t && e(n.prototype, t), r && e(n, r), n;
                    };
                }(), c = function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
                }, l = function(e, n) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !n || "object" != typeof n && "function" != typeof n ? e : n;
                }, N = !1, D = console;
                function g(e) {
                    N = e;
                }
                function y(e, n, t, r, i) {
                    var M = function(e) {
                        var n = Object(o._getGlobalState)().allowStateChanges;
                        return Object(o._getGlobalState)().allowStateChanges = e, n;
                    }(e), a = void 0;
                    try {
                        a = n(t, r, i);
                    } finally{
                        !function(e) {
                            Object(o._getGlobalState)().allowStateChanges = e;
                        }(M);
                    }
                    return a;
                }
                function j(e, n) {
                    var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = e[n], o = T[n], i = r ? !0 === t ? function() {
                        o.apply(this, arguments), r.apply(this, arguments);
                    } : function() {
                        r.apply(this, arguments), o.apply(this, arguments);
                    } : o;
                    e[n] = i;
                }
                function z(e, n) {
                    if (null == e || null == n || "object" !== (void 0 === e ? "undefined" : a(e)) || "object" !== (void 0 === n ? "undefined" : a(n))) return e !== n;
                    var t = Object.keys(e);
                    if (t.length !== Object.keys(n).length) return !0;
                    for(var r = void 0, o = t.length - 1; r = t[o]; o--)if (n[r] !== e[r]) return !0;
                    return !1;
                }
                var T = {
                    componentWillMount: function() {
                        var e = this;
                        if (!0 !== N) {
                            var n = M(this), t = !1, i = !1;
                            l.call(this, "props"), l.call(this, "state");
                            var a = this.render.bind(this), u = null, s = !1, c = function(e, n, t) {
                                s = !1;
                                var r = void 0, o = void 0;
                                if (u.track(function() {
                                    try {
                                        o = y(!1, a, e, n, t);
                                    } catch (e) {
                                        r = e;
                                    }
                                }), r) throw r;
                                return o;
                            };
                            this.render = function() {
                                return (u = new o.Reaction(n + ".render()", function() {
                                    if (!s && (s = !0, "function" == typeof e.componentWillReact && e.componentWillReact(), !0 !== e.__$mobxIsUnmounted)) {
                                        var n = !0;
                                        try {
                                            i = !0, t || r.Component.prototype.forceUpdate.call(e), n = !1;
                                        } finally{
                                            i = !1, n && u.dispose();
                                        }
                                    }
                                })).reactComponent = e, c.$mobx = u, e.render = c, c(e.props, e.state, e.context);
                            };
                        }
                        function l(e) {
                            var n = this[e], r = Object(o.createAtom)("reactive " + e);
                            Object.defineProperty(this, e, {
                                configurable: !0,
                                enumerable: !0,
                                get: function() {
                                    return r.reportObserved(), n;
                                },
                                set: function(e) {
                                    !i && z(n, e) ? (n = e, t = !0, r.reportChanged(), t = !1) : n = e;
                                }
                            });
                        }
                    },
                    componentWillUnmount: function() {
                        !0 !== N && (this.render.$mobx && this.render.$mobx.dispose(), this.__$mobxIsUnmounted = !0);
                    },
                    componentDidMount: function() {},
                    componentDidUpdate: function() {},
                    shouldComponentUpdate: function(e, n) {
                        return N && D.warn("[mobx-preact] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side."), this.state !== n || z(this.props, e);
                    }
                };
                function f(e) {
                    var n, t;
                    if (arguments.length > 1 && D.warn('Mobx observer: Using observer to inject stores is not supported. Use `@connect(["store1", "store2"]) ComponentClass instead or preferably, use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))``'), !0 === e.isMobxInjector && D.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'"), i(e)) return f((t = n = function(n) {
                        function t() {
                            return u(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
                        }
                        return c(t, n), s(t, [
                            {
                                key: "render",
                                value: function() {
                                    return e.call(this, this.props, this.context);
                                }
                            }
                        ]), t;
                    }(r.Component), n.displayName = M(e), t));
                    if (!e) throw new Error("Please pass a valid component to 'observer'");
                    var o = e.prototype || e;
                    return A(o), e.isMobXReactObserver = !0, e;
                }
                function A(e) {
                    j(e, "componentWillMount", !0), j(e, "componentDidMount"), e.shouldComponentUpdate || (e.shouldComponentUpdate = T.shouldComponentUpdate);
                }
                var d = f(function(e) {
                    return e.children[0]();
                });
                d.displayName = "Observer";
                "undefined" != typeof window ? window : void 0 !== e || "undefined" != typeof self && self;
                var p = function(e, n) {
                    return e(n = {
                        exports: {}
                    }, n.exports), n.exports;
                }(function(e, n) {
                    var t, r, o, i, M, a, u, s;
                    e.exports = (t = {
                        childContextTypes: !0,
                        contextTypes: !0,
                        defaultProps: !0,
                        displayName: !0,
                        getDefaultProps: !0,
                        getDerivedStateFromProps: !0,
                        mixins: !0,
                        propTypes: !0,
                        type: !0
                    }, r = {
                        name: !0,
                        length: !0,
                        prototype: !0,
                        caller: !0,
                        callee: !0,
                        arguments: !0,
                        arity: !0
                    }, o = Object.defineProperty, i = Object.getOwnPropertyNames, M = Object.getOwnPropertySymbols, a = Object.getOwnPropertyDescriptor, u = Object.getPrototypeOf, s = u && u(Object), function e(n, c, l) {
                        if ("string" != typeof c) {
                            if (s) {
                                var N = u(c);
                                N && N !== s && e(n, N, l);
                            }
                            var D = i(c);
                            M && (D = D.concat(M(c)));
                            for(var g = 0; g < D.length; ++g){
                                var y = D[g];
                                if (!(t[y] || r[y] || l && l[y])) {
                                    var j = a(c, y);
                                    try {
                                        o(n, y, j);
                                    } catch (e) {}
                                }
                            }
                            return n;
                        }
                        return n;
                    });
                }), E = {
                    isMobxInjector: {
                        value: !0,
                        writable: !0,
                        configurable: !0,
                        enumerable: !0
                    }
                };
                function w(e, n, t) {
                    var o, i, a = M(n, {
                        prefix: "inject-",
                        suffix: t ? "-with-" + t : ""
                    }), N = (i = o = function(t) {
                        function o() {
                            return u(this, o), l(this, (o.__proto__ || Object.getPrototypeOf(o)).apply(this, arguments));
                        }
                        return c(o, t), s(o, [
                            {
                                key: "render",
                                value: function() {
                                    var t = {};
                                    for(var o in this.props)this.props.hasOwnProperty(o) && (t[o] = this.props[o]);
                                    var i = e(this.context.mobxStores || {}, t, this.context) || {};
                                    for(var M in i)t[M] = i[M];
                                    return Object(r.h)(n, t);
                                }
                            }
                        ]), o;
                    }(r.Component), o.displayName = a, i);
                    return p(N, n), N.wrappedComponent = n, Object.defineProperties(N, E), N;
                }
                function I(e) {
                    return function(n, t) {
                        return e.forEach(function(e) {
                            if (!(e in t)) {
                                if (!(e in n)) throw new Error("MobX injector: Store '" + e + "' is not available! Make sure it is provided by some Provider");
                                t[e] = n[e];
                            }
                        }), t;
                    };
                }
                function O() {
                    var e = void 0;
                    if ("function" == typeof arguments[0]) return e = arguments[0], function(n) {
                        var t = w(e, n);
                        return t.isMobxInjector = !1, (t = f(t)).isMobxInjector = !0, t;
                    };
                    for(var n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t];
                    return e = I(n), function(t) {
                        return w(e, t, n.join("-"));
                    };
                }
                function x(e, n) {
                    if ("string" == typeof e) throw new Error("Store names should be provided as array");
                    return Array.isArray(e) ? n ? O.apply(null, e)(x(n)) : function(n) {
                        return x(e, n);
                    } : f(e);
                }
                var L = {
                    children: !0,
                    key: !0,
                    ref: !0
                }, h = console, v = function(e) {
                    function n() {
                        return u(this, n), l(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
                    }
                    return c(n, e), s(n, [
                        {
                            key: "render",
                            value: function(e) {
                                var n = e.children;
                                return n.length > 1 ? Object(r.h)("div", null, " ", n, " ") : n[0];
                            }
                        },
                        {
                            key: "getChildContext",
                            value: function() {
                                var e = {}, n = this.context.mobxStores;
                                if (n) for(var t in n)e[t] = n[t];
                                for(var r in this.props)L[r] || "suppressChangedStoreWarning" === r || (e[r] = this.props[r]);
                                return {
                                    mobxStores: e
                                };
                            }
                        },
                        {
                            key: "componentWillReceiveProps",
                            value: function(e) {
                                if (Object.keys(e).length !== Object.keys(this.props).length && h.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children"), !e.suppressChangedStoreWarning) for(var n in e)L[n] || this.props[n] === e[n] || h.warn("MobX Provider: Provided store '" + n + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
                            }
                        }
                    ]), n;
                }(r.Component);
                if (!r.Component) throw new Error("mobx-preact requires Preact to be available");
            }).call(this, t(3));
        },
        function(e, n) {
            var t;
            t = function() {
                return this;
            }();
            try {
                t = t || new Function("return this")();
            } catch (e) {
                "object" == typeof window && (t = window);
            }
            e.exports = t;
        },
        function(e, n, t) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.JSONHTTPError = n.TextHTTPError = n.HTTPError = n.getPagination = void 0;
            var r = Object.assign || function(e) {
                for(var n = 1; n < arguments.length; n++){
                    var t = arguments[n];
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                }
                return e;
            }, o = function() {
                function e(e, n) {
                    for(var t = 0; t < n.length; t++){
                        var r = n[t];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(n, t, r) {
                    return t && e(n.prototype, t), r && e(n, r), n;
                };
            }(), i = t(10);
            function M(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function a(e, n) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !n || "object" != typeof n && "function" != typeof n ? e : n;
            }
            function u(e, n) {
                if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
                e.prototype = Object.create(n && n.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
            }
            Object.defineProperty(n, "getPagination", {
                enumerable: !0,
                get: function() {
                    return i.getPagination;
                }
            });
            var s = n.HTTPError = function(e) {
                function n(e) {
                    M(this, n);
                    var t = a(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e.statusText));
                    return t.name = t.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(t, t.constructor) : t.stack = new Error(e.statusText).stack, t.status = e.status, t;
                }
                return u(n, e), n;
            }(function(e) {
                function n() {
                    var n = Reflect.construct(e, Array.from(arguments));
                    return Object.setPrototypeOf(n, Object.getPrototypeOf(this)), n;
                }
                return n.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.setPrototypeOf ? Object.setPrototypeOf(n, e) : n.__proto__ = e, n;
            }(Error)), c = n.TextHTTPError = function(e) {
                function n(e, t) {
                    M(this, n);
                    var r = a(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
                    return r.data = t, r;
                }
                return u(n, e), n;
            }(s), l = n.JSONHTTPError = function(e) {
                function n(e, t) {
                    M(this, n);
                    var r = a(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
                    return r.json = t, r;
                }
                return u(n, e), n;
            }(s), N = function() {
                function e() {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments[1];
                    M(this, e), this.apiURL = n, this.apiURL.match(/\/[^\/]?/) && (this._sameOrigin = !0), this.defaultHeaders = t && t.defaultHeaders || {};
                }
                return o(e, [
                    {
                        key: "headers",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return r({}, this.defaultHeaders, {
                                "Content-Type": "application/json"
                            }, e);
                        }
                    },
                    {
                        key: "parseJsonResponse",
                        value: function(e) {
                            return e.json().then(function(n) {
                                if (!e.ok) return Promise.reject(new l(e, n));
                                var t = (0, i.getPagination)(e);
                                return t ? {
                                    pagination: t,
                                    items: n
                                } : n;
                            });
                        }
                    },
                    {
                        key: "request",
                        value: function(e) {
                            var n = this, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = this.headers(t.headers || {});
                            return this._sameOrigin && (t.credentials = t.credentials || "same-origin"), fetch(this.apiURL + e, r({}, t, {
                                headers: o
                            })).then(function(e) {
                                var t = e.headers.get("Content-Type");
                                return t && t.match(/json/) ? n.parseJsonResponse(e) : e.ok ? e.text().then(function(e) {}) : e.text().then(function(n) {
                                    return Promise.reject(new c(e, n));
                                });
                            });
                        }
                    }
                ]), e;
            }();
            n.default = N;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0);
            function i(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function M(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function a(e, n) {
                return (a = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function u(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = c(e);
                    if (n) {
                        var o = c(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return s(this, t);
                };
            }
            function s(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function c(e) {
                return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var l = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && a(e, n);
                }(c, e);
                var n, t, r, s = u(c);
                function c() {
                    return i(this, c), s.apply(this, arguments);
                }
                return n = c, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.saving, t = e.text, r = e.saving_text;
                            return (0, o.h)("button", {
                                type: "submit",
                                className: "btn".concat(n ? " saving" : "")
                            }, n ? r || "Saving" : t || "Save");
                        }
                    }
                ], M(n.prototype, t), r && M(n, r), c;
            }(o.Component);
            n.default = l;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0);
            function i(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function M(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function a(e, n) {
                return (a = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function u(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = c(e);
                    if (n) {
                        var o = c(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return s(this, t);
                };
            }
            function s(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function c(e) {
                return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var l = {
                confirm: {
                    type: "success",
                    text: "message_confirm"
                },
                password_mail: {
                    type: "success",
                    text: "message_password_mail"
                },
                email_changed: {
                    type: "sucess",
                    text: "message_email_changed"
                },
                verfication_error: {
                    type: "error",
                    text: "message_verfication_error"
                },
                signup_disabled: {
                    type: "error",
                    text: "message_signup_disabled"
                }
            }, N = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && a(e, n);
                }(c, e);
                var n, t, r, s = u(c);
                function c() {
                    return i(this, c), s.apply(this, arguments);
                }
                return n = c, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.type, t = e.t, r = l[n];
                            return (0, o.h)("div", {
                                className: "flashMessage ".concat(r.type)
                            }, (0, o.h)("span", null, t(r.text)));
                        }
                    }
                ], M(n.prototype, t), r && M(n, r), c;
            }(o.Component);
            n.default = N;
        },
        function(e, n, t) {
            "use strict";
            e.exports = function(e) {
                var n = [];
                return n.toString = function() {
                    return this.map(function(n) {
                        var t = function(e, n) {
                            var t = e[1] || "", r = e[3];
                            if (!r) return t;
                            if (n && "function" == typeof btoa) {
                                var o = (M = r, a = btoa(unescape(encodeURIComponent(JSON.stringify(M)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(u, " */")), i = r.sources.map(function(e) {
                                    return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
                                });
                                return [
                                    t
                                ].concat(i).concat([
                                    o
                                ]).join("\n");
                            }
                            var M, a, u;
                            return [
                                t
                            ].join("\n");
                        }(n, e);
                        return n[2] ? "@media ".concat(n[2], " {").concat(t, "}") : t;
                    }).join("");
                }, n.i = function(e, t, r) {
                    "string" == typeof e && (e = [
                        [
                            null,
                            e,
                            ""
                        ]
                    ]);
                    var o = {};
                    if (r) for(var i = 0; i < this.length; i++){
                        var M = this[i][0];
                        null != M && (o[M] = !0);
                    }
                    for(var a = 0; a < e.length; a++){
                        var u = [].concat(e[a]);
                        r && o[u[0]] || (t && (u[2] ? u[2] = "".concat(t, " and ").concat(u[2]) : u[2] = t), n.push(u));
                    }
                }, n;
            };
        },
        function(e, n, t) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var r = t(0), o = t(1), i = t(2), M = l(t(9)), a = l(t(13)), u = l(t(19)), s = l(t(29)), c = l(t(30));
            function l(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function N(e, n) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, n) {
                    var t = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
                    if (null == t) return;
                    var r, o, i = [], M = !0, a = !1;
                    try {
                        for(t = t.call(e); !(M = (r = t.next()).done) && (i.push(r.value), !n || i.length !== n); M = !0);
                    } catch (e) {
                        a = !0, o = e;
                    } finally{
                        try {
                            M || null == t.return || t.return();
                        } finally{
                            if (a) throw o;
                        }
                    }
                    return i;
                }(e, n) || function(e, n) {
                    if (!e) return;
                    if ("string" == typeof e) return D(e, n);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return D(e, n);
                }(e, n) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function D(e, n) {
                (null == n || n > e.length) && (n = e.length);
                for(var t = 0, r = new Array(n); t < n; t++)r[t] = e[t];
                return r;
            }
            function g(e, n) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    n && (r = r.filter(function(n) {
                        return Object.getOwnPropertyDescriptor(e, n).enumerable;
                    })), t.push.apply(t, r);
                }
                return t;
            }
            function y(e) {
                for(var n = 1; n < arguments.length; n++){
                    var t = null != arguments[n] ? arguments[n] : {};
                    n % 2 ? g(Object(t), !0).forEach(function(n) {
                        j(e, n, t[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : g(Object(t)).forEach(function(n) {
                        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
                    });
                }
                return e;
            }
            function j(e, n, t) {
                return n in e ? Object.defineProperty(e, n, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[n] = t, e;
            }
            var z = {};
            function T(e) {
                var n = arguments, t = z[e] || new Set;
                Array.from(t.values()).forEach(function(e) {
                    e.apply(e, Array.prototype.slice.call(n, 1));
                });
            }
            var f = {
                login: !0,
                signup: !0,
                error: !0
            }, A = {
                on: function(e, n) {
                    z[e] = z[e] || new Set, z[e].add(n);
                },
                off: function(e, n) {
                    z[e] && (n ? z[e].delete(n) : z[e].clear());
                },
                open: function(e) {
                    if (!f[e = e || "login"]) throw new Error("Invalid action for open: ".concat(e));
                    u.default.openModal(u.default.user ? "user" : e);
                },
                close: function() {
                    u.default.closeModal();
                },
                currentUser: function() {
                    return u.default.gotrue && u.default.gotrue.currentUser();
                },
                logout: function() {
                    return u.default.logout();
                },
                get gotrue () {
                    return u.default.gotrue || u.default.openModal("login"), u.default.gotrue;
                },
                refresh: function(e) {
                    return u.default.gotrue || u.default.openModal("login"), u.default.gotrue.currentUser().jwt(e);
                },
                init: function(e) {
                    !function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = e.APIUrl, t = e.logo, o = void 0 === t || t, M = e.namePlaceholder, l = e.locale;
                        l && (u.default.locale = l);
                        var N = document.querySelectorAll("[data-netlify-identity-menu],[data-netlify-identity-button]");
                        Array.prototype.slice.call(N).forEach(function(e) {
                            var n = null === e.getAttribute("data-netlify-identity-menu") ? "button" : "menu";
                            (0, r.render)((0, r.h)(i.Provider, {
                                store: u.default
                            }, (0, r.h)(s.default, {
                                mode: n,
                                text: e.innerText.trim()
                            })), e, null);
                        }), u.default.init(O(n)), u.default.modal.logo = o, u.default.setNamePlaceholder(M), (w = document.createElement("iframe")).id = "netlify-identity-widget", w.title = "Netlify identity widget", w.onload = function() {
                            var e = w.contentDocument.createElement("style");
                            e.innerHTML = c.default.toString(), w.contentDocument.head.appendChild(e), E = (0, r.render)((0, r.h)(i.Provider, {
                                store: u.default
                            }, (0, r.h)(a.default, null)), w.contentDocument.body, E), m();
                        }, p(w, x), w.src = "about:blank";
                        var D = e.container ? document.querySelector(e.container) : document.body;
                        D.appendChild(w), d && (w.setAttribute("style", d), d = null);
                    }(e);
                },
                setLocale: function(e) {
                    e && (u.default.locale = e);
                },
                store: u.default
            }, d = null;
            function p(e, n) {
                var t = "";
                for(var r in n)t += "".concat(r, ": ").concat(n[r], "; ");
                e ? e.setAttribute("style", t) : d = t;
            }
            var E, w, I = {
                localhost: !0,
                "127.0.0.1": !0,
                "0.0.0.0": !0
            };
            function O(e) {
                var n = I[document.location.hostname];
                if (e) return new M.default({
                    APIUrl: e,
                    setCookie: !n
                });
                if (n) {
                    u.default.setIsLocal(n);
                    var t = localStorage.getItem("netlifySiteURL");
                    return t && u.default.setSiteURL(t), null;
                }
                return new M.default({
                    setCookie: !n
                });
            }
            var x = {
                position: "fixed",
                top: 0,
                left: 0,
                border: "none",
                width: "100%",
                height: "100%",
                overflow: "visible",
                background: "transparent",
                display: "none",
                "z-index": 99
            };
            (0, o.observe)(u.default.modal, "isOpen", function() {
                u.default.settings || u.default.loadSettings(), p(w, y(y({}, x), {}, {
                    display: u.default.modal.isOpen ? "block !important" : "none"
                })), u.default.modal.isOpen ? T("open", u.default.modal.page) : T("close");
            }), (0, o.observe)(u.default, "siteURL", function() {
                var e;
                if (null === u.default.siteURL || void 0 === u.default.siteURL ? localStorage.removeItem("netlifySiteURL") : localStorage.setItem("netlifySiteURL", u.default.siteURL), u.default.siteURL) {
                    var n = u.default.siteURL.replace(/\/$/, "");
                    e = "".concat(n, "/.netlify/identity");
                }
                u.default.init(O(e), !0);
            }), (0, o.observe)(u.default, "user", function() {
                u.default.user ? T("login", u.default.user) : T("logout");
            }), (0, o.observe)(u.default, "gotrue", function() {
                u.default.gotrue && T("init", u.default.gotrue.currentUser());
            }), (0, o.observe)(u.default, "error", function() {
                T("error", u.default.error);
            });
            var L = /(confirmation|invite|recovery|email_change)_token=([^&]+)/, h = /error=access_denied&error_description=403/, v = /access_token=/;
            function m() {
                var e = (document.location.hash || "").replace(/^#\/?/, "");
                if (e) {
                    var n = e.match(L);
                    if (n && (u.default.verifyToken(n[1], n[2]), document.location.hash = ""), e.match(h) && (u.default.openModal("signup"), document.location.hash = ""), e.match(v)) {
                        var t = {};
                        if (e.split("&").forEach(function(e) {
                            var n = N(e.split("="), 2), r = n[0], o = n[1];
                            t[r] = o;
                        }), document && t.access_token && (document.cookie = "nf_jwt=".concat(t.access_token)), t.state) try {
                            var r = decodeURIComponent(t.state);
                            if ("implicit" === JSON.parse(r).auth_type) return;
                        } catch (e) {}
                        document.location.hash = "", u.default.openModal("login"), u.default.completeExternalLogin(t);
                    }
                }
            }
            var b = A;
            n.default = b;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o, i = function(e) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== r(e) && "function" != typeof e) return {
                    default: e
                };
                var n = a();
                if (n && n.has(e)) return n.get(e);
                var t = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    var M = o ? Object.getOwnPropertyDescriptor(e, i) : null;
                    M && (M.get || M.set) ? Object.defineProperty(t, i, M) : t[i] = e[i];
                }
                t.default = e, n && n.set(e, t);
                return t;
            }(t(4)), M = (o = t(11)) && o.__esModule ? o : {
                default: o
            };
            function a() {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap;
                return a = function() {
                    return e;
                }, e;
            }
            function u(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function s(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            var c = /^http:\/\//, l = function() {
                function e() {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = n.APIUrl, r = void 0 === t ? "/.netlify/identity" : t, o = n.audience, M = void 0 === o ? "" : o, a = n.setCookie, s = void 0 !== a && a;
                    u(this, e), r.match(c) && console.warn("Warning:\n\nDO NOT USE HTTP IN PRODUCTION FOR GOTRUE EVER!\nGoTrue REQUIRES HTTPS to work securely."), M && (this.audience = M), this.setCookie = s, this.api = new i.default(r);
                }
                var n, t, r;
                return n = e, t = [
                    {
                        key: "_request",
                        value: function(e) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            n.headers = n.headers || {};
                            var t = n.audience || this.audience;
                            return t && (n.headers["X-JWT-AUD"] = t), this.api.request(e, n).catch(function(e) {
                                return e instanceof i.JSONHTTPError && e.json && (e.json.msg ? e.message = e.json.msg : e.json.error && (e.message = "".concat(e.json.error, ": ").concat(e.json.error_description))), Promise.reject(e);
                            });
                        }
                    },
                    {
                        key: "settings",
                        value: function() {
                            return this._request("/settings");
                        }
                    },
                    {
                        key: "signup",
                        value: function(e, n, t) {
                            return this._request("/signup", {
                                method: "POST",
                                body: JSON.stringify({
                                    email: e,
                                    password: n,
                                    data: t
                                })
                            });
                        }
                    },
                    {
                        key: "login",
                        value: function(e, n, t) {
                            var r = this;
                            return this._setRememberHeaders(t), this._request("/token", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: "grant_type=password&username=".concat(encodeURIComponent(e), "&password=").concat(encodeURIComponent(n))
                            }).then(function(e) {
                                return M.default.removeSavedSession(), r.createUser(e, t);
                            });
                        }
                    },
                    {
                        key: "loginExternalUrl",
                        value: function(e) {
                            return "".concat(this.api.apiURL, "/authorize?provider=").concat(e);
                        }
                    },
                    {
                        key: "confirm",
                        value: function(e, n) {
                            return this._setRememberHeaders(n), this.verify("signup", e, n);
                        }
                    },
                    {
                        key: "requestPasswordRecovery",
                        value: function(e) {
                            return this._request("/recover", {
                                method: "POST",
                                body: JSON.stringify({
                                    email: e
                                })
                            });
                        }
                    },
                    {
                        key: "recover",
                        value: function(e, n) {
                            return this._setRememberHeaders(n), this.verify("recovery", e, n);
                        }
                    },
                    {
                        key: "acceptInvite",
                        value: function(e, n, t) {
                            var r = this;
                            return this._setRememberHeaders(t), this._request("/verify", {
                                method: "POST",
                                body: JSON.stringify({
                                    token: e,
                                    password: n,
                                    type: "signup"
                                })
                            }).then(function(e) {
                                return r.createUser(e, t);
                            });
                        }
                    },
                    {
                        key: "acceptInviteExternalUrl",
                        value: function(e, n) {
                            return "".concat(this.api.apiURL, "/authorize?provider=").concat(e, "&invite_token=").concat(n);
                        }
                    },
                    {
                        key: "createUser",
                        value: function(e) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            this._setRememberHeaders(n);
                            var t = new M.default(this.api, e, this.audience);
                            return t.getUserData().then(function(e) {
                                return n && e._saveSession(), e;
                            });
                        }
                    },
                    {
                        key: "currentUser",
                        value: function() {
                            var e = M.default.recoverSession(this.api);
                            return e && this._setRememberHeaders(e._fromStorage), e;
                        }
                    },
                    {
                        key: "verify",
                        value: function(e, n, t) {
                            var r = this;
                            return this._setRememberHeaders(t), this._request("/verify", {
                                method: "POST",
                                body: JSON.stringify({
                                    token: n,
                                    type: e
                                })
                            }).then(function(e) {
                                return r.createUser(e, t);
                            });
                        }
                    },
                    {
                        key: "_setRememberHeaders",
                        value: function(e) {
                            this.setCookie && (this.api.defaultHeaders = this.api.defaultHeaders || {}, this.api.defaultHeaders["X-Use-Cookie"] = e ? "1" : "session");
                        }
                    }
                ], s(n.prototype, t), r && s(n, r), e;
            }();
            n.default = l, "undefined" != typeof window && (window.GoTrue = l);
        },
        function(e, n, t) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var r = function(e, n) {
                if (Array.isArray(e)) return e;
                if (Symbol.iterator in Object(e)) return function(e, n) {
                    var t = [], r = !0, o = !1, i = void 0;
                    try {
                        for(var M, a = e[Symbol.iterator](); !(r = (M = a.next()).done) && (t.push(M.value), !n || t.length !== n); r = !0);
                    } catch (e) {
                        o = !0, i = e;
                    } finally{
                        try {
                            !r && a.return && a.return();
                        } finally{
                            if (o) throw i;
                        }
                    }
                    return t;
                }(e, n);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
            n.getPagination = function(e) {
                var n = e.headers.get("Link"), t = {};
                if (null == n) return null;
                n = n.split(",");
                for(var o = e.headers.get("X-Total-Count"), i = 0, M = n.length; i < M; i++){
                    var a = n[i].replace(/(^\s*|\s*$)/, "").split(";"), u = r(a, 2), s = u[0], c = u[1], l = s.match(/page=(\d+)/), N = l && parseInt(l[1], 10);
                    c.match(/last/) ? t.last = N : c.match(/next/) ? t.next = N : c.match(/prev/) ? t.prev = N : c.match(/first/) && (t.first = N);
                }
                return t.last = Math.max(t.last || 0, t.prev && t.prev + 1 || 0), t.current = t.next ? t.next - 1 : t.last || 1, t.total = o ? parseInt(o, 10) : null, t;
            };
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o, i = function(e) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== r(e) && "function" != typeof e) return {
                    default: e
                };
                var n = a();
                if (n && n.has(e)) return n.get(e);
                var t = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    var M = o ? Object.getOwnPropertyDescriptor(e, i) : null;
                    M && (M.get || M.set) ? Object.defineProperty(t, i, M) : t[i] = e[i];
                }
                t.default = e, n && n.set(e, t);
                return t;
            }(t(4)), M = (o = t(12)) && o.__esModule ? o : {
                default: o
            };
            function a() {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap;
                return a = function() {
                    return e;
                }, e;
            }
            function u(e, n) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    n && (r = r.filter(function(n) {
                        return Object.getOwnPropertyDescriptor(e, n).enumerable;
                    })), t.push.apply(t, r);
                }
                return t;
            }
            function s(e) {
                for(var n = 1; n < arguments.length; n++){
                    var t = null != arguments[n] ? arguments[n] : {};
                    n % 2 ? u(Object(t), !0).forEach(function(n) {
                        c(e, n, t[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : u(Object(t)).forEach(function(n) {
                        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
                    });
                }
                return e;
            }
            function c(e, n, t) {
                return n in e ? Object.defineProperty(e, n, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[n] = t, e;
            }
            function l(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            var N = {}, D = null, g = {
                api: 1,
                token: 1,
                audience: 1,
                url: 1
            }, y = {
                api: 1
            }, j = function() {
                return "undefined" != typeof window;
            }, z = function() {
                function e(n, t, r) {
                    !function(e, n) {
                        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.api = n, this.url = n.apiURL, this.audience = r, this._processTokenResponse(t), D = this;
                }
                var n, t, r;
                return n = e, r = [
                    {
                        key: "removeSavedSession",
                        value: function() {
                            j() && localStorage.removeItem("gotrue.user");
                        }
                    },
                    {
                        key: "recoverSession",
                        value: function(n) {
                            if (D) return D;
                            var t = j() && localStorage.getItem("gotrue.user");
                            if (t) try {
                                var r = JSON.parse(t), o = r.url, M = r.token, a = r.audience;
                                return o && M ? new e(n || new i.default(o, {}), M, a)._saveUserData(r, !0) : null;
                            } catch (e) {
                                return console.error(new Error("Gotrue-js: Error recovering session: ".concat(e))), null;
                            }
                            return null;
                        }
                    }
                ], t = [
                    {
                        key: "update",
                        value: function(e) {
                            var n = this;
                            return this._request("/user", {
                                method: "PUT",
                                body: JSON.stringify(e)
                            }).then(function(e) {
                                return n._saveUserData(e)._refreshSavedSession();
                            });
                        }
                    },
                    {
                        key: "jwt",
                        value: function(e) {
                            var n = this.tokenDetails();
                            if (null == n) return Promise.reject(new Error("Gotrue-js: failed getting jwt access token"));
                            var t = n.expires_at, r = n.refresh_token, o = n.access_token;
                            return e || t - 6e4 < Date.now() ? this._refreshToken(r) : Promise.resolve(o);
                        }
                    },
                    {
                        key: "logout",
                        value: function() {
                            return this._request("/logout", {
                                method: "POST"
                            }).then(this.clearSession.bind(this)).catch(this.clearSession.bind(this));
                        }
                    },
                    {
                        key: "_refreshToken",
                        value: function(e) {
                            var n = this;
                            return N[e] ? N[e] : N[e] = this.api.request("/token", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: "grant_type=refresh_token&refresh_token=".concat(e)
                            }).then(function(t) {
                                return delete N[e], n._processTokenResponse(t), n._refreshSavedSession(), n.token.access_token;
                            }).catch(function(t) {
                                return delete N[e], n.clearSession(), Promise.reject(t);
                            });
                        }
                    },
                    {
                        key: "_request",
                        value: function(e) {
                            var n = this, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            t.headers = t.headers || {};
                            var r = t.audience || this.audience;
                            return r && (t.headers["X-JWT-AUD"] = r), this.jwt().then(function(r) {
                                return n.api.request(e, s({
                                    headers: Object.assign(t.headers, {
                                        Authorization: "Bearer ".concat(r)
                                    })
                                }, t)).catch(function(e) {
                                    return e instanceof i.JSONHTTPError && e.json && (e.json.msg ? e.message = e.json.msg : e.json.error && (e.message = "".concat(e.json.error, ": ").concat(e.json.error_description))), Promise.reject(e);
                                });
                            });
                        }
                    },
                    {
                        key: "getUserData",
                        value: function() {
                            return this._request("/user").then(this._saveUserData.bind(this)).then(this._refreshSavedSession.bind(this));
                        }
                    },
                    {
                        key: "_saveUserData",
                        value: function(n, t) {
                            for(var r in n)r in e.prototype || r in g || (this[r] = n[r]);
                            return t && (this._fromStorage = !0), this;
                        }
                    },
                    {
                        key: "_processTokenResponse",
                        value: function(e) {
                            this.token = e;
                            try {
                                var n = JSON.parse(function(e) {
                                    var n = e.replace(/-/g, "+").replace(/_/g, "/");
                                    switch(n.length % 4){
                                        case 0:
                                            break;
                                        case 2:
                                            n += "==";
                                            break;
                                        case 3:
                                            n += "=";
                                            break;
                                        default:
                                            throw "Illegal base64url string!";
                                    }
                                    var t = window.atob(n);
                                    try {
                                        return decodeURIComponent(escape(t));
                                    } catch (e) {
                                        return t;
                                    }
                                }(e.access_token.split(".")[1]));
                                this.token.expires_at = 1e3 * n.exp;
                            } catch (e) {
                                console.error(new Error("Gotrue-js: Failed to parse tokenResponse claims: ".concat(e)));
                            }
                        }
                    },
                    {
                        key: "_refreshSavedSession",
                        value: function() {
                            return j() && localStorage.getItem("gotrue.user") && this._saveSession(), this;
                        }
                    },
                    {
                        key: "_saveSession",
                        value: function() {
                            return j() && localStorage.setItem("gotrue.user", JSON.stringify(this._details)), this;
                        }
                    },
                    {
                        key: "tokenDetails",
                        value: function() {
                            return this.token;
                        }
                    },
                    {
                        key: "clearSession",
                        value: function() {
                            e.removeSavedSession(), this.token = null, D = null;
                        }
                    },
                    {
                        key: "admin",
                        get: function() {
                            return new M.default(this);
                        }
                    },
                    {
                        key: "_details",
                        get: function() {
                            var n = {};
                            for(var t in this)t in e.prototype || t in y || (n[t] = this[t]);
                            return n;
                        }
                    }
                ], l(n.prototype, t), r && l(n, r), e;
            }();
            n.default = z;
        },
        function(e, n, t) {
            "use strict";
            function r(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = function() {
                function e(n) {
                    !function(e, n) {
                        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.user = n;
                }
                var n, t, o;
                return n = e, t = [
                    {
                        key: "listUsers",
                        value: function(e) {
                            return this.user._request("/admin/users", {
                                method: "GET",
                                audience: e
                            });
                        }
                    },
                    {
                        key: "getUser",
                        value: function(e) {
                            return this.user._request("/admin/users/".concat(e.id));
                        }
                    },
                    {
                        key: "updateUser",
                        value: function(e) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            return this.user._request("/admin/users/".concat(e.id), {
                                method: "PUT",
                                body: JSON.stringify(n)
                            });
                        }
                    },
                    {
                        key: "createUser",
                        value: function(e, n) {
                            var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return t.email = e, t.password = n, this.user._request("/admin/users", {
                                method: "POST",
                                body: JSON.stringify(t)
                            });
                        }
                    },
                    {
                        key: "deleteUser",
                        value: function(e) {
                            return this.user._request("/admin/users/".concat(e.id), {
                                method: "DELETE"
                            });
                        }
                    }
                ], r(n.prototype, t), o && r(n, o), e;
            }();
            n.default = o;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o, i = t(0), M = t(2), a = D(t(14)), u = D(t(15)), s = D(t(16)), c = D(t(17)), l = D(t(18)), N = D(t(6));
            function D(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function g(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function y(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function j(e, n) {
                return (j = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function z(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = f(e);
                    if (n) {
                        var o = f(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return T(this, t);
                };
            }
            function T(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function f(e) {
                return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var A = {
                login: !0,
                signup: !0
            }, d = {
                login: {
                    login: !0,
                    button: "log_in",
                    button_saving: "logging_in",
                    email: !0,
                    password: "current-password",
                    link: "amnesia",
                    link_text: "forgot_password",
                    providers: !0
                },
                signup: {
                    signup: !0,
                    button: "sign_up",
                    button_saving: "signing_up",
                    name: !0,
                    email: !0,
                    password: "new-password",
                    providers: !0
                },
                amnesia: {
                    title: "recover_password",
                    button: "send_recovery_email",
                    button_saving: "sending_recovery_email",
                    email: !0,
                    link: "login",
                    link_text: "never_mind"
                },
                recovery: {
                    title: "recover_password",
                    button: "update_password",
                    button_saving: "updating_password",
                    password: "new-password",
                    link: "login",
                    link_text: "never_mind"
                },
                invite: {
                    title: "complete_your_signup",
                    button: "sign_up",
                    button_saving: "signing_up",
                    password: "new-password",
                    providers: !0
                },
                user: {
                    title: "logged_in"
                }
            }, p = (0, M.connect)([
                "store"
            ])(o = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && j(e, n);
                }(M, e);
                var n, t, r, o = z(M);
                function M() {
                    var e;
                    g(this, M);
                    for(var n = arguments.length, t = new Array(n), r = 0; r < n; r++)t[r] = arguments[r];
                    return (e = o.call.apply(o, [
                        this
                    ].concat(t))).handleClose = function() {
                        return e.props.store.closeModal();
                    }, e.handlePage = function(n) {
                        return e.props.store.openModal(n);
                    }, e.handleLogout = function() {
                        return e.props.store.logout();
                    }, e.handleSiteURL = function(n) {
                        return e.props.store.setSiteURL(n);
                    }, e.clearSiteURL = function(n) {
                        return e.props.store.clearSiteURL();
                    }, e.clearStoreError = function() {
                        return e.props.store.setError();
                    }, e.handleExternalLogin = function(n) {
                        return e.props.store.externalLogin(n);
                    }, e.handleUser = function(n) {
                        var t = n.name, r = n.email, o = n.password, i = e.props.store;
                        switch(i.modal.page){
                            case "login":
                                i.login(r, o);
                                break;
                            case "signup":
                                i.signup(t, r, o);
                                break;
                            case "amnesia":
                                i.requestPasswordRecovery(r);
                                break;
                            case "invite":
                                i.acceptInvite(o);
                                break;
                            case "recovery":
                                i.updatePassword(o);
                        }
                    }, e;
                }
                return n = M, t = [
                    {
                        key: "renderBody",
                        value: function() {
                            var e = this, n = this.props.store, t = d[n.modal.page] || {};
                            return n.isLocal && null === n.siteURL ? (0, i.h)(u.default, {
                                devMode: null != n.siteURL,
                                onSiteURL: n.siteURL ? this.clearSiteURL : this.handleSiteURL,
                                t: n.translate
                            }) : n.settings ? n.user ? (0, i.h)(s.default, {
                                user: n.user,
                                saving: n.saving,
                                onLogout: this.handleLogout,
                                t: n.translate
                            }) : "signup" === n.modal.page && n.settings.disable_signup ? (0, i.h)(N.default, {
                                type: "signup_disabled",
                                t: n.translate
                            }) : (0, i.h)("div", null, (0, i.h)(c.default, {
                                page: d[n.modal.page] || {},
                                message: n.message,
                                saving: n.saving,
                                onSubmit: this.handleUser,
                                namePlaceholder: n.namePlaceholder,
                                t: n.translate
                            }), !n.user && t.link && n.gotrue && (0, i.h)("button", {
                                onclick: function() {
                                    return e.handlePage(t.link);
                                },
                                className: "btnLink forgotPasswordLink"
                            }, n.translate(t.link_text)), n.isLocal ? (0, i.h)(u.default, {
                                devMode: null != n.siteURL,
                                onSiteURL: n.siteURL ? this.clearSiteURL : this.handleSiteURL,
                                t: n.translate
                            }) : (0, i.h)("div", null)) : void 0;
                        }
                    },
                    {
                        key: "renderProviders",
                        value: function() {
                            var e = this.props.store;
                            if (!e.gotrue || !e.settings) return null;
                            if ("signup" === e.modal.page && e.settings.disable_signup) return null;
                            if (!(d[e.modal.page] || {}).providers) return null;
                            var n = [
                                "Google",
                                "GitHub",
                                "GitLab",
                                "BitBucket",
                                "SAML"
                            ].filter(function(n) {
                                return e.settings.external[n.toLowerCase()];
                            });
                            return n.length ? (0, i.h)(l.default, {
                                providers: n,
                                labels: e.settings.external_labels || {},
                                onLogin: this.handleExternalLogin,
                                t: e.translate
                            }) : null;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.props.store, n = A[e.modal.page], t = e.settings && !e.settings.disable_signup, r = d[e.modal.page] || {};
                            return (0, i.h)("div", null, (0, i.h)(a.default, {
                                page: r,
                                error: e.error,
                                showHeader: n,
                                showSignup: t,
                                devSettings: !e.gotrue,
                                loading: !e.error && e.gotrue && !e.settings,
                                isOpen: e.modal.isOpen,
                                onPage: this.handlePage,
                                onClose: this.handleClose,
                                logo: e.modal.logo,
                                t: e.translate,
                                isLocal: e.isLocal,
                                clearSiteURL: this.clearSiteURL,
                                clearStoreError: this.clearStoreError
                            }, this.renderBody(), this.renderProviders()));
                        }
                    }
                ], y(n.prototype, t), r && y(n, r), M;
            }(i.Component)) || o;
            n.default = p;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0);
            function i(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function M(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function a(e, n) {
                return (a = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function u(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = c(e);
                    if (n) {
                        var o = c(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return s(this, t);
                };
            }
            function s(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function c(e) {
                return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var l = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && a(e, n);
                }(c, e);
                var n, t, r, s = u(c);
                function c() {
                    var e;
                    i(this, c);
                    for(var n = arguments.length, t = new Array(n), r = 0; r < n; r++)t[r] = arguments[r];
                    return (e = s.call.apply(s, [
                        this
                    ].concat(t))).handleClose = function(n) {
                        n.preventDefault(), e.props.onClose();
                    }, e.blockEvent = function(e) {
                        e.stopPropagation();
                    }, e.linkHandler = function(n) {
                        return function(t) {
                            t.preventDefault(), e.props.onPage(n);
                        };
                    }, e;
                }
                return n = c, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.page, t = e.error, r = e.loading, i = e.showHeader, M = e.showSignup, a = e.devSettings, u = e.isOpen, s = e.children, c = e.logo, l = e.t, N = e.isLocal, D = e.clearSiteURL, g = e.clearStoreError, y = r || !u, j = t ? function(e) {
                                return e.json && e.json.error_description || e.message || e.toString();
                            }(t) : null;
                            return (0, o.h)("div", {
                                className: "modalContainer",
                                role: "dialog",
                                "aria-hidden": "".concat(y),
                                onClick: this.handleClose
                            }, (0, o.h)("div", {
                                className: "modalDialog".concat(r ? " visuallyHidden" : ""),
                                onClick: this.blockEvent
                            }, (0, o.h)("div", {
                                className: "modalContent"
                            }, (0, o.h)("button", {
                                onclick: this.handleClose,
                                className: "btn btnClose"
                            }, (0, o.h)("span", {
                                className: "visuallyHidden"
                            }, "Close")), i && (0, o.h)("div", {
                                className: "header"
                            }, M && (0, o.h)("button", {
                                className: "btn btnHeader ".concat(n.signup ? "active" : ""),
                                onclick: this.linkHandler("signup")
                            }, l("sign_up")), !a && (0, o.h)("button", {
                                className: "btn btnHeader ".concat(n.login ? "active" : ""),
                                onclick: this.linkHandler("login")
                            }, l("log_in"))), n.title && (0, o.h)("div", {
                                className: "header"
                            }, (0, o.h)("button", {
                                className: "btn btnHeader active"
                            }, l(n.title))), a && (0, o.h)("div", {
                                className: "header"
                            }, (0, o.h)("button", {
                                className: "btn btnHeader active"
                            }, l("site_url_title"))), j && (0, o.h)("div", {
                                className: "flashMessage error"
                            }, (0, o.h)("span", null, l(j))), N && j && j.includes("Failed to load settings from") && (0, o.h)("div", null, (0, o.h)("button", {
                                onclick: function(e) {
                                    D(e), g();
                                },
                                className: "btnLink forgotPasswordLink"
                            }, l("site_url_link_text"))), s)), c && (0, o.h)("a", {
                                href: "https://www.netlify.com",
                                className: "callOut".concat(r ? " visuallyHidden" : "")
                            }, (0, o.h)("span", {
                                className: "netlifyLogo"
                            }), l("coded_by")));
                        }
                    }
                ], M(n.prototype, t), r && M(n, r), c;
            }(o.Component);
            n.default = l;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0);
            function i(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function M(e, n) {
                return (M = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function a(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = s(e);
                    if (n) {
                        var o = s(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return u(this, t);
                };
            }
            function u(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function s(e) {
                return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var c = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && M(e, n);
                }(s, e);
                var n, t, r, u = a(s);
                function s(e) {
                    var n;
                    return function(e, n) {
                        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
                    }(this, s), (n = u.call(this, e)).handleInput = function(e) {
                        var t, r, o;
                        n.setState((t = {}, r = e.target.name, o = e.target.value, r in t ? Object.defineProperty(t, r, {
                            value: o,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[r] = o, t));
                    }, n.addSiteURL = function(e) {
                        e.preventDefault();
                        var t, r, o = (t = n.state.url, r = "/.netlify/identity", -1 === t.indexOf(r) ? t : t.substring(0, t.length - r.length));
                        n.props.onSiteURL(o);
                    }, n.clearSiteURL = function(e) {
                        e.preventDefault, n.props.onSiteURL();
                    }, n.state = {
                        url: "",
                        development: e.devMode || !1
                    }, n;
                }
                return n = s, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this, n = this.state, t = n.url, r = n.development, i = this.props.t;
                            return (0, o.h)("div", null, r ? (0, o.h)("div", {
                                class: "subheader"
                            }, (0, o.h)("h3", null, i("site_url_title")), (0, o.h)("button", {
                                onclick: function(n) {
                                    return e.clearSiteURL(n);
                                },
                                className: "btnLink forgotPasswordLink"
                            }, i("site_url_link_text"))) : (0, o.h)("form", {
                                onsubmit: this.addSiteURL,
                                className: "form"
                            }, (0, o.h)("div", {
                                className: "flashMessage"
                            }, i("site_url_message")), (0, o.h)("div", {
                                className: "formGroup"
                            }, (0, o.h)("label", null, (0, o.h)("span", {
                                className: "visuallyHidden"
                            }, i("site_url_label")), (0, o.h)("input", {
                                className: "formControl",
                                type: "url",
                                name: "url",
                                value: t,
                                placeholder: i("site_url_placeholder"),
                                autocapitalize: "off",
                                required: !0,
                                oninput: this.handleInput
                            }), (0, o.h)("div", {
                                className: "inputFieldIcon inputFieldUrl"
                            }))), (0, o.h)("button", {
                                type: "submit",
                                className: "btn"
                            }, i("site_url_submit"))));
                        }
                    }
                ], i(n.prototype, t), r && i(n, r), s;
            }(o.Component);
            n.default = c;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o, i = t(0), M = (o = t(5)) && o.__esModule ? o : {
                default: o
            };
            function a(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function u(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function s(e, n) {
                return (s = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function c(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = N(e);
                    if (n) {
                        var o = N(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return l(this, t);
                };
            }
            function l(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function N(e) {
                return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var D = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && s(e, n);
                }(l, e);
                var n, t, r, o = c(l);
                function l() {
                    var e;
                    a(this, l);
                    for(var n = arguments.length, t = new Array(n), r = 0; r < n; r++)t[r] = arguments[r];
                    return (e = o.call.apply(o, [
                        this
                    ].concat(t))).handleLogout = function(n) {
                        n.preventDefault(), e.props.onLogout();
                    }, e;
                }
                return n = l, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.user, t = e.saving, r = e.t;
                            return (0, i.h)("form", {
                                onSubmit: this.handleLogout,
                                className: "form ".concat(t ? "disabled" : "")
                            }, (0, i.h)("p", {
                                className: "infoText"
                            }, r("logged_in_as"), " ", (0, i.h)("br", null), (0, i.h)("span", {
                                className: "infoTextEmail"
                            }, n.user_metadata.full_name || n.user_metadata.name || n.email)), (0, i.h)(M.default, {
                                saving: t,
                                text: r("log_out"),
                                saving_text: r("logging_out")
                            }));
                        }
                    }
                ], u(n.prototype, t), r && u(n, r), l;
            }(i.Component);
            n.default = D;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0), i = a(t(6)), M = a(t(5));
            function a(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function u(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function s(e, n) {
                return (s = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function c(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = N(e);
                    if (n) {
                        var o = N(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return l(this, t);
                };
            }
            function l(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function N(e) {
                return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var D = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && s(e, n);
                }(l, e);
                var n, t, r, a = c(l);
                function l(e) {
                    var n;
                    return function(e, n) {
                        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
                    }(this, l), (n = a.call(this, e)).handleInput = function(e) {
                        var t, r, o;
                        n.setState((t = {}, r = e.target.name, o = e.target.value, r in t ? Object.defineProperty(t, r, {
                            value: o,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[r] = o, t));
                    }, n.handleLogin = function(e) {
                        e.preventDefault(), n.props.onSubmit(n.state);
                    }, n.state = {
                        name: "",
                        email: "",
                        password: ""
                    }, n;
                }
                return n = l, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.page, t = e.message, r = e.saving, a = e.namePlaceholder, u = e.t, s = this.state, c = s.name, l = s.email, N = s.password;
                            return (0, o.h)("form", {
                                onsubmit: this.handleLogin,
                                className: "form ".concat(r ? "disabled" : "")
                            }, t && (0, o.h)(i.default, {
                                type: t,
                                t: u
                            }), n.name && (0, o.h)("div", {
                                className: "formGroup"
                            }, (0, o.h)("label", null, (0, o.h)("span", {
                                className: "visuallyHidden"
                            }, u("form_name_placeholder")), (0, o.h)("input", {
                                className: "formControl",
                                type: "name",
                                name: "name",
                                value: c,
                                placeholder: a || u("form_name_label"),
                                autocapitalize: "off",
                                required: !0,
                                oninput: this.handleInput
                            }), (0, o.h)("div", {
                                className: "inputFieldIcon inputFieldName"
                            }))), n.email && (0, o.h)("div", {
                                className: "formGroup"
                            }, (0, o.h)("label", null, (0, o.h)("span", {
                                className: "visuallyHidden"
                            }, u("form_name_label")), (0, o.h)("input", {
                                className: "formControl",
                                type: "email",
                                name: "email",
                                value: l,
                                placeholder: u("form_email_placeholder"),
                                autocapitalize: "off",
                                required: !0,
                                oninput: this.handleInput
                            }), (0, o.h)("div", {
                                className: "inputFieldIcon inputFieldEmail"
                            }))), n.password && (0, o.h)("div", {
                                className: "formGroup"
                            }, (0, o.h)("label", null, (0, o.h)("span", {
                                className: "visuallyHidden"
                            }, u("form_password_label")), (0, o.h)("input", {
                                className: "formControl",
                                type: "password",
                                name: "password",
                                value: N,
                                placeholder: u("form_password_placeholder"),
                                autocomplete: n.password,
                                required: !0,
                                oninput: this.handleInput
                            }), (0, o.h)("div", {
                                className: "inputFieldIcon inputFieldPassword"
                            }))), (0, o.h)(M.default, {
                                saving: r,
                                text: u(n.button),
                                saving_text: u(n.button_saving)
                            }));
                        }
                    }
                ], u(n.prototype, t), r && u(n, r), l;
            }(o.Component);
            n.default = D;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o = t(0);
            function i(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function M(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function a(e, n, t) {
                return n && M(e.prototype, n), t && M(e, t), e;
            }
            function u(e, n) {
                if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(n && n.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), n && s(e, n);
            }
            function s(e, n) {
                return (s = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function c(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = N(e);
                    if (n) {
                        var o = N(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return l(this, t);
                };
            }
            function l(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function N(e) {
                return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var D = function(e) {
                u(t, e);
                var n = c(t);
                function t() {
                    var e;
                    i(this, t);
                    for(var r = arguments.length, o = new Array(r), M = 0; M < r; M++)o[M] = arguments[M];
                    return (e = n.call.apply(n, [
                        this
                    ].concat(o))).handleLogin = function(n) {
                        n.preventDefault(), e.props.onLogin(e.props.provider.toLowerCase());
                    }, e;
                }
                return a(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, n = e.provider, t = e.label, r = e.t;
                            return (0, o.h)("button", {
                                onClick: this.handleLogin,
                                className: "provider".concat(n, " btn btnProvider")
                            }, "".concat(r("continue_with"), " ").concat(t));
                        }
                    }
                ]), t;
            }(o.Component), g = function(e) {
                u(t, e);
                var n = c(t);
                function t() {
                    return i(this, t), n.apply(this, arguments);
                }
                return a(t, [
                    {
                        key: "getLabel",
                        value: function(e) {
                            var n = e.toLowerCase();
                            return n in this.props.labels ? this.props.labels[n] : e;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, n = this.props, t = n.providers, r = n.onLogin, i = n.t;
                            return (0, o.h)("div", {
                                className: "providersGroup"
                            }, (0, o.h)("hr", {
                                className: "hr"
                            }), t.map(function(n) {
                                return (0, o.h)(D, {
                                    key: n,
                                    provider: n,
                                    label: e.getLabel(n),
                                    onLogin: r,
                                    t: i
                                });
                            }));
                        }
                    }
                ]), t;
            }(o.Component);
            n.default = g;
        },
        function(e, n, t) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var r = t(1), o = t(20), i = (0, r.observable)({
                user: null,
                recovered_user: null,
                message: null,
                settings: null,
                gotrue: null,
                error: null,
                siteURL: null,
                remember: !0,
                saving: !1,
                invite_token: null,
                email_change_token: null,
                namePlaceholder: null,
                modal: {
                    page: "login",
                    isOpen: !1,
                    logo: !0
                },
                locale: o.defaultLocale
            });
            i.setNamePlaceholder = (0, r.action)(function(e) {
                i.namePlaceholder = e;
            }), i.startAction = (0, r.action)(function() {
                i.saving = !0, i.error = null, i.message = null;
            }), i.setError = (0, r.action)(function(e) {
                i.saving = !1, i.error = e;
            }), i.init = (0, r.action)(function(e, n) {
                e && (i.gotrue = e, i.user = e.currentUser(), i.user && (i.modal.page = "user")), n && i.loadSettings();
            }), i.loadSettings = (0, r.action)(function() {
                i.settings || i.gotrue && i.gotrue.settings().then((0, r.action)(function(e) {
                    return i.settings = e;
                })).catch((0, r.action)(function(e) {
                    i.error = new Error("Failed to load settings from ".concat(i.gotrue.api.apiURL));
                }));
            }), i.setIsLocal = (0, r.action)(function(e) {
                i.isLocal = e;
            }), i.setSiteURL = (0, r.action)(function(e) {
                i.siteURL = e;
            }), i.clearSiteURL = (0, r.action)(function() {
                i.gotrue = null, i.siteURL = null, i.settings = null;
            }), i.login = (0, r.action)(function(e, n) {
                return i.startAction(), i.gotrue.login(e, n, i.remember).then((0, r.action)(function(e) {
                    i.user = e, i.modal.page = "user", i.invite_token = null, i.email_change_token && i.doEmailChange(), i.saving = !1;
                })).catch(i.setError);
            }), i.externalLogin = (0, r.action)(function(e) {
                i.error = null, i.message = null;
                var n = i.invite_token ? i.gotrue.acceptInviteExternalUrl(e, i.invite_token) : i.gotrue.loginExternalUrl(e);
                window.location.href = n;
            }), i.completeExternalLogin = (0, r.action)(function(e) {
                i.startAction(), i.gotrue.createUser(e, i.remember).then(function(e) {
                    i.user = e, i.modal.page = "user", i.saving = !1;
                }).catch(i.setError);
            }), i.signup = (0, r.action)(function(e, n, t) {
                return i.startAction(), i.gotrue.signup(n, t, {
                    full_name: e
                }).then((0, r.action)(function() {
                    i.settings.autoconfirm ? i.login(n, t, i.remember) : i.message = "confirm", i.saving = !1;
                })).catch(i.setError);
            }), i.logout = (0, r.action)(function() {
                if (i.user) return i.startAction(), i.user.logout().then((0, r.action)(function() {
                    i.user = null, i.modal.page = "login", i.saving = !1;
                })).catch(i.setError);
                i.modal.page = "login", i.saving = !1;
            }), i.updatePassword = (0, r.action)(function(e) {
                i.startAction(), (i.recovered_user || i.user).update({
                    password: e
                }).then(function(e) {
                    i.user = e, i.recovered_user = null, i.modal.page = "user", i.saving = !1;
                }).catch(i.setError);
            }), i.acceptInvite = (0, r.action)(function(e) {
                i.startAction(), i.gotrue.acceptInvite(i.invite_token, e, i.remember).then(function(e) {
                    i.saving = !1, i.invite_token = null, i.user = e, i.modal.page = "user";
                }).catch(i.setError);
            }), i.doEmailChange = (0, r.action)(function() {
                return i.startAction(), i.user.update({
                    email_change_token: i.email_change_token
                }).then((0, r.action)(function(e) {
                    i.user = e, i.email_change_token = null, i.message = "email_changed", i.saving = !1;
                })).catch(i.setError);
            }), i.verifyToken = (0, r.action)(function(e, n) {
                var t = i.gotrue;
                switch(i.modal.isOpen = !0, e){
                    case "confirmation":
                        i.startAction(), i.modal.page = "signup", t.confirm(n, i.remember).then((0, r.action)(function(e) {
                            i.user = e, i.saving = !1;
                        })).catch((0, r.action)(function(e) {
                            console.error(e), i.message = "verfication_error", i.modal.page = "signup", i.saving = !1;
                        }));
                        break;
                    case "email_change":
                        i.email_change_token = n, i.modal.page = "message", i.user ? i.doEmailChange() : i.modal.page = "login";
                        break;
                    case "invite":
                        i.modal.page = e, i.invite_token = n;
                        break;
                    case "recovery":
                        i.startAction(), i.modal.page = e, i.gotrue.recover(n, i.remember).then(function(e) {
                            i.saving = !1, i.recovered_user = e;
                        }).catch(function(e) {
                            i.saving = !1, i.error = e, i.modal.page = "login";
                        });
                        break;
                    default:
                        i.error = "Unkown token type";
                }
            }), i.requestPasswordRecovery = (0, r.action)(function(e) {
                i.startAction(), i.gotrue.requestPasswordRecovery(e).then((0, r.action)(function() {
                    i.message = "password_mail", i.saving = !1;
                })).catch(i.setError);
            }), i.openModal = (0, r.action)(function(e) {
                i.modal.page = e, i.modal.isOpen = !0;
            }), i.closeModal = (0, r.action)(function() {
                i.modal.isOpen = !1, i.error = null, i.message = null, i.saving = !1;
            }), i.translate = (0, r.action)(function(e) {
                return (0, o.getTranslation)(e, i.locale);
            });
            var M = i;
            n.default = M;
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.getTranslation = n.defaultLocale = void 0;
            var o = D(t(21)), i = D(t(22)), M = D(t(23)), a = D(t(24)), u = D(t(25)), s = D(t(26)), c = D(t(27)), l = D(t(28));
            function N(e) {
                if ("function" != typeof WeakMap) return null;
                var n = new WeakMap, t = new WeakMap;
                return (N = function(e) {
                    return e ? t : n;
                })(e);
            }
            function D(e, n) {
                if (!n && e && e.__esModule) return e;
                if (null === e || "object" !== r(e) && "function" != typeof e) return {
                    default: e
                };
                var t = N(n);
                if (t && t.has(e)) return t.get(e);
                var o = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var M in e)if ("default" !== M && Object.prototype.hasOwnProperty.call(e, M)) {
                    var a = i ? Object.getOwnPropertyDescriptor(e, M) : null;
                    a && (a.get || a.set) ? Object.defineProperty(o, M, a) : o[M] = e[M];
                }
                return o.default = e, t && t.set(e, o), o;
            }
            n.defaultLocale = "en";
            var g = {
                en: o,
                fr: i,
                es: M,
                hu: a,
                pt: u,
                pl: s,
                cs: c,
                sk: l
            };
            n.getTranslation = function(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "en", t = g[n] && g[n][e];
                return t || g.en[e] || e;
            };
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Log in","log_out":"Log out","logged_in_as":"Logged in as","logged_in":"Logged in","logging_in":"Logging in","logging_out":"Logging out","sign_up":"Sign up","signing_up":"Signing up","forgot_password":"Forgot password?","recover_password":"Recover password","send_recovery_email":"Send recovery email","sending_recovery_email":"Sending recovery email","never_mind":"Never mind","update_password":"Update password","updating_password":"Updating password","complete_your_signup":"Complete your signup","site_url_title":"Development Settings","site_url_link_text":"Clear localhost URL","site_url_message":"Looks like you\'re running a local server. Please let us know the URL of your Netlify site.","site_url_label":"Enter your Netlify Site URL","site_url_placeholder":"URL of your Netlify site","site_url_submit":"Set site\'s URL","message_confirm":"A confirmation message was sent to your email, click the link there to continue.","message_password_mail":"We\'ve sent a recovery email to your account, follow the link there to reset your password.","message_email_changed":"Your email address has been updated!","message_verfication_error":"There was an error verifying your account. Please try again or contact an administrator.","message_signup_disabled":"Public signups are disabled. Contact an administrator and ask for an invite.","form_name_placeholder":"Name","form_email_label":"Enter your email","form_name_label":"Enter your name","form_email_placeholder":"Email","form_password_label":"Enter your password","form_password_placeholder":"Password","coded_by":"Coded by Netlify","continue_with":"Continue with","No user found with this email":"No user found with this email","Invalid Password":"Invalid Password","Email not confirmed":"Email not confirmed","User not found":"User not found"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Connexion","log_out":"D\xe9connexion","logged_in_as":"Connect\xe9 en tant que","logged_in":"Connect\xe9","logging_in":"Connexion","logging_out":"D\xe9connexion","sign_up":"Inscription","signing_up":"Inscription","forgot_password":"Mot de passe oubli\xe9 ?","recover_password":"R\xe9cup\xe9rer le mot de passe","send_recovery_email":"Envoyer l\'e-mail de r\xe9cup\xe9ration","sending_recovery_email":"Envoi de l\'e-mail de r\xe9cup\xe9ration","never_mind":"Annuler","update_password":"Mettre \xe0 jour le mot de passe","updating_password":"Mise \xe0 jour du mot de passe","complete_your_signup":"Compl\xe9ter l\'inscription","site_url_title":"Param\xe8tres de d\xe9veloppement","site_url_link_text":"Effacer l\'URL localhost","site_url_message":"On dirait que vous faites tourner un serveur local. Veuillez nous indiquer l\'URL de votre site Netlify.","site_url_label":"Entrez l\'URL de votre site Netlify","site_url_placeholder":"URL de votre site Netlify","site_url_submit":"D\xe9finir l\'URL du site","message_confirm":"Un message de confirmation a \xe9t\xe9 envoy\xe9 \xe0 votre adresse \xe9lectronique, cliquez sur le lien pour continuer.","message_password_mail":"Nous avons envoy\xe9 un e-mail de r\xe9cup\xe9ration \xe0 votre compte, suivez le lien qui s\'y trouve pour r\xe9initialiser votre mot de passe.","message_email_changed":"Votre adresse e-mail a \xe9t\xe9 mise \xe0 jour !","message_verfication_error":"Il y a eu une erreur lors de la v\xe9rification de votre compte. Veuillez r\xe9essayer ou contacter un administrateur.","message_signup_disabled":"Les inscriptions publiques sont d\xe9sactiv\xe9es. Contactez un administrateur et demandez une invitation.","form_name_placeholder":"Nom","form_email_label":"Entrez votre adresse e-mail","form_name_label":"Saisissez votre nom","form_email_placeholder":"E-mail","form_password_label":"Saisissez votre mot de passe","form_password_placeholder":"Mot de passe","coded_by":"Cod\xe9 par Netlify","continue_with":"Continuer avec","No user found with this email":"Aucun utilisateur trouv\xe9 avec cet e-mail","Invalid Password":"Mot de passe incorrect","Email not confirmed":"Adresse e-mail non confirm\xe9e","User not found":"Aucun utilisateur trouv\xe9"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Iniciar sesi\xf3n","log_out":"Cerrar sesi\xf3n","logged_in_as":"Conectado como","logged_in":"Conectado","logging_in":"Iniciando sesi\xf3n","logging_out":"Cerrando sesi\xf3n","sign_up":"Registrate","signing_up":"Registrandose","forgot_password":"\xbfOlvidaste tu contrase\xf1a?","recover_password":"Recuperar contrase\xf1a","send_recovery_email":"Enviar correo electr\xf3nico de recuperaci\xf3n","sending_recovery_email":"Enviando correo electr\xf3nico de recuperaci\xf3n","never_mind":"Regresar","update_password":"Actualizar contrase\xf1a","updating_password":"Actualizando contrase\xf1a","complete_your_signup":"Completa tu registro","site_url_title":"Configuraci\xf3n de desarrollo","site_url_link_text":"Borrar URL del localhost","site_url_message":"Parece que estas corriendo un servidor local. Por favor haznos saber la URL de tu sitio en Netlify.","site_url_label":"Ingresa la URL de tu sitio en Netlify","site_url_placeholder":"URL de tu sitio en Netlify","site_url_submit":"Establecer la URL del sitio","message_confirm":"Se envi\xf3 un mensaje de confirmaci\xf3n a tu correo electr\xf3nico, haz clic en el enlace all\xed para continuar.","message_password_mail":"Hemos enviado un correo electr\xf3nico de recuperaci\xf3n a tu correo electr\xf3nico, sigue el enlace all\xed para restablecer tu contrase\xf1a.","message_email_changed":"\xa1Tu direcci\xf3n de correo electr\xf3nico ha sido actualizada!","message_verfication_error":"Se produjo un error al verificar tu cuenta. Por favor intenta nuevamente o contacta a un administrador.","message_signup_disabled":"Los registros p\xfablicos est\xe1n deshabilitados. Contacta a un administrador y solicita una invitaci\xf3n.","form_name_placeholder":"Nombre","form_email_label":"Ingresa tu correo electr\xf3nico","form_name_label":"Ingresa tu nombre","form_email_placeholder":"Correo electr\xf3nico","form_password_label":"Ingresa tu contrase\xf1a","form_password_placeholder":"Contrase\xf1a","coded_by":"Codificado por Netlify","continue_with":"Contin\xfaa con","No user found with this email":"No existe ning\xfan usuario con este correo electr\xf3nico","Invalid Password":"La contrase\xf1a es invalida","Email not confirmed":"Correo electr\xf3nico no confirmado","User not found":"Usuario no encontrado"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Bejelentkez\xe9s","log_out":"Kijelentkez\xe9s","logged_in_as":"Bejelentkezve mint","logged_in":"Bejelentkezve","logging_in":"Bejelentkez\xe9s","logging_out":"Kijelentkez\xe9s","sign_up":"Regisztr\xe1ci\xf3","signing_up":"Regisztr\xe1l\xe1s","forgot_password":"Elfelejtette a jelszav\xe1t?","recover_password":"Jelsz\xf3 vissza\xe1ll\xedt\xe1sa","send_recovery_email":"Jelsz\xf3p\xf3tl\xf3 lev\xe9l k\xfcld\xe9se","sending_recovery_email":"Jelsz\xf3p\xf3tl\xf3 lev\xe9l k\xfcld\xe9se","never_mind":"M\xe9gsem","update_password":"\xdaj jelsz\xf3 be\xe1ll\xedt\xe1sa","updating_password":"\xdaj jelsz\xf3 be\xe1ll\xedt\xe1sa","complete_your_signup":"Regisztr\xe1ci\xf3 befejez\xe9se","site_url_title":"Fejleszt\u0151i Be\xe1ll\xedt\xe1sok","site_url_link_text":"Localhost URL t\xf6rl\xe9se","site_url_message":"\xdagy n\xe9z ki egy helyi szervert futtat. K\xe9rj\xfck adja meg a Netlify oldala URL-j\xe9t.","site_url_label":"Adja meg a Netlify oldala URL-j\xe9t","site_url_placeholder":"a Netlify oldala URL-je","site_url_submit":"URL be\xe1ll\xedt\xe1sa","message_confirm":"Elk\xfcldt\xfcnk egy meger\u0151s\xedt\u0151 levelet e-mailben, k\xe9rj\xfck kattintson a linkre a lev\xe9lben a folytat\xe1shoz.","message_password_mail":"Elk\xfcldt\xfcnk egy jelsz\xf3p\xf3tl\xf3 levelet e-mailben, k\xe9rj\xfck k\xf6vesse a linket a lev\xe9lben a jelszava vissza\xe1ll\xedt\xe1s\xe1hoz.","message_email_changed":"Az e-mail c\xedm\xe9t friss\xedtett\xfck!","message_verfication_error":"Probl\xe9ma t\xf6rt\xe9nt a fi\xf3kja meger\u0151s\xedt\xe9se k\xf6zben. K\xe9rj\xfck pr\xf3b\xe1lja \xfajra, vagy vegye fel a kapcsolatot egy adminisztr\xe1torral.","message_signup_disabled":"A nyilv\xe1nos regisztr\xe1ci\xf3 nincs enged\xe9lyezve. Vegye fel a kapcsolatot egy adminisztr\xe1torral \xe9s k\xe9rjen megh\xedv\xf3t.","form_name_placeholder":"N\xe9v","form_email_label":"Adja meg az e-mail c\xedm\xe9t","form_name_label":"Adja meg a nev\xe9t","form_email_placeholder":"E-mail","form_password_label":"Adja meg a jelszav\xe1t","form_password_placeholder":"Jelsz\xf3","coded_by":"Fejlesztette a Netlify","continue_with":"Bejelentkez\xe9s ezzel:","No user found with this email":"Nem tal\xe1lhat\xf3 fi\xf3k ezzel az e-mail c\xedmmel","Invalid Password":"Helytelen Jelsz\xf3","Email not confirmed":"Az e-mail nem er\u0151s\xfclt meg","User not found":"Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Entrar","log_out":"Sair","logged_in_as":"Logado como","logged_in":"Logado em","logging_in":"Logando em","logging_out":"Saindo","sign_up":"Registrar","signing_up":"Registrando","forgot_password":"Esqueceu a senha?","recover_password":"Recuperar senha","send_recovery_email":"Enviar email de recupera\xe7\xe3o de senha","sending_recovery_email":"Enviando email de recupera\xe7\xe3o de senha","never_mind":"Deixa pra l\xe1","update_password":"Atualizar senha","updating_password":"Atualizando senha","complete_your_signup":"Complete seu registro","site_url_title":"Configura\xe7\xf5es de desenvolvimento","site_url_link_text":"Limpar URL do localhost","site_url_message":"Parece que voc\xea est\xe1 executando um servidor local. Informe-nos o URL do seu site Netlify.","site_url_label":"Insira o URL do seu site Netlify","site_url_placeholder":"URL do seu site Netlify","site_url_submit":"Configure a URL do seu site","message_confirm":"Uma mensagem de confirma\xe7\xe3o foi enviada para o seu email, clique no link para continuar.","message_password_mail":"Enviamos um e-mail de recupera\xe7\xe3o para sua conta, siga o link para redefinir sua senha.","message_email_changed":"Seu email foi atualizado!","message_verfication_error":"Ocorreu um erro ao verificar sua conta. Tente novamente ou entre em contato com um administrador.","message_signup_disabled":"Registros p\xfablicos est\xe3o desabilitados. Contate um administrador e pe\xe7a por um convite.","form_name_placeholder":"Nome","form_email_label":"Insira seu email","form_name_label":"Insira seu nome","form_email_placeholder":"Email","form_password_label":"Insira sua senha","form_password_placeholder":"Senha","coded_by":"Desenvolvido por Netlify","continue_with":"Continue com","No user found with this email":"Nenhum usu\xe1rio encontrado com esse email","Invalid Password":"Senha inv\xe1lida","Email not confirmed":"Email n\xe3o confirmado","User not found":"Usu\xe1rio n\xe3o encontrado"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Zaloguj si\u0119","log_out":"Wyloguj si\u0119","logged_in_as":"Zaloguj jako","logged_in":"Zalogowany","logging_in":"Logowanie","logging_out":"Wylogowywanie","sign_up":"Zarejestruj si\u0119","signing_up":"Rejestracja","forgot_password":"Nie pami\u0119tasz has\u0142a?","recover_password":"Resetuj has\u0142o","send_recovery_email":"Wy\u015Blij link do resetowania has\u0142a","sending_recovery_email":"Wysy\u0142anie linku do resetowania has\u0142a","never_mind":"Nieistotne","update_password":"Zaktualizuj has\u0142o","updating_password":"Aktualizowanie has\u0142o","complete_your_signup":"Doko\u0144cz rejestracj\u0119","site_url_title":"Ustawienia strony","site_url_link_text":"Usu\u0144 adres localhost","site_url_message":"Wygl\u0105da na to \u017Ce zosta\u0142 uruchomiony lokalny serwer. Wprowad\u017A adres Twojej strony na Netlify.","site_url_label":"Wprowadz adres strony na Netlify","site_url_placeholder":"Adres Twojej strony na Netlify","site_url_submit":"Ustaw adres strony","message_confirm":"Potwierdzenie zosta\u0142o wys\u0142ane na Tw\xf3j adres email. Kliknij w link w wiadomo\u015Bci aby kontunuowa\u0107.","message_password_mail":"Wys\u0142ali\u015Bmy link resetuj\u0105cy has\u0142o na Tw\xf3j adres email. Klknij w link w wiadomo\u015Bci aby zresetowa\u0107 has\u0142o.","message_email_changed":"Tw\xf3j adres email zosta\u0142 zaktualizowany!","message_verfication_error":"Wyst\u0105pi\u0142 b\u0142\u0105d podczas weryfikcacji Twoje konta. Spr\xf3buj ponownie lub skontaktuj si\u0119 z administratorem,","message_signup_disabled":"Publiczna rejestracja jest wy\u0142\u0105czona. Skontaktuj si\u0119 z administratorem by uzyska\u0107 zaproszenie.","form_name_placeholder":"Imi\u0119","form_email_label":"Wprowad\u017A Tw\xf3j adres email","form_name_label":"Wprowad\u017A Twoje imi\u0119","form_email_placeholder":"Email","form_password_label":"Wprowad\u017A twoje has\u0142o","form_password_placeholder":"Has\u0142o","coded_by":"Coded by Netlify","continue_with":"Kontynuuj z","No user found with this email":"Nie znaleziono u\u017Cytkownika o tym adresie","Invalid Password":"Has\u0142o nieprawid\u0142owe","Email not confirmed":"Email nie zosta\u0142 potwierdzony","User not found":"Nie znaleziono u\u017Cytkownika"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"P\u0159ihl\xe1sit se","log_out":"Odhl\xe1sit se","logged_in_as":"P\u0159ihl\xe1\u0161en jako","logged_in":"P\u0159ihl\xe1\u0161en\xfd u\u017Eivatel","logging_in":"Prob\xedh\xe1 p\u0159ihl\xe1\u0161en\xed","logging_out":"Prob\xedh\xe1 odhl\xe1\u0161en\xed","sign_up":"Zaregistrovat se","signing_up":"Registrace","forgot_password":"Zapomn\u011Bli jste heslo?","recover_password":"Obnovit heslo","send_recovery_email":"Odeslat e-mail pro obnoven\xed","sending_recovery_email":"Odes\xedl\xe1n\xed e-mailu pro obnoven\xed","never_mind":"Zp\u011Bt","update_password":"Aktualizovat heslo","updated_password":"Aktualizace hesla","complete_your_signup":"Dokon\u010Dete registraci","site_url_title":"Nastaven\xed v\xfdvoje","site_url_link_text":"Vymazat URL localhost","site_url_message":"Zd\xe1 se, \u017Ee pou\u017E\xedv\xe1te lok\xe1ln\xed server. Sd\u011Blte n\xe1m pros\xedm adresu URL sv\xe9ho Netlify serveru.","site_url_label":"Zadejte adresu URL sv\xe9ho serveru Netlify","site_url_placeholder":"URL va\u0161eho Netlify serveru","site_url_submit":"Nastavit adresu URL","message_confirm":"Na v\xe1\u0161 e-mail byl odesl\xe1n odkaz k potvrzen\xed registrace, pokra\u010Dujte kliknut\xedm na tento odkaz.","message_password_mail":"Zaslali jsme v\xe1m e-mail pro obnoven\xed hesla, heslo obnov\xedte kliknut\xedm na odkaz v e-mailu.","message_email_changed":"Va\u0161e e-mailov\xe1 adresa byla aktualizov\xe1na!","message_verfication_error":"P\u0159i ov\u011B\u0159ov\xe1n\xed va\u0161eho \xfa\u010Dtu do\u0161lo k chyb\u011B. Zkuste to pros\xedm znovu nebo kontaktujte spr\xe1vce.","message_signup_disabled":"Registrace pro ve\u0159ejnost jsou zak\xe1z\xe1ny. Kontaktujte spr\xe1vce a po\u017E\xe1dejte o pozv\xe1nku.","form_name_placeholder":"Jm\xe9no","form_email_label":"Zadejte sv\u016Fj e-mail","form_name_label":"Zadejte sv\xe9 jm\xe9no","form_email_placeholder":"E-mail","form_password_label":"Zadejte sv\xe9 heslo","form_password_placeholder":"Heslo","coded_by":"Vytvo\u0159eno Netlify","continue_with":"Pokra\u010Dovat p\u0159es","No user found with this email":"Nebyl nalezen \u017E\xe1dn\xfd u\u017Eivatel s t\xedmto e-mailem","Invalid Password":"Neplatn\xe9 heslo","Email not confirmed":"E-mail nebyl potvrzen","User not found":"U\u017Eivatel nebyl nalezen"}');
        },
        function(e) {
            e.exports = JSON.parse('{"log_in":"Prihl\xe1si\u0165 sa","log_out":"Odhl\xe1si\u0165 sa","logged_in_as":"Prihl\xe1sen\xfd ako","logged_in":"Prihl\xe1sen\xfd u\u017E\xedvate\u013E","logging_in":"Prebieha prihl\xe1senie","logging_out":"Prebieha odhl\xe1senie","sign_up":"Zaregistrova\u0165 sa","signing_up":"Registr\xe1cia","forgot_password":"Zabudli ste heslo?","recover_password":"Obnovi\u0165 heslo","send_recovery_email":"Odosla\u0165 e-mail pre obnovenie","sending_recovery_email":"Odosielanie e-mailu pre obnovenie","never_mind":"Nasp\xe4\u0165","update_password":"Aktualizova\u0165 heslo","updated_password":"Aktualiz\xe1cia hesla","complete_your_signup":"Dokon\u010Dite registr\xe1ciu","site_url_title":"Nastavenie v\xfdvoja","site_url_link_text":"Vymaza\u0165 URL localhost","site_url_message":"Zd\xe1 sa, \u017Ee pou\u017E\xedvate lok\xe1lny server. Pros\xedm, nastavte URL adresu svojho Netlify servera.","site_url_label":"Zadajte URL svojho Netlify servera","site_url_placeholder":"URL v\xe1\u0161ho Netlify servera","site_url_submit":"Nastavi\u0165 URL adresu","message_confirm":"Potvr\u010Fte registr\xe1ciu kliknut\xedm na odkaz v spr\xe1ve, ktor\xfa sme V\xe1m pr\xe1ve zaslali na v\xe1\u0161 email.","message_password_mail":"Poslali sme v\xe1m e-mail pre obnovenie hesla, heslo obnov\xedte kliknut\xedm na odkaz v e-maile.","message_email_changed":"Va\u0161a e-mailov\xe1 adresa bola aktualizovan\xe1!","message_verfication_error":"Pri overovan\xed v\xe1\u0161ho \xfa\u010Dtu do\u0161lo k chybe. Pros\xedm, sk\xfaste to znova alebo kontaktujte spr\xe1vcu.","message_signup_disabled":"Registr\xe1cia pre verejnos\u0165 s\xfa zak\xe1zan\xe9. Kontaktujte spr\xe1vcu a po\u017Eiadajte o pozv\xe1nku.","form_name_placeholder":"Meno","form_email_label":"Zadajte svoj e-mail","form_name_label":"Zadajte svoje meno","form_email_placeholder":"E-mail","form_password_label":"Zadajte svoje heslo","form_password_placeholder":"Heslo","coded_by":"Vytvoren\xe9 Netlify","continue_with":"Pokra\u010Dova\u0165 cez","No user found with this email":"Nebol n\xe1jden\xfd \u017Eiadny u\u017E\xedvate\u013E s t\xfdmto e-mailom","Invalid Password":"Neplatn\xe9 heslo","Email not confirmed":"E-mail nebol potvrden\xfd","User not found":"Pou\u017E\xedvate\u013E nebol n\xe1jden\xfd"}');
        },
        function(e, n, t) {
            "use strict";
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = void 0;
            var o, i = t(0);
            function M(e, n) {
                if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
            }
            function a(e, n) {
                for(var t = 0; t < n.length; t++){
                    var r = n[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function u(e, n) {
                return (u = Object.setPrototypeOf || function(e, n) {
                    return e.__proto__ = n, e;
                })(e, n);
            }
            function s(e) {
                var n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var t, r = l(e);
                    if (n) {
                        var o = l(this).constructor;
                        t = Reflect.construct(r, arguments, o);
                    } else t = r.apply(this, arguments);
                    return c(this, t);
                };
            }
            function c(e, n) {
                return !n || "object" !== r(n) && "function" != typeof n ? function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e) : n;
            }
            function l(e) {
                return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            var N = (0, t(2).connect)([
                "store"
            ])(o = function(e) {
                !function(e, n) {
                    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(n && n.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), n && u(e, n);
                }(c, e);
                var n, t, r, o = s(c);
                function c() {
                    var e;
                    M(this, c);
                    for(var n = arguments.length, t = new Array(n), r = 0; r < n; r++)t[r] = arguments[r];
                    return (e = o.call.apply(o, [
                        this
                    ].concat(t))).handleSignup = function(n) {
                        n.preventDefault(), e.props.store.openModal("signup");
                    }, e.handleLogin = function(n) {
                        n.preventDefault(), e.props.store.openModal("login");
                    }, e.handleLogout = function(n) {
                        n.preventDefault(), e.props.store.openModal("user");
                    }, e.handleButton = function(n) {
                        n.preventDefault(), e.props.store.openModal(e.props.store.user ? "user" : "login");
                    }, e;
                }
                return n = c, t = [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props.store, n = e.user, t = e.translate;
                            return "button" === this.props.mode ? (0, i.h)("a", {
                                className: "netlify-identity-button",
                                href: "#",
                                onClick: this.handleButton
                            }, this.props.text || t(n ? "log_out" : "log_in")) : n ? (0, i.h)("ul", {
                                className: "netlify-identity-menu"
                            }, (0, i.h)("li", {
                                className: "netlify-identity-item netlify-identity-user-details"
                            }, t("logged_in_as"), " ", (0, i.h)("span", {
                                className: "netlify-identity-user"
                            }, n.user_metadata.name || n.email)), (0, i.h)("li", {
                                className: "netlify-identity-item"
                            }, (0, i.h)("a", {
                                className: "netlify-identity-logout",
                                href: "#",
                                onClick: this.handleLogout
                            }, t("log_out")))) : (0, i.h)("ul", {
                                className: "netlify-identity-menu"
                            }, (0, i.h)("li", {
                                className: "netlify-identity-item"
                            }, (0, i.h)("a", {
                                className: "netlify-identity-signup",
                                href: "#",
                                onClick: this.handleSignup
                            }, t("sign_up"))), (0, i.h)("li", {
                                className: "netlify-identity-item"
                            }, (0, i.h)("a", {
                                className: "netlify-identity-login",
                                href: "#",
                                onClick: this.handleLogin
                            }, t("log_in"))));
                        }
                    }
                ], a(n.prototype, t), r && a(n, r), c;
            }(i.Component)) || o;
            n.default = N;
        },
        function(e, n, t) {
            "use strict";
            t.r(n);
            var r = t(7), o = t.n(r)()(!0);
            o.push([
                e.i,
                '::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: #a3a9ac;\n  font-weight: 500;\n}\n\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #a3a9ac;\n  font-weight: 500;\n}\n\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #a3a9ac;\n  font-weight: 500;\n}\n\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: #a3a9ac;\n  font-weight: 500;\n}\n\n.modalContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,\n    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  font-size: 14px;\n  line-height: 1.5;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  z-index: 99999;\n}\n\n.modalContainer::before {\n  content: "";\n  display: block;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  z-index: -1;\n}\n\n.modalDialog {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n}\n\n.modalContent {\n  position: relative;\n  padding: 32px;\n  opacity: 0;\n  -webkit-transform: translateY(10px) scale(1);\n          transform: translateY(10px) scale(1);\n  background: #fff;\n}\n\n[aria-hidden="false"] .modalContent {\n    -webkit-animation: bouncyEntrance 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n            animation: bouncyEntrance 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n    -webkit-animation-fill-mode: forwards;\n            animation-fill-mode: forwards;\n  }\n\n@-webkit-keyframes bouncyEntrance {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10px) scale(0.9);\n            transform: translateY(10px) scale(0.9);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0) scale(1);\n            transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes bouncyEntrance {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10px) scale(0.9);\n            transform: translateY(10px) scale(0.9);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0) scale(1);\n            transform: translateY(0) scale(1);\n  }\n}\n\n@media (min-width: 480px) {\n  .modalContainer::before {\n    background-color: rgb(14, 30, 37);\n    -webkit-animation: fadeIn 0.1s ease-in;\n            animation: fadeIn 0.1s ease-in;\n    -webkit-animation-fill-mode: forwards;\n            animation-fill-mode: forwards;\n  }\n\n  .modalDialog {\n    max-width: 364px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n  .modalContent {\n    background: #fff;\n    -webkit-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .07),\n      0 12px 32px 0 rgba(14, 30, 37, .1);\n            box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .07),\n      0 12px 32px 0 rgba(14, 30, 37, .1);\n    border-radius: 8px;\n    margin-top: 32px;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.67;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.67;\n  }\n}\n\n.flashMessage {\n  text-align: center;\n  color: rgb(14, 30, 37);\n  font-weight: 500;\n  font-size: 14px;\n  background-color: #f2f3f3;\n  padding: 6px;\n  border-radius: 4px;\n  opacity: 0.7;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n\n.flashMessage:hover,\n.flashMessage:focus {\n  opacity: 1;\n}\n\n.error {\n  color: #fa3946;\n  background-color: #fceef0;\n  opacity: 1;\n}\n\n.error span::before {\n  content: "";\n  display: inline-block;\n  position: relative;\n  top: 3px;\n  margin-right: 4px;\n  width: 16px;\n  height: 16px;\n  background: no-repeat center center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjRkEzOTQ2IiBkPSJNOCwxLjMzMzMzMzMzIEMxMS42NzYsMS4zMzMzMzMzMyAxNC42NjY2NjY3LDQuMzI0IDE0LjY2NjY2NjcsOCBDMTQuNjY2NjY2NywxMS42NzYgMTEuNjc2LDE0LjY2NjY2NjcgOCwxNC42NjY2NjY3IEM0LjMyNCwxNC42NjY2NjY3IDEuMzMzMzMzMzMsMTEuNjc2IDEuMzMzMzMzMzMsOCBDMS4zMzMzMzMzMyw0LjMyNCA0LjMyNCwxLjMzMzMzMzMzIDgsMS4zMzMzMzMzMyBaIE04LDAgQzMuNTgyLDAgMCwzLjU4MiAwLDggQzAsMTIuNDE4IDMuNTgyLDE2IDgsMTYgQzEyLjQxOCwxNiAxNiwxMi40MTggMTYsOCBDMTYsMy41ODIgMTIuNDE4LDAgOCwwIFogTTcuMTI2NjY2NjcsNS4wMTczMzMzMyBDNy4wNjA2NjY2Nyw0LjQ3OTMzMzMzIDcuNDc4NjY2NjcsNCA4LjAyNTMzMzMzLDQgQzguNTM5MzMzMzMsNCA4Ljk0MzMzMzMzLDQuNDUwNjY2NjcgOC44Nzg2NjY2Nyw0Ljk2NzMzMzMzIEw4LjM3NCw5LjAwMjY2NjY3IEM4LjM1MDY2NjY3LDkuMTkxMzMzMzMgOC4xOSw5LjMzMzMzMzMzIDgsOS4zMzMzMzMzMyBDNy44MSw5LjMzMzMzMzMzIDcuNjQ5MzMzMzMsOS4xOTEzMzMzMyA3LjYyNTMzMzMzLDkuMDAyNjY2NjcgTDcuMTI2NjY2NjcsNS4wMTczMzMzMyBMNy4xMjY2NjY2Nyw1LjAxNzMzMzMzIFogTTgsMTIuMTY2NjY2NyBDNy41NCwxMi4xNjY2NjY3IDcuMTY2NjY2NjcsMTEuNzkzMzMzMyA3LjE2NjY2NjY3LDExLjMzMzMzMzMgQzcuMTY2NjY2NjcsMTAuODczMzMzMyA3LjU0LDEwLjUgOCwxMC41IEM4LjQ2LDEwLjUgOC44MzMzMzMzMywxMC44NzMzMzMzIDguODMzMzMzMzMsMTEuMzMzMzMzMyBDOC44MzMzMzMzMywxMS43OTMzMzMzIDguNDYsMTIuMTY2NjY2NyA4LDEyLjE2NjY2NjcgWiIvPgo8L3N2Zz4K);\n}\n\n.success {\n}\n\n.disabled {\n  opacity: 0.38;\n  pointer-events: none;\n}\n\n.infoText {\n  text-align: center;\n  margin: 32px 0;\n}\n\n.infoTextEmail {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.saving {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABQCAMAAACeYYN3AAAAxlBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////DTx3aAAAAQnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8PT4/QEGgjKRfAAACk0lEQVR4AYXQDXP5WhAG8CUhiSQqSv4RRRMVL1Fa1VZf3PL9v9Tde9wc9M8+P8/M7s6czJiHgNIvVCJO6YiAMlAiWckASiQrm4bJMZTDrmbBIEC9qpgVjp6n4B+oyEwCzKrMQBVaQIlkpmXZln1dhQB+49gOh5dLexlV6MhsAqyazEQVugCqsOK5nsQmwPWZ53ucvyczSGb4l9T9OsdnLgFOXVZFFd4AqEKrIasR4AdBI2hw1GR6VzMwSWY2A60ZNDl6KnUC3KbMRhXeAqhCpyXzCAjarNVucdqXVEhWaRfCdsj5vQcE1EOZQ7Jy+EcUlklWi2Q3BLQ6nagTcTra2Y0qrHZirRN3OOezTUAjvq4bd7suqpDfSGJUoXcnCwiIerIqqlC96vf6HD1ZsUcE3PYH/QGnrx3uYnqoQn4l6aMK/XtZi4BuIrNIZqVJkiapkhx37Y6AcDgcpsNU44Nz3OuoQn4jSVGFNw+ykID+SGaTzM5G2YiTFVM73AMConE2zjhj7XAXs4EqHE/4d12GKgwmsoiAZCpzSObMptPZdHZVSkCc5/ksnym8cPRUmiQzpvNcmedzTl4o7qlBsuZc1iVg9ChDFdYWshEBveV/FssFZ/l7Z7eowsfl0/JJ4UXj43A/ogpbT7IeAZNnWQ1VuJJNCBi8HKxeVhw9tRaq8JkfrV/WHDULxb1CFbbX7HX9yllfck9A/ipzSea+yeYEJO+yEFX4tim8b94VXjj/zzdU4Z/NmY/NB+fkTglYfMg8knmfsiUBD1+yCFX4+X309f3FOds/UYVR8fH2e6vwovExIuB5K/NJ5v8jWxGQ/chiVOF2d+pn98M5zt3WJFm83+/2O4UXjprabkzAWn+o56k9qvBfX4hMaM+SxOMAAAAASUVORK5CYII=);\n  background-repeat: repeat-x;\n  background-size: contain;\n  background-origin: border-box;\n  background-position: 0% 0%;\n  -webkit-animation: loading 20s linear infinite;\n          animation: loading 20s linear infinite;\n  pointer-events: none;\n}\n\n.saving::after {\n  content: "\u2026";\n}\n\n@-webkit-keyframes loading {\n  0% {\n    background-position: 0% 0%;\n  }\n\n  100% {\n    background-position: 700% 0%;\n  }\n}\n\n@keyframes loading {\n  0% {\n    background-position: 0% 0%;\n  }\n\n  100% {\n    background-position: 700% 0%;\n  }\n}\n\n.btn {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: auto;\n  margin: 14px 0 0;\n  padding: 6px;\n  outline: 0;\n  cursor: pointer;\n  border: 2px solid rgb(14, 30, 37);\n  border-radius: 4px;\n  background-color: #2d3b41;\n  color: #fff;\n  -webkit-transition: background-color 0.2s ease;\n  transition: background-color 0.2s ease;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,\n    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.btn:hover,\n.btn:focus {\n  background-color: rgb(14, 30, 37);\n  text-decoration: none;\n}\n\n.btnClose {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin: 6px;\n  background: #fff;\n  color: #a3a9ac;\n}\n\n.btnClose::before {\n  content: "\xd7";\n  font-size: 25px;\n  line-height: 9px;\n}\n\n.btnClose:hover,\n.btnClose:focus {\n  background: #e9ebeb;\n  color: rgb(14, 30, 37);\n}\n\n.header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: -8px;\n  margin-bottom: 32px;\n}\n\n.btnHeader {\n  font-size: 16px;\n  line-height: 24px;\n  background: #fff;\n  color: #a3a9ac;\n  border: 0;\n  border-bottom: 2px solid #e9ebeb;\n  border-radius: 4px 4px 0 0;\n  margin: 0;\n}\n\n.btnHeader:focus,\n.btnHeader.active {\n  background: #fff;\n  color: rgb(14, 30, 37);\n  border-color: rgb(14, 30, 37);\n  font-weight: 700;\n}\n\n.btnHeader:not(:only-child):hover {\n  background-color: #e9ebeb;\n  color: rgb(14, 30, 37);\n}\n\n.btnHeader:only-child {\n  cursor: auto;\n}\n\n.btnLink {\n  display: block;\n  position: relative;\n  width: auto;\n  height: auto;\n  margin: 14px auto 0;\n  padding: 6px;\n  padding-bottom: 0;\n  outline: 0;\n  cursor: pointer;\n  color: rgb(14, 30, 37);\n  border: none;\n  border-bottom: 2px solid #e9ebeb;\n  border-radius: 0;\n  background-color: inherit;\n  -webkit-transition: border-color 0.2s ease;\n  transition: border-color 0.2s ease;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,\n    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.btnLink:hover,\n.btnLink:focus {\n  background-color: inherit;\n  border-color: #a3a9ac;\n}\n\n.form {\n}\n\n.formGroup {\n  position: relative;\n  margin-top: 14px;\n}\n\n.formControl {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: block;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 6px 12px 6px 34px;\n  border: 2px solid #e9ebeb;\n  border-radius: 4px;\n  background: #fff;\n  color: rgb(14, 30, 37);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  -webkit-transition: -webkit-box-shadow ease-in-out 0.15s;\n  transition: -webkit-box-shadow ease-in-out 0.15s;\n  transition: box-shadow ease-in-out 0.15s;\n  transition: box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.inputFieldIcon {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n}\n\n.inputFieldName {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTgsNyBDNi4zNDMxNDU3NSw3IDUsNS42NTY4NTQyNSA1LDQgQzUsMi4zNDMxNDU3NSA2LjM0MzE0NTc1LDEgOCwxIEM5LjY1Njg1NDI1LDEgMTEsMi4zNDMxNDU3NSAxMSw0IEMxMSw1LjY1Njg1NDI1IDkuNjU2ODU0MjUsNyA4LDcgWiBNOCwxNSBMMS41LDE1IEMxLjUsMTEuMTM0MDA2OCA0LjQxMDE0OTEzLDggOCw4IEMxMS41ODk4NTA5LDggMTQuNSwxMS4xMzQwMDY4IDE0LjUsMTUgTDgsMTUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTEpIi8+PC9zdmc+);\n}\n\n.inputFieldEmail {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE2IDExIj4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xLjE3MDczMTcxLDMgQzAuNTIyMTQ2MzQxLDMgMy45MDI0NTk4N2UtMDgsMy41NDUxMTA4MSAzLjkwMjQ1OTg3ZS0wOCw0LjIyMjIyMTU0IEwzLjkwMjQ1OTg3ZS0wOCwxMi43Nzc3Nzg1IEMzLjkwMjQ1OTg3ZS0wOCwxMy40NTQ4ODkyIDAuNTIyMTQ2MzQxLDE0IDEuMTcwNzMxNzEsMTQgTDE0LjgyOTI2ODMsMTQgQzE1LjQ3Nzg1MzcsMTQgMTYsMTMuNDU0ODg5MiAxNiwxMi43Nzc3Nzg1IEwxNiw0LjIyMjIyMTU0IEMxNiwzLjU0NTExMDgxIDE1LjQ3Nzg1MzcsMyAxNC44MjkyNjgzLDMgTDEuMTcwNzMxNzEsMyBaIE0yLjMzNzQyMTE5LDUuMDAxODY1NjYgQzIuNDU3NTExNzUsNC45ODk1NTIxNCAyLjU2MDcxNDU3LDUuMDM5MzM5OCAyLjYzNjM1OTg1LDUuMTE3Mjg0MzcgTDcuNDgyNjA2MTcsMTAuMTEzMjU0NSBDNy43ODQ0ODgyMiwxMC40MjQ3NDU1IDguMjAzMjc4MjksMTAuNDI0NzY2IDguNTA1ODk2MTksMTAuMTEzMjU0NSBMMTMuMzYzNjQwMiw1LjExNzI4NDM3IEMxMy41MDUxMjU1LDQuOTcxMjA0OTkgMTMuNzUyOTc3OSw0Ljk4MTg5NzIzIDEzLjg4MzkyMjIsNS4xMzk3MzYwMiBDMTQuMDE0ODY2NSw1LjI5NzU3NDgxIDE0LjAwNTI4MjEsNS41NzQwNzQ4OCAxMy44NjM3OTY3LDUuNzIwMTU0MjYgTDExLjExNTg2MDYsOC41NDg0MTE1MiBMMTMuODU4MDU3MSwxMS4yNjc2NDY5IEMxNC4wMjE3ODM1LDExLjQwMzE5ODIgMTQuMDQ4OTM2MywxMS43MDE0OTMyIDEzLjkxMjk4ODIsMTEuODcwOTg4OCBDMTMuNzc3MDQwMSwxMi4wNDA1MDQ5IDEzLjUwODI4OTcsMTIuMDQzNDE5MSAxMy4zNjkzOTgyLDExLjg3Njk0MDQgTDEwLjU3NTQ3MTUsOS4xMDYzOTg2MiBMOS4wMDYwNTI3NSwxMC43MTYxMjQ0IEM4LjQzNDk0MTk1LDExLjMwNDAzMzQgNy41NTMzMDI4NiwxMS4zMDUxNjIxIDYuOTgyNDY4LDEwLjcxNjEyNDQgTDUuNDI0NTI4NSw5LjEwNjM5ODYyIEwyLjYzMDYwMTgzLDExLjg3Njk0MDQgQzIuNDkxNzEwMzMsMTIuMDQzNDM5NyAyLjIyMjk1OTg4LDEyLjA0MDUyNTUgMi4wODcwMTE3OCwxMS44NzA5ODg4IEMxLjk1MTA2MzY3LDExLjcwMTQ5MzIgMS45NzgyMTY1LDExLjQwMzE5ODIgMi4xNDE5NDI5LDExLjI2NzY0NjkgTDQuODg0MTM5MzksOC41NDg0MTE1MiBMMi4xMzYyMDMyOCw1LjcyMDE1NDI2IEMyLjAyODcxNDE0LDUuNjE2MjI4MTYgMS45ODM1NTE0MSw1LjQzODk1NDUzIDIuMDI1OTkxNSw1LjI4NzQ5ODI1IEMyLjA2ODQxMzE5LDUuMTM2MDYyNDkgMi4xOTYwMjc4MSw1LjAxOTAyMjQ5IDIuMzM3NDIxMTksNS4wMDE4NjU2NiBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zKSIvPjwvc3ZnPg==);\n}\n\n.inputFieldPassword {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.inputFieldUrl {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xMCw1IEMxMCwzLjg5NTQzMDUgOS4xMDQ1Njk1LDMgOCwzIEM2Ljg5NTQzMDUsMyA2LDMuODk1NDMwNSA2LDUgTTQsMTAgTDQsMTEgTDYsMTEgTDYsMTAgQzYsOS40NDc3MTUyNSA1LjU1MjI4NDc1LDkgNSw5IEM0LjQ0NzcxNTI1LDkgNCw5LjQ0NzcxNTI1IDQsMTAgWiBNMTIsMTAgQzEyLDkuNDQ3NzE1MjUgMTEuNTUyMjg0Nyw5IDExLDkgQzEwLjQ0NzcxNTMsOSAxMCw5LjQ0NzcxNTI1IDEwLDEwIEwxMCwxMSBMMTIsMTEgTDEyLDEwIFogTTYsNiBMNiw1IEw0LDUgTDQsNiBDNCw2LjU1MjI4NDc1IDQuNDQ3NzE1MjUsNyA1LDcgQzUuNTUyMjg0NzUsNyA2LDYuNTUyMjg0NzUgNiw2IFogTTEwLDYgQzEwLDYuNTUyMjg0NzUgMTAuNDQ3NzE1Myw3IDExLDcgQzExLjU1MjI4NDcsNyAxMiw2LjU1MjI4NDc1IDEyLDYgTDEyLDUgTDEwLDUgTDEwLDYgWiBNNCw1IEM0LDIuNzkwODYxIDUuNzkwODYxLDEgOCwxIEMxMC4yMDkxMzksMSAxMiwyLjc5MDg2MSAxMiw1IEw0LDUgWiBNNCwxMSBMMTIsMTEgQzEyLDEzLjIwOTEzOSAxMC4yMDkxMzksMTUgOCwxNSBDNS43OTA4NjEsMTUgNCwxMy4yMDkxMzkgNCwxMSBaIE0xMCwxMSBMNiwxMSBDNiwxMi4xMDQ1Njk1IDYuODk1NDMwNSwxMyA4LDEzIEM5LjEwNDU2OTUsMTMgMTAsMTIuMTA0NTY5NSAxMCwxMSBaIE04LDExIEM3LjQ0NzcxNTI1LDExIDcsMTAuNTUyMjg0NyA3LDEwIEw3LDYgQzcsNS40NDc3MTUyNSA3LjQ0NzcxNTI1LDUgOCw1IEM4LjU1MjI4NDc1LDUgOSw1LjQ0NzcxNTI1IDksNiBMOSwxMCBDOSwxMC41NTIyODQ3IDguNTUyMjg0NzUsMTEgOCwxMSBaIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA4LjcwNyA2LjI5MykiLz48L3N2Zz4=);\n}\n\n.formLabel {\n}\n\n.hr {\n  border: 0;\n  border-top: 2px solid #e9ebeb;\n  margin: 32px 0 -1px;\n  text-align: center;\n  overflow: visible;\n}\n\n.hr::before {\n  content: "or";\n  position: relative;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  text-transform: uppercase;\n  background-color: #fff;\n  color: rgb(14, 30, 37);\n  padding: 4px;\n  top: -11px;\n}\n\n.btnProvider {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.btnProvider::before {\n  content: "";\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  width: 32px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-position: left center;\n  top: -2px;\n  left: 14px;\n}\n\n.providerGoogle {\n  background-color: #4285f4;\n  border-color: #366dc7;\n}\n\n.providerGoogle:hover,\n.providerGoogle:focus {\n  background-color: #366dc7;\n}\n\n.providerGitHub {\n  background-color: #333;\n  border-color: #000;\n}\n\n.providerGitHub:hover,\n.providerGitHub:focus {\n  background-color: #000;\n}\n\n.providerGitLab {\n  background-color: #e24329;\n  border-color: #b03320;\n}\n\n.providerGitLab:hover,\n.providerGitLab:focus {\n  background-color: #b03320;\n}\n\n.providerBitbucket {\n  background-color: #205081;\n  border-color: #14314f;\n}\n\n.providerBitbucket:hover,\n.providerBitbucket:focus {\n  background-color: #14314f;\n}\n\n.providerGoogle:before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEzIDEyIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNDg4IC0yKSI+ICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wLjY1MjczNDM3NSwzLjI5NTI4MjQ0IEMwLjIzNzk4NDM3NSw0LjEwNTgzMjA2IDIuODQyMTcwOTRlLTE0LDUuMDE2MDQ1OCAyLjg0MjE3MDk0ZS0xNCw1Ljk3OTM4OTMxIEMyLjg0MjE3MDk0ZS0xNCw2Ljk0MjczMjgyIDAuMjM3OTg0Mzc1LDcuODUyOTAwNzYgMC42NTI3MzQzNzUsOC42NjM0NTAzOCBDMS42NTkwNDY4NywxMC42MTY3MDIzIDMuNzI2MDkzNzUsMTEuOTU4Nzc4NiA2LjExOTUzMTI1LDExLjk1ODc3ODYgQzcuNzcxNzgxMjUsMTEuOTU4Nzc4NiA5LjE1ODg1OTM3LDExLjQyNzI1MTkgMTAuMTcyMDE1NiwxMC41MTA0NDI3IEMxMS4zMjc5MDYyLDkuNDY3MzU4NzggMTEuOTk0MjgxMiw3LjkzMjY0MTIyIDExLjk5NDI4MTIsNi4xMTIyNTk1NCBDMTEuOTk0MjgxMiw1LjYyMDYyNTk1IDExLjk1MzQ1MzEsNS4yNjE4NjI2IDExLjg2NTA5MzcsNC44ODk4MTY3OSBMNi4xMTk1MzEyNSw0Ljg4OTgxNjc5IEw2LjExOTUzMTI1LDcuMTA4ODA5MTYgTDkuNDkyMDQ2ODcsNy4xMDg4MDkxNiBDOS40MjQwNzgxMiw3LjY2MDI1OTU0IDkuMDU2OTA2MjUsOC40OTA3MzI4MiA4LjI0MDk1MzEyLDkuMDQ4Nzc4NjMgQzcuNzI0MjAzMTIsOS40MDA5MDA3NiA3LjAzMDY0MDYyLDkuNjQ2NzE3NTYgNi4xMTk1MzEyNSw5LjY0NjcxNzU2IEM0LjUwMTI2NTYyLDkuNjQ2NzE3NTYgMy4xMjc3ODEyNSw4LjYwMzY3OTM5IDIuNjM4MTcxODcsNy4xNjE5ODQ3MyBMMi42Mjg3MTIwNSw3LjE2Mjc2OTU5IEMyLjUwNTM0MTU4LDYuNzk3Mjk0NjggMi40MzQyMTg3NSw2LjM4MTEyMjg1IDIuNDM0MjE4NzUsNS45NzkzODkzMSBDMi40MzQyMTg3NSw1LjU2NzQ1MDM4IDIuNTA4OTg0MzgsNS4xNjg4Mzk2OSAyLjYzMTM3NSw0Ljc5Njc5Mzg5IEMzLjEyNzc4MTI1LDMuMzU1MDk5MjQgNC41MDEyNjU2MiwyLjMxMjAxNTI3IDYuMTE5NTMxMjUsMi4zMTIwMTUyNyBDNy4yNjg2MjUsMi4zMTIwMTUyNyA4LjA0Mzc1LDIuNzk3MDA3NjMgOC40ODU3MzQzNywzLjIwMjMwNTM0IEwxMC4yMTI3OTY5LDEuNTU0NjQxMjIgQzkuMTUyMTA5MzcsMC41OTEyOTc3MSA3Ljc3MTc4MTI1LDguODgxNzg0MmUtMTYgNi4xMTk1MzEyNSw4Ljg4MTc4NDJlLTE2IEMzLjcyNjA5Mzc1LDguODgxNzg0MmUtMTYgMS42NTkwNDY4NywxLjM0MjAzMDUzIDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgTDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSIvPiAgPC9nPjwvc3ZnPg==);\n}\n\n.providerGitHub:before {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.providerGitLab:before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDE0IDEzIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTIpIj4gICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+ICAgIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBMNC40MjgwOTMzMyw0Ljk5NzI4MjU0IEw5LjU4MDA5MzM2LDQuOTk3MjgyNTQgTDcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBaIE03LjAwNDA5MzM2LDEyLjk0OTIzIEwwLjgxNzg5MzMzMyw0Ljk5NzI2OTE3IEw0LjQyODA5MzMzLDQuOTk3MjY5MTcgTDcuMDA0MDkzMzYsMTIuOTQ5MjMgWiBNMC44MTc4OTk5OTksNC45OTcyODkyMyBMNy4wMDQwOTk5OCwxMi45NDkyNSBMMC4yMjg4MzMzMzMsOC4wMTE4ODA4IEMwLjA0MTksNy44NzU2NzE1MiAtMC4wMzYzLDcuNjM0MjEyNyAwLjAzNTEsNy40MTM4MTcxMiBMMC44MTc4OTk5OTksNC45OTcyODkyMyBaIE0wLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIEwyLjM2OTM2NjY3LDAuMjA3OTA0NzE0IEMyLjQ0OTE2NjY3LC0wLjAzODUwMjM1ODggMi43OTY3NjY2NywtMC4wMzg1NjkyMjY1IDIuODc2NTY2NjcsMC4yMDc5MDQ3MTQgTDQuNDI4MSw0Ljk5NzI5NTkxIEwwLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIFogTTcuMDA0MDkzMzYsMTIuOTQ5MjMgTDkuNTgwMDkzMzYsNC45OTcyNjkxNyBMMTMuMTkwMjkzMyw0Ljk5NzI2OTE3IEw3LjAwNDA5MzM2LDEyLjk0OTIzIFogTTEzLjE5MDI5MzMsNC45OTcyODkyMyBMMTMuOTczMDkzMyw3LjQxMzgxNzEyIEMxNC4wNDQ0OTMzLDcuNjM0MjEyNyAxMy45NjYyOTM0LDcuODc1NjcxNTIgMTMuNzc5MzYsOC4wMTE4ODA4IEw3LjAwNDA5MzM2LDEyLjk0OTI1IEwxMy4xOTAyOTMzLDQuOTk3Mjg5MjMgWiBNMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIEw5LjU4MDA5MzM2LDQuOTk3Mjk1OTEgTDExLjEzMTYyNjcsMC4yMDc5MDQ3MTQgQzExLjIxMTQyNjcsLTAuMDM4NTY5MjI2NSAxMS41NTkwMjY3LC0wLjAzODUwMjM1ODggMTEuNjM4ODI2NywwLjIwNzkwNDcxNCBMMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMikiLz4gIDwvZz48L3N2Zz4=);\n}\n\n.providerBitbucket:before {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.callOut {\n  display: block;\n  padding: 32px;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  color: #a3a9ac;\n  text-align: center;\n}\n\n.callOut:after {\n  content: " \u2665";\n  -webkit-transition: color 4s ease;\n  transition: color 4s ease;\n}\n\n.callOut:hover:after {\n  color: red;\n}\n\n.callOut .netlifyLogo {\n  display: block;\n  margin: auto;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 8px;\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.visuallyHidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.subheader {\n  margin-top: 2em;\n  border-top: 1px solid rgb(14, 30, 37);\n}\n\n.subheader h3 {\n    padding-top: 1em;\n    text-align: center;\n  }\n',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://components/modal.css"
                    ],
                    names: [],
                    mappings: "AAiBA;EACE,wBAAwB;EACxB,cAA0B;EAC1B,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAA0B;EAC1B,gBAAgB;AAClB;;AACA;EACE,WAAW;EACX,cAA0B;EAC1B,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,cAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8BAAsB;UAAtB,sBAAsB;EACtB;+EAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAA2B;EAC3B,UAAU;EACV,4CAAoC;UAApC,oCAAoC;EACpC,gBAAgB;AAMlB;;AAJE;IACE,2EAAmE;YAAnE,mEAAmE;IACnE,qCAA6B;YAA7B,6BAA6B;EAC/B;;AAGF;EACE;IACE,UAAU;IACV,8CAAsC;YAAtC,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,yCAAiC;YAAjC,iCAAiC;EACnC;AACF;;AAVA;EACE;IACE,UAAU;IACV,8CAAsC;YAAtC,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,yCAAiC;YAAjC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iCAAkC;IAClC,sCAA8B;YAA9B,8BAA8B;IAC9B,qCAA6B;YAA7B,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB;wCACqC;YADrC;wCACqC;IACrC,kBAAkB;IAClB,gBAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AARA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uCAA+B;EAA/B,+BAA+B;AACjC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAwB;EACxB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,yzCAAyzC;AAC3zC;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,y2CAAy2C;EACz2C,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,8CAAsC;UAAtC,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AARA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,8CAAsC;EAAtC,sCAAsC;EACtC;+EAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,gBAAgB;EAChB,mBAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAA0B;EAC1B,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,sBAAuB;EACvB,6BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,sBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,0CAAkC;EAAlC,kCAAkC;EAClC;+EAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAiC;AACnC;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAuB;EACvB,wBAAgB;UAAhB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wDAAwC;EAAxC,gDAAwC;EAAxC,wCAAwC;EAAxC,8EAAwC;EACxC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,6jBAA6jB;AAC/jB;;AAEA;EACE,65DAA65D;AAC/5D;;AAEA;EACE,qkEAAqkE;AACvkE;;AAEA;EACE,yyCAAyyC;AAC3yC;;AAEA;AACA;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,mBAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,sBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAA4C;EAC5C,qBAA2C;AAC7C;;AAEA;;EAEE,yBAA+C;AACjD;;AAEA;EACE,sBAA4C;EAC5C,kBAA2C;AAC7C;;AAEA;;EAEE,sBAA+C;AACjD;;AAEA;EACE,yBAA4C;EAC5C,qBAA2C;AAC7C;;AAEA;;EAEE,yBAA+C;AACjD;;AAEA;EACE,yBAA+C;EAC/C,qBAA8C;AAChD;;AAEA;;EAEE,yBAAkD;AACpD;;AAEA;EACE,i9DAAi9D;AACn9D;;AAEA;EACE,ikKAAikK;AACnkK;;AAEA;EACE,imDAAimD;AACnmD;;AAEA;EACE,y2FAAy2F;AAC32F;;AAEA;EACE,cAAc;EACd,aAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qlYAAqlY;AACvlY;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;AAMvC;;AAJE;IACE,gBAAgB;IAChB,kBAAkB;EACpB",
                    sourcesContent: [
                        ':root {\n  --baseColor: rgb(14, 30, 37);\n  --subduedColor: #a3a9ac;\n  --errorColor: #fa3946;\n  --providerColorGoogle: #4285f4;\n  --providerAltColorGoogle: #366dc7;\n  --providerColorGitHub: #333;\n  --providerAltColorGitHub: #000;\n  --providerColorGitLab: #e24329;\n  --providerAltColorGitLab: #b03320;\n  --providerColorBitbucket: #205081;\n  --providerAltColorBitbucket: #14314f;\n  --fontFamily: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,\n    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";\n  --basePadding: 32px;\n}\n\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: var(--subduedColor);\n  font-weight: 500;\n}\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: var(--subduedColor);\n  font-weight: 500;\n}\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: var(--subduedColor);\n  font-weight: 500;\n}\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: var(--subduedColor);\n  font-weight: 500;\n}\n\n.modalContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-sizing: border-box;\n  font-family: var(--fontFamily);\n  font-size: 14px;\n  line-height: 1.5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 99999;\n}\n\n.modalContainer::before {\n  content: "";\n  display: block;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  z-index: -1;\n}\n\n.modalDialog {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.modalContent {\n  position: relative;\n  padding: var(--basePadding);\n  opacity: 0;\n  transform: translateY(10px) scale(1);\n  background: #fff;\n\n  [aria-hidden="false"] & {\n    animation: bouncyEntrance 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n    animation-fill-mode: forwards;\n  }\n}\n\n@keyframes bouncyEntrance {\n  0% {\n    opacity: 0;\n    transform: translateY(10px) scale(0.9);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (min-width: 480px) {\n  .modalContainer::before {\n    background-color: var(--baseColor);\n    animation: fadeIn 0.1s ease-in;\n    animation-fill-mode: forwards;\n  }\n\n  .modalDialog {\n    max-width: 364px;\n    justify-content: center;\n  }\n\n  .modalContent {\n    background: #fff;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.07),\n      0 12px 32px 0 rgba(14, 30, 37, 0.1);\n    border-radius: 8px;\n    margin-top: var(--basePadding);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.67;\n  }\n}\n\n.flashMessage {\n  text-align: center;\n  color: var(--baseColor);\n  font-weight: 500;\n  font-size: 14px;\n  background-color: #f2f3f3;\n  padding: 6px;\n  border-radius: 4px;\n  opacity: 0.7;\n  transition: opacity 0.2s linear;\n}\n\n.flashMessage:hover,\n.flashMessage:focus {\n  opacity: 1;\n}\n\n.error {\n  color: var(--errorColor);\n  background-color: #fceef0;\n  opacity: 1;\n}\n\n.error span::before {\n  content: "";\n  display: inline-block;\n  position: relative;\n  top: 3px;\n  margin-right: 4px;\n  width: 16px;\n  height: 16px;\n  background: no-repeat center center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjRkEzOTQ2IiBkPSJNOCwxLjMzMzMzMzMzIEMxMS42NzYsMS4zMzMzMzMzMyAxNC42NjY2NjY3LDQuMzI0IDE0LjY2NjY2NjcsOCBDMTQuNjY2NjY2NywxMS42NzYgMTEuNjc2LDE0LjY2NjY2NjcgOCwxNC42NjY2NjY3IEM0LjMyNCwxNC42NjY2NjY3IDEuMzMzMzMzMzMsMTEuNjc2IDEuMzMzMzMzMzMsOCBDMS4zMzMzMzMzMyw0LjMyNCA0LjMyNCwxLjMzMzMzMzMzIDgsMS4zMzMzMzMzMyBaIE04LDAgQzMuNTgyLDAgMCwzLjU4MiAwLDggQzAsMTIuNDE4IDMuNTgyLDE2IDgsMTYgQzEyLjQxOCwxNiAxNiwxMi40MTggMTYsOCBDMTYsMy41ODIgMTIuNDE4LDAgOCwwIFogTTcuMTI2NjY2NjcsNS4wMTczMzMzMyBDNy4wNjA2NjY2Nyw0LjQ3OTMzMzMzIDcuNDc4NjY2NjcsNCA4LjAyNTMzMzMzLDQgQzguNTM5MzMzMzMsNCA4Ljk0MzMzMzMzLDQuNDUwNjY2NjcgOC44Nzg2NjY2Nyw0Ljk2NzMzMzMzIEw4LjM3NCw5LjAwMjY2NjY3IEM4LjM1MDY2NjY3LDkuMTkxMzMzMzMgOC4xOSw5LjMzMzMzMzMzIDgsOS4zMzMzMzMzMyBDNy44MSw5LjMzMzMzMzMzIDcuNjQ5MzMzMzMsOS4xOTEzMzMzMyA3LjYyNTMzMzMzLDkuMDAyNjY2NjcgTDcuMTI2NjY2NjcsNS4wMTczMzMzMyBMNy4xMjY2NjY2Nyw1LjAxNzMzMzMzIFogTTgsMTIuMTY2NjY2NyBDNy41NCwxMi4xNjY2NjY3IDcuMTY2NjY2NjcsMTEuNzkzMzMzMyA3LjE2NjY2NjY3LDExLjMzMzMzMzMgQzcuMTY2NjY2NjcsMTAuODczMzMzMyA3LjU0LDEwLjUgOCwxMC41IEM4LjQ2LDEwLjUgOC44MzMzMzMzMywxMC44NzMzMzMzIDguODMzMzMzMzMsMTEuMzMzMzMzMyBDOC44MzMzMzMzMywxMS43OTMzMzMzIDguNDYsMTIuMTY2NjY2NyA4LDEyLjE2NjY2NjcgWiIvPgo8L3N2Zz4K);\n}\n\n.success {\n}\n\n.disabled {\n  opacity: 0.38;\n  pointer-events: none;\n}\n\n.infoText {\n  text-align: center;\n  margin: 32px 0;\n}\n\n.infoTextEmail {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.saving {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABQCAMAAACeYYN3AAAAxlBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////DTx3aAAAAQnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8PT4/QEGgjKRfAAACk0lEQVR4AYXQDXP5WhAG8CUhiSQqSv4RRRMVL1Fa1VZf3PL9v9Tde9wc9M8+P8/M7s6czJiHgNIvVCJO6YiAMlAiWckASiQrm4bJMZTDrmbBIEC9qpgVjp6n4B+oyEwCzKrMQBVaQIlkpmXZln1dhQB+49gOh5dLexlV6MhsAqyazEQVugCqsOK5nsQmwPWZ53ucvyczSGb4l9T9OsdnLgFOXVZFFd4AqEKrIasR4AdBI2hw1GR6VzMwSWY2A60ZNDl6KnUC3KbMRhXeAqhCpyXzCAjarNVucdqXVEhWaRfCdsj5vQcE1EOZQ7Jy+EcUlklWi2Q3BLQ6nagTcTra2Y0qrHZirRN3OOezTUAjvq4bd7suqpDfSGJUoXcnCwiIerIqqlC96vf6HD1ZsUcE3PYH/QGnrx3uYnqoQn4l6aMK/XtZi4BuIrNIZqVJkiapkhx37Y6AcDgcpsNU44Nz3OuoQn4jSVGFNw+ykID+SGaTzM5G2YiTFVM73AMConE2zjhj7XAXs4EqHE/4d12GKgwmsoiAZCpzSObMptPZdHZVSkCc5/ksnym8cPRUmiQzpvNcmedzTl4o7qlBsuZc1iVg9ChDFdYWshEBveV/FssFZ/l7Z7eowsfl0/JJ4UXj43A/ogpbT7IeAZNnWQ1VuJJNCBi8HKxeVhw9tRaq8JkfrV/WHDULxb1CFbbX7HX9yllfck9A/ipzSea+yeYEJO+yEFX4tim8b94VXjj/zzdU4Z/NmY/NB+fkTglYfMg8knmfsiUBD1+yCFX4+X309f3FOds/UYVR8fH2e6vwovExIuB5K/NJ5v8jWxGQ/chiVOF2d+pn98M5zt3WJFm83+/2O4UXjprabkzAWn+o56k9qvBfX4hMaM+SxOMAAAAASUVORK5CYII=);\n  background-repeat: repeat-x;\n  background-size: contain;\n  background-origin: border-box;\n  background-position: 0% 0%;\n  animation: loading 20s linear infinite;\n  pointer-events: none;\n}\n\n.saving::after {\n  content: "\u2026";\n}\n\n@keyframes loading {\n  0% {\n    background-position: 0% 0%;\n  }\n\n  100% {\n    background-position: 700% 0%;\n  }\n}\n\n.btn {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: auto;\n  margin: 14px 0 0;\n  padding: 6px;\n  outline: 0;\n  cursor: pointer;\n  border: 2px solid var(--baseColor);\n  border-radius: 4px;\n  background-color: #2d3b41;\n  color: #fff;\n  transition: background-color 0.2s ease;\n  font-family: var(--fontFamily);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.btn:hover,\n.btn:focus {\n  background-color: var(--baseColor);\n  text-decoration: none;\n}\n\n.btnClose {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin: 6px;\n  background: #fff;\n  color: var(--subduedColor);\n}\n\n.btnClose::before {\n  content: "\xd7";\n  font-size: 25px;\n  line-height: 9px;\n}\n\n.btnClose:hover,\n.btnClose:focus {\n  background: #e9ebeb;\n  color: var(--baseColor);\n}\n\n.header {\n  display: flex;\n  margin-top: -8px;\n  margin-bottom: var(--basePadding);\n}\n\n.btnHeader {\n  font-size: 16px;\n  line-height: 24px;\n  background: #fff;\n  color: var(--subduedColor);\n  border: 0;\n  border-bottom: 2px solid #e9ebeb;\n  border-radius: 4px 4px 0 0;\n  margin: 0;\n}\n\n.btnHeader:focus,\n.btnHeader.active {\n  background: #fff;\n  color: var(--baseColor);\n  border-color: var(--baseColor);\n  font-weight: 700;\n}\n\n.btnHeader:not(:only-child):hover {\n  background-color: #e9ebeb;\n  color: var(--baseColor);\n}\n\n.btnHeader:only-child {\n  cursor: auto;\n}\n\n.btnLink {\n  display: block;\n  position: relative;\n  width: auto;\n  height: auto;\n  margin: 14px auto 0;\n  padding: 6px;\n  padding-bottom: 0;\n  outline: 0;\n  cursor: pointer;\n  color: var(--baseColor);\n  border: none;\n  border-bottom: 2px solid #e9ebeb;\n  border-radius: 0;\n  background-color: inherit;\n  transition: border-color 0.2s ease;\n  font-family: var(--fontFamily);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.btnLink:hover,\n.btnLink:focus {\n  background-color: inherit;\n  border-color: var(--subduedColor);\n}\n\n.form {\n}\n\n.formGroup {\n  position: relative;\n  margin-top: 14px;\n}\n\n.formControl {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 6px 12px 6px 34px;\n  border: 2px solid #e9ebeb;\n  border-radius: 4px;\n  background: #fff;\n  color: var(--baseColor);\n  box-shadow: none;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  transition: box-shadow ease-in-out 0.15s;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.inputFieldIcon {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n}\n\n.inputFieldName {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTgsNyBDNi4zNDMxNDU3NSw3IDUsNS42NTY4NTQyNSA1LDQgQzUsMi4zNDMxNDU3NSA2LjM0MzE0NTc1LDEgOCwxIEM5LjY1Njg1NDI1LDEgMTEsMi4zNDMxNDU3NSAxMSw0IEMxMSw1LjY1Njg1NDI1IDkuNjU2ODU0MjUsNyA4LDcgWiBNOCwxNSBMMS41LDE1IEMxLjUsMTEuMTM0MDA2OCA0LjQxMDE0OTEzLDggOCw4IEMxMS41ODk4NTA5LDggMTQuNSwxMS4xMzQwMDY4IDE0LjUsMTUgTDgsMTUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTEpIi8+PC9zdmc+);\n}\n\n.inputFieldEmail {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE2IDExIj4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xLjE3MDczMTcxLDMgQzAuNTIyMTQ2MzQxLDMgMy45MDI0NTk4N2UtMDgsMy41NDUxMTA4MSAzLjkwMjQ1OTg3ZS0wOCw0LjIyMjIyMTU0IEwzLjkwMjQ1OTg3ZS0wOCwxMi43Nzc3Nzg1IEMzLjkwMjQ1OTg3ZS0wOCwxMy40NTQ4ODkyIDAuNTIyMTQ2MzQxLDE0IDEuMTcwNzMxNzEsMTQgTDE0LjgyOTI2ODMsMTQgQzE1LjQ3Nzg1MzcsMTQgMTYsMTMuNDU0ODg5MiAxNiwxMi43Nzc3Nzg1IEwxNiw0LjIyMjIyMTU0IEMxNiwzLjU0NTExMDgxIDE1LjQ3Nzg1MzcsMyAxNC44MjkyNjgzLDMgTDEuMTcwNzMxNzEsMyBaIE0yLjMzNzQyMTE5LDUuMDAxODY1NjYgQzIuNDU3NTExNzUsNC45ODk1NTIxNCAyLjU2MDcxNDU3LDUuMDM5MzM5OCAyLjYzNjM1OTg1LDUuMTE3Mjg0MzcgTDcuNDgyNjA2MTcsMTAuMTEzMjU0NSBDNy43ODQ0ODgyMiwxMC40MjQ3NDU1IDguMjAzMjc4MjksMTAuNDI0NzY2IDguNTA1ODk2MTksMTAuMTEzMjU0NSBMMTMuMzYzNjQwMiw1LjExNzI4NDM3IEMxMy41MDUxMjU1LDQuOTcxMjA0OTkgMTMuNzUyOTc3OSw0Ljk4MTg5NzIzIDEzLjg4MzkyMjIsNS4xMzk3MzYwMiBDMTQuMDE0ODY2NSw1LjI5NzU3NDgxIDE0LjAwNTI4MjEsNS41NzQwNzQ4OCAxMy44NjM3OTY3LDUuNzIwMTU0MjYgTDExLjExNTg2MDYsOC41NDg0MTE1MiBMMTMuODU4MDU3MSwxMS4yNjc2NDY5IEMxNC4wMjE3ODM1LDExLjQwMzE5ODIgMTQuMDQ4OTM2MywxMS43MDE0OTMyIDEzLjkxMjk4ODIsMTEuODcwOTg4OCBDMTMuNzc3MDQwMSwxMi4wNDA1MDQ5IDEzLjUwODI4OTcsMTIuMDQzNDE5MSAxMy4zNjkzOTgyLDExLjg3Njk0MDQgTDEwLjU3NTQ3MTUsOS4xMDYzOTg2MiBMOS4wMDYwNTI3NSwxMC43MTYxMjQ0IEM4LjQzNDk0MTk1LDExLjMwNDAzMzQgNy41NTMzMDI4NiwxMS4zMDUxNjIxIDYuOTgyNDY4LDEwLjcxNjEyNDQgTDUuNDI0NTI4NSw5LjEwNjM5ODYyIEwyLjYzMDYwMTgzLDExLjg3Njk0MDQgQzIuNDkxNzEwMzMsMTIuMDQzNDM5NyAyLjIyMjk1OTg4LDEyLjA0MDUyNTUgMi4wODcwMTE3OCwxMS44NzA5ODg4IEMxLjk1MTA2MzY3LDExLjcwMTQ5MzIgMS45NzgyMTY1LDExLjQwMzE5ODIgMi4xNDE5NDI5LDExLjI2NzY0NjkgTDQuODg0MTM5MzksOC41NDg0MTE1MiBMMi4xMzYyMDMyOCw1LjcyMDE1NDI2IEMyLjAyODcxNDE0LDUuNjE2MjI4MTYgMS45ODM1NTE0MSw1LjQzODk1NDUzIDIuMDI1OTkxNSw1LjI4NzQ5ODI1IEMyLjA2ODQxMzE5LDUuMTM2MDYyNDkgMi4xOTYwMjc4MSw1LjAxOTAyMjQ5IDIuMzM3NDIxMTksNS4wMDE4NjU2NiBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zKSIvPjwvc3ZnPg==);\n}\n\n.inputFieldPassword {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.inputFieldUrl {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xMCw1IEMxMCwzLjg5NTQzMDUgOS4xMDQ1Njk1LDMgOCwzIEM2Ljg5NTQzMDUsMyA2LDMuODk1NDMwNSA2LDUgTTQsMTAgTDQsMTEgTDYsMTEgTDYsMTAgQzYsOS40NDc3MTUyNSA1LjU1MjI4NDc1LDkgNSw5IEM0LjQ0NzcxNTI1LDkgNCw5LjQ0NzcxNTI1IDQsMTAgWiBNMTIsMTAgQzEyLDkuNDQ3NzE1MjUgMTEuNTUyMjg0Nyw5IDExLDkgQzEwLjQ0NzcxNTMsOSAxMCw5LjQ0NzcxNTI1IDEwLDEwIEwxMCwxMSBMMTIsMTEgTDEyLDEwIFogTTYsNiBMNiw1IEw0LDUgTDQsNiBDNCw2LjU1MjI4NDc1IDQuNDQ3NzE1MjUsNyA1LDcgQzUuNTUyMjg0NzUsNyA2LDYuNTUyMjg0NzUgNiw2IFogTTEwLDYgQzEwLDYuNTUyMjg0NzUgMTAuNDQ3NzE1Myw3IDExLDcgQzExLjU1MjI4NDcsNyAxMiw2LjU1MjI4NDc1IDEyLDYgTDEyLDUgTDEwLDUgTDEwLDYgWiBNNCw1IEM0LDIuNzkwODYxIDUuNzkwODYxLDEgOCwxIEMxMC4yMDkxMzksMSAxMiwyLjc5MDg2MSAxMiw1IEw0LDUgWiBNNCwxMSBMMTIsMTEgQzEyLDEzLjIwOTEzOSAxMC4yMDkxMzksMTUgOCwxNSBDNS43OTA4NjEsMTUgNCwxMy4yMDkxMzkgNCwxMSBaIE0xMCwxMSBMNiwxMSBDNiwxMi4xMDQ1Njk1IDYuODk1NDMwNSwxMyA4LDEzIEM5LjEwNDU2OTUsMTMgMTAsMTIuMTA0NTY5NSAxMCwxMSBaIE04LDExIEM3LjQ0NzcxNTI1LDExIDcsMTAuNTUyMjg0NyA3LDEwIEw3LDYgQzcsNS40NDc3MTUyNSA3LjQ0NzcxNTI1LDUgOCw1IEM4LjU1MjI4NDc1LDUgOSw1LjQ0NzcxNTI1IDksNiBMOSwxMCBDOSwxMC41NTIyODQ3IDguNTUyMjg0NzUsMTEgOCwxMSBaIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA4LjcwNyA2LjI5MykiLz48L3N2Zz4=);\n}\n\n.formLabel {\n}\n\n.hr {\n  border: 0;\n  border-top: 2px solid #e9ebeb;\n  margin: var(--basePadding) 0 -1px;\n  text-align: center;\n  overflow: visible;\n}\n\n.hr::before {\n  content: "or";\n  position: relative;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  text-transform: uppercase;\n  background-color: #fff;\n  color: var(--baseColor);\n  padding: 4px;\n  top: -11px;\n}\n\n.btnProvider {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.btnProvider::before {\n  content: "";\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  width: 32px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-position: left center;\n  top: -2px;\n  left: 14px;\n}\n\n.providerGoogle {\n  background-color: var(--providerColorGoogle);\n  border-color: var(--providerAltColorGoogle);\n}\n\n.providerGoogle:hover,\n.providerGoogle:focus {\n  background-color: var(--providerAltColorGoogle);\n}\n\n.providerGitHub {\n  background-color: var(--providerColorGitHub);\n  border-color: var(--providerAltColorGitHub);\n}\n\n.providerGitHub:hover,\n.providerGitHub:focus {\n  background-color: var(--providerAltColorGitHub);\n}\n\n.providerGitLab {\n  background-color: var(--providerColorGitLab);\n  border-color: var(--providerAltColorGitLab);\n}\n\n.providerGitLab:hover,\n.providerGitLab:focus {\n  background-color: var(--providerAltColorGitLab);\n}\n\n.providerBitbucket {\n  background-color: var(--providerColorBitbucket);\n  border-color: var(--providerAltColorBitbucket);\n}\n\n.providerBitbucket:hover,\n.providerBitbucket:focus {\n  background-color: var(--providerAltColorBitbucket);\n}\n\n.providerGoogle:before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEzIDEyIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNDg4IC0yKSI+ICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wLjY1MjczNDM3NSwzLjI5NTI4MjQ0IEMwLjIzNzk4NDM3NSw0LjEwNTgzMjA2IDIuODQyMTcwOTRlLTE0LDUuMDE2MDQ1OCAyLjg0MjE3MDk0ZS0xNCw1Ljk3OTM4OTMxIEMyLjg0MjE3MDk0ZS0xNCw2Ljk0MjczMjgyIDAuMjM3OTg0Mzc1LDcuODUyOTAwNzYgMC42NTI3MzQzNzUsOC42NjM0NTAzOCBDMS42NTkwNDY4NywxMC42MTY3MDIzIDMuNzI2MDkzNzUsMTEuOTU4Nzc4NiA2LjExOTUzMTI1LDExLjk1ODc3ODYgQzcuNzcxNzgxMjUsMTEuOTU4Nzc4NiA5LjE1ODg1OTM3LDExLjQyNzI1MTkgMTAuMTcyMDE1NiwxMC41MTA0NDI3IEMxMS4zMjc5MDYyLDkuNDY3MzU4NzggMTEuOTk0MjgxMiw3LjkzMjY0MTIyIDExLjk5NDI4MTIsNi4xMTIyNTk1NCBDMTEuOTk0MjgxMiw1LjYyMDYyNTk1IDExLjk1MzQ1MzEsNS4yNjE4NjI2IDExLjg2NTA5MzcsNC44ODk4MTY3OSBMNi4xMTk1MzEyNSw0Ljg4OTgxNjc5IEw2LjExOTUzMTI1LDcuMTA4ODA5MTYgTDkuNDkyMDQ2ODcsNy4xMDg4MDkxNiBDOS40MjQwNzgxMiw3LjY2MDI1OTU0IDkuMDU2OTA2MjUsOC40OTA3MzI4MiA4LjI0MDk1MzEyLDkuMDQ4Nzc4NjMgQzcuNzI0MjAzMTIsOS40MDA5MDA3NiA3LjAzMDY0MDYyLDkuNjQ2NzE3NTYgNi4xMTk1MzEyNSw5LjY0NjcxNzU2IEM0LjUwMTI2NTYyLDkuNjQ2NzE3NTYgMy4xMjc3ODEyNSw4LjYwMzY3OTM5IDIuNjM4MTcxODcsNy4xNjE5ODQ3MyBMMi42Mjg3MTIwNSw3LjE2Mjc2OTU5IEMyLjUwNTM0MTU4LDYuNzk3Mjk0NjggMi40MzQyMTg3NSw2LjM4MTEyMjg1IDIuNDM0MjE4NzUsNS45NzkzODkzMSBDMi40MzQyMTg3NSw1LjU2NzQ1MDM4IDIuNTA4OTg0MzgsNS4xNjg4Mzk2OSAyLjYzMTM3NSw0Ljc5Njc5Mzg5IEMzLjEyNzc4MTI1LDMuMzU1MDk5MjQgNC41MDEyNjU2MiwyLjMxMjAxNTI3IDYuMTE5NTMxMjUsMi4zMTIwMTUyNyBDNy4yNjg2MjUsMi4zMTIwMTUyNyA4LjA0Mzc1LDIuNzk3MDA3NjMgOC40ODU3MzQzNywzLjIwMjMwNTM0IEwxMC4yMTI3OTY5LDEuNTU0NjQxMjIgQzkuMTUyMTA5MzcsMC41OTEyOTc3MSA3Ljc3MTc4MTI1LDguODgxNzg0MmUtMTYgNi4xMTk1MzEyNSw4Ljg4MTc4NDJlLTE2IEMzLjcyNjA5Mzc1LDguODgxNzg0MmUtMTYgMS42NTkwNDY4NywxLjM0MjAzMDUzIDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgTDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSIvPiAgPC9nPjwvc3ZnPg==);\n}\n\n.providerGitHub:before {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.providerGitLab:before {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDE0IDEzIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTIpIj4gICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+ICAgIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBMNC40MjgwOTMzMyw0Ljk5NzI4MjU0IEw5LjU4MDA5MzM2LDQuOTk3MjgyNTQgTDcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBaIE03LjAwNDA5MzM2LDEyLjk0OTIzIEwwLjgxNzg5MzMzMyw0Ljk5NzI2OTE3IEw0LjQyODA5MzMzLDQuOTk3MjY5MTcgTDcuMDA0MDkzMzYsMTIuOTQ5MjMgWiBNMC44MTc4OTk5OTksNC45OTcyODkyMyBMNy4wMDQwOTk5OCwxMi45NDkyNSBMMC4yMjg4MzMzMzMsOC4wMTE4ODA4IEMwLjA0MTksNy44NzU2NzE1MiAtMC4wMzYzLDcuNjM0MjEyNyAwLjAzNTEsNy40MTM4MTcxMiBMMC44MTc4OTk5OTksNC45OTcyODkyMyBaIE0wLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIEwyLjM2OTM2NjY3LDAuMjA3OTA0NzE0IEMyLjQ0OTE2NjY3LC0wLjAzODUwMjM1ODggMi43OTY3NjY2NywtMC4wMzg1NjkyMjY1IDIuODc2NTY2NjcsMC4yMDc5MDQ3MTQgTDQuNDI4MSw0Ljk5NzI5NTkxIEwwLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIFogTTcuMDA0MDkzMzYsMTIuOTQ5MjMgTDkuNTgwMDkzMzYsNC45OTcyNjkxNyBMMTMuMTkwMjkzMyw0Ljk5NzI2OTE3IEw3LjAwNDA5MzM2LDEyLjk0OTIzIFogTTEzLjE5MDI5MzMsNC45OTcyODkyMyBMMTMuOTczMDkzMyw3LjQxMzgxNzEyIEMxNC4wNDQ0OTMzLDcuNjM0MjEyNyAxMy45NjYyOTM0LDcuODc1NjcxNTIgMTMuNzc5MzYsOC4wMTE4ODA4IEw3LjAwNDA5MzM2LDEyLjk0OTI1IEwxMy4xOTAyOTMzLDQuOTk3Mjg5MjMgWiBNMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIEw5LjU4MDA5MzM2LDQuOTk3Mjk1OTEgTDExLjEzMTYyNjcsMC4yMDc5MDQ3MTQgQzExLjIxMTQyNjcsLTAuMDM4NTY5MjI2NSAxMS41NTkwMjY3LC0wLjAzODUwMjM1ODggMTEuNjM4ODI2NywwLjIwNzkwNDcxNCBMMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMikiLz4gIDwvZz48L3N2Zz4=);\n}\n\n.providerBitbucket:before {\n  background-image: url(data:image/svg+xml;base64,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);\n}\n\n.callOut {\n  display: block;\n  padding: var(--basePadding);\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  color: var(--subduedColor);\n  text-align: center;\n}\n\n.callOut:after {\n  content: " \u2665";\n  transition: color 4s ease;\n}\n\n.callOut:hover:after {\n  color: red;\n}\n\n.callOut .netlifyLogo {\n  display: block;\n  margin: auto;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 8px;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4gIDxkZWZzPiAgICA8cmFkaWFsR3JhZGllbnQgaWQ9ImEiIGN5PSIwJSIgcj0iMTAwJSIgZng9IjUwJSIgZnk9IjAlIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDAgMSAtMS4xNTE4NSAwIC41IC0uNSkiPiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyMEM2QjciIG9mZnNldD0iMCUiLz4gICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNEQ5QUJGIiBvZmZzZXQ9IjEwMCUiLz4gICAgPC9yYWRpYWxHcmFkaWVudD4gIDwvZGVmcz4gIDxwYXRoIGZpbGw9InVybCgjYSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjk4MDYyMywxMS42MjYyMzc3IEMyMi44NzE3MTA3LDExLjUwNTEzMDYgMjIuNzM1NTcwNCwxMS4zOTc0Nzk4IDIyLjU3MjIwMjEsMTEuMzE2NzQxOCBDMjIuNTU4NTg4MSwxMS4zMTY3NDE4IDIyLjU0NDk3NCwxMS4yODk4MjkxIDIyLjUzMTM2LDExLjI3NjM3MjcgTDIzLjE3MTIxOTQsNy4zNjA1NzY2MSBDMjMuMTcxMjE5NCw3LjMzMzY2MzkyIDIzLjE4NDgzMzQsNy4zMjAyMDc1OCAyMy4xOTg0NDc1LDcuMzIwMjA3NTggTDIzLjIxMjA2MTUsNy4zMjAyMDc1OCBDMjMuMjEyMDYxNSw3LjMyMDIwNzU4IDIzLjIyNTY3NTUsNy4zMjAyMDc1OCAyMy4yMzkyODk2LDcuMzMzNjYzOTIgTDI2LjE2NjMwNiwxMC4yMjY3Nzc5IEMyNi4xNzk5MiwxMC4yNDAyMzQzIDI2LjE3OTkyLDEwLjI1MzY5MDYgMjYuMTc5OTIsMTAuMjY3MTQ2OSBDMjYuMTc5OTIsMTAuMjgwNjAzMyAyNi4xNjYzMDYsMTAuMjk0MDU5NiAyNi4xNTI2OTE5LDEwLjMwNzUxNiBMMjMuMDIxNDY1MSwxMS42Mzk2OTQgTDIzLjAwNzg1MSwxMS42Mzk2OTQgQzIyLjk5NDIzNywxMS42Mzk2OTQgMjIuOTk0MjM3LDExLjYzOTY5NCAyMi45ODA2MjMsMTEuNjI2MjM3NyBaIE0xNi4zNTA1NzM2LDkuNDU5NzM4MSBDMTYuMzIzMzQ1Myw5LjE5MDYxMjc0IDE2LjIyODA0NjMsOC45MjE0ODczOCAxNi4wNzgyOTA2LDguNjkyNzMwODMgQzE2LjA2NDY3NjUsOC42NzkyNzQ1NiAxNi4wNjQ2NzY1LDguNjUyMzYyMDIgMTYuMDc4MjkwNiw4LjYyNTQ0OTQ5IEwxOS4zNTkzMDEsMy41Mzg5ODAyMiBDMTkuMzU5MzAxLDMuNTI1NTIzOTUgMTkuMzcyOTE1MSwzLjUxMjA2NzY4IDE5LjM4NjUyOTMsMy41MTIwNjc2OCBDMTkuNDAwMTQzNCwzLjUxMjA2NzY4IDE5LjQwMDE0MzQsMy41MTIwNjc2OCAxOS40MTM3NTc2LDMuNTI1NTIzOTUgTDIyLjMyNzE4NTgsNi40MTg2MjE1NSBDMjIuMzQwOCw2LjQzMjA3NzgyIDIyLjM0MDgsNi40NDU1MzQwOSAyMi4zNDA4LDYuNDU4OTkwMzUgTDIxLjU3ODQwNzYsMTEuMTgyMTQwNCBDMjEuNTc4NDA3NiwxMS4yMDkwNTI5IDIxLjU2NDc5MzQsMTEuMjIyNTA5MiAyMS41NTExNzkzLDExLjIyMjUwOTIgQzIxLjM3NDE5NTMsMTEuMjc2MzM0MyAyMS4yMTA4MjU1LDExLjM1NzA3MTkgMjEuMDc0Njg0LDExLjQ2NDcyMiBDMjEuMDc0Njg0LDExLjQ3ODE3ODMgMjEuMDYxMDY5OCwxMS40NzgxNzgzIDIxLjAzMzg0MTUsMTEuNDc4MTc4MyBMMTYuMzc3ODAxOSw5LjUwMDEwNjkgQzE2LjM2NDE4NzgsOS40ODY2NTA2MyAxNi4zNTA1NzM2LDkuNDczMTk0MzcgMTYuMzUwNTczNiw5LjQ1OTczODEgWiBNMjYuOTgzMTkwNywxMS4wMjA3NjY5IEwzMS45Nzk1Nzg4LDE1Ljk3MjY2NCBDMzIuMDA2ODA3MSwxNS45ODYxMjAyIDMyLjAwNjgwNzEsMTYuMDI2NDg4OSAzMS45Nzk1Nzg4LDE2LjAyNjQ4ODkgTDMxLjk1MjM1MDUsMTYuMDUzNDAxNCBDMzEuOTUyMzUwNSwxNi4wNjY4NTc3IDMxLjkzODczNjQsMTYuMDY2ODU3NyAzMS45MTE1MDgxLDE2LjA2Njg1NzcgTDIzLjU1MjQyODMsMTIuNTI3ODY2IEMyMy41Mzg4MTQxLDEyLjUyNzg2NiAyMy41MjUyLDEyLjUwMDk1MzUgMjMuNTI1MiwxMi40ODc0OTczIEMyMy41MjUyLDEyLjQ3NDA0MSAyMy41Mzg4MTQxLDEyLjQ2MDU4NDggMjMuNTUyNDI4MywxMi40NDcxMjg2IEwyNi45NTU5NjI0LDExLjAwNzMxMDcgQzI2Ljk1NTk2MjQsMTEuMDA3MzEwNyAyNi45Njk1NzY1LDExLjAwNzMxMDcgMjYuOTgzMTkwNywxMS4wMjA3NjY5IFogTTIzLjEzMDQzNjMsMTMuMzg5MDg4MSBMMzEuMTQ5MTg1OCwxNi43ODAwNzYxIEMzMS4xNjI4LDE2Ljc5MzUzMjQgMzEuMTYyOCwxNi44MDY5ODg3IDMxLjE2MjgsMTYuODIwNDQ1IEMzMS4xNjI4LDE2LjgzMzkwMTMgMzEuMTYyOCwxNi44NDczNTc2IDMxLjE0OTE4NTgsMTYuODYwODEzOSBMMjYuNzEwOTY0NSwyMS4yNjEwMjQ1IEMyNi43MTA5NjQ1LDIxLjI3NDQ4MDggMjYuNjk3MzUwMywyMS4yNzQ0ODA4IDI2LjY3MDEyMiwyMS4yNzQ0ODA4IEwyMS44MjM0NzU0LDIwLjI2NTI1ODIgQzIxLjc5NjI0NywyMC4yNjUyNTgyIDIxLjc4MjYzMjksMjAuMjUxODAxOSAyMS43ODI2MzI5LDIwLjIyNDg4OTMgQzIxLjc0MTc5MDMsMTkuODQ4MTEyOCAyMS41NjQ4MDYsMTkuNTExNzA1MyAyMS4yNjUyOTQyLDE5LjI4Mjk0ODEgQzIxLjI1MTY4LDE5LjI2OTQ5MTggMjEuMjUxNjgsMTkuMjU2MDM1NSAyMS4yNTE2OCwxOS4yNDI1NzkyIEwyMi4xMDkzNzMxLDEzLjk4MTE2NTMgQzIyLjEwOTM3MzEsMTMuOTU0MjUyNyAyMi4xMzY2MDE0LDEzLjk0MDc5NjQgMjIuMTUwMjE1NiwxMy45NDA3OTY0IEMyMi41MzE0MTI1LDEzLjg4Njk3MTIgMjIuODU4MTUyNywxMy42OTg1ODMgMjMuMDc1OTc5NiwxMy40MDI1NDQ0IEMyMy4wODk1OTM3LDEzLjM4OTA4ODEgMjMuMTAzMjA3OSwxMy4zODkwODgxIDIzLjEzMDQzNjMsMTMuMzg5MDg4MSBaIE0xNi4xNDYzNzksMTAuNDI4Njg1OSBMMjAuNTMwMTMxNywxMi4yODU2NTMyIEMyMC41NDM3NDU5LDEyLjI5OTEwOTUgMjAuNTU3MzYsMTIuMzEyNTY1OCAyMC41NTczNiwxMi4zMzk0NzgzIEMyMC41NDM3NDU5LDEyLjQwNjc1OTggMjAuNTMwMTMxNywxMi40ODc0OTc1IDIwLjUzMDEzMTcsMTIuNTY4MjM1MiBMMjAuNTMwMTMxNywxMi42MzU1MTY2IEwyMC41MzAxMzE3LDEyLjY4OTM0MTcgQzIwLjUzMDEzMTcsMTIuNzAyNzk4IDIwLjUxNjUxNzYsMTIuNzE2MjU0MyAyMC41MDI5MDM0LDEyLjcyOTcxMDYgQzIwLjUwMjkwMzQsMTIuNzI5NzEwNiAxMC44Nzc3MDcyLDE2LjgzMzg3NzUgMTAuODY0MDkzLDE2LjgzMzg3NzUgQzEwLjg1MDQ3ODksMTYuODMzODc3NSAxMC44MzY4NjQ3LDE2LjgzMzg3NzUgMTAuODIzMjUwNiwxNi44MjA0MjEyIEMxMC44MDk2MzY1LDE2LjgwNjk2NDkgMTAuODA5NjM2NSwxNi43ODAwNTI0IDEwLjgyMzI1MDYsMTYuNzY2NTk2MSBMMTQuNDMwOTk3NCwxMS4xODIyMzc4IEMxNC40NDQ2MTE2LDExLjE2ODc4MTUgMTQuNDU4MjI1NywxMS4xNTUzMjUzIDE0LjQ4NTQ1NCwxMS4xNTUzMjUzIEMxNC41ODA3NTMsMTEuMTY4NzgxNSAxNC42NjI0Mzc4LDExLjE4MjIzNzggMTQuNzQ0MTIyNiwxMS4xODIyMzc4IEMxNS4yODg2ODgyLDExLjE4MjIzNzggMTUuNzkyNDExMywxMC45MTMxMTIxIDE2LjA5MTkyMjQsMTAuNDU1NTk4NCBDMTYuMTA1NTM2NSwxMC40NDIxNDIyIDE2LjExOTE1MDcsMTAuNDI4Njg1OSAxNi4xNDYzNzksMTAuNDI4Njg1OSBaIE0yMS41NTExNDI5LDIxLjE4MDI0MzMgTDI1LjgxMjM3MTcsMjIuMDU0OTA1MyBDMjUuODI1OTg1OSwyMi4wNTQ5MDUzIDI1LjgzOTYsMjIuMDY4MzYxNiAyNS44Mzk2LDIyLjEwODczMDcgQzI1LjgzOTYsMjIuMTIyMTg3IDI1LjgzOTYsMjIuMTM1NjQzMyAyNS44MjU5ODU5LDIyLjE0OTA5OTcgTDE5LjkxNzQ0NDksMjguMDAyNjA3MiBDMTkuOTE3NDQ0OSwyOC4wMTYwNjM2IDE5LjkwMzgzMDcsMjguMDE2MDYzNiAxOS44OTAyMTY2LDI4LjAxNjA2MzYgTDE5Ljg2Mjk4ODMsMjguMDE2MDYzNiBDMTkuODQ5Mzc0MSwyOC4wMDI2MDcyIDE5LjgzNTc2LDI3Ljk4OTE1MDkgMTkuODM1NzYsMjcuOTYyMjM4MiBMMjAuODU2ODIxMiwyMS42OTE1ODQxIEMyMC44NTY4MjEyLDIxLjY3ODEyNzggMjAuODcwNDM1NCwyMS42NTEyMTUxIDIwLjg4NDA0OTUsMjEuNjUxMjE1MSBDMjEuMTI5MTA0MiwyMS41NTcwMjA4IDIxLjMzMzMxNjUsMjEuMzk1NTQ0NyAyMS40OTY2ODYzLDIxLjE5MzY5OTYgQzIxLjUxMDMwMDQsMjEuMTkzNjk5NiAyMS41MjM5MTQ2LDIxLjE4MDI0MzMgMjEuNTUxMTQyOSwyMS4xODAyNDMzIFogTTE5LjA0NjE2NzksMjAuNjgyNDAzIEMxOS4xNTUwODE0LDIxLjA5OTU0ODcgMTkuNDU0NTkzMywyMS40NjI4NjkyIDE5Ljg2MzAxODcsMjEuNjI0MzQ0OSBDMTkuODkwMjQ3MSwyMS42Mzc4MDEyIDE5Ljg5MDI0NzEsMjEuNjY0NzEzOSAxOS44NjMwMTg3LDIxLjY2NDcxMzkgQzE5Ljg2MzAxODcsMjEuNjY0NzEzOSAxOC42MjQxMjgzLDI5LjIxMzcwNTQgMTguNjI0MTI4MywyOS4yMjcxNjE3IEwxOC4xODg0NzQ2LDI5LjY1Nzc2MzcgQzE4LjE4ODQ3NDYsMjkuNjcxMjIwMSAxOC4xNzQ4NjA0LDI5LjY3MTIyMDEgMTguMTYxMjQ2MiwyOS42NzEyMjAxIEMxOC4xNDc2MzIsMjkuNjcxMjIwMSAxOC4xNDc2MzIsMjkuNjcxMjIwMSAxOC4xMzQwMTc4LDI5LjY1Nzc2MzcgTDEwLjk0NTczMDYsMTkuMjY5NDkwMSBDMTAuOTMyMTE2NSwxOS4yNTYwMzM4IDEwLjkzMjExNjUsMTkuMjI5MTIxMiAxMC45NDU3MzA2LDE5LjIxNTY2NDkgQzEwLjk4NjU3MzIsMTkuMTYxODM5NiAxMS4wMTM4MDE1LDE5LjEwODAxNDQgMTEuMDU0NjQ0MSwxOS4wNDA3MzI4IEMxMS4wNjgyNTgzLDE5LjAyNzI3NjUgMTEuMDgxODcyNCwxOS4wMTM4MjAyIDExLjEwOTEwMDgsMTkuMDEzODIwMiBMMTkuMDA1MzI1NCwyMC42NDIwMzQxIEMxOS4wMzI1NTM3LDIwLjY1NTQ5MDQgMTkuMDQ2MTY3OSwyMC42Njg5NDY3IDE5LjA0NjE2NzksMjAuNjgyNDAzIFogTTExLjMxMzM2NDcsMTguMDk4NzI4NiBDMTEuMjg2MTM2NSwxOC4wOTg3Mjg2IDExLjI3MjUyMjQsMTguMDg1MjcyNCAxMS4yNzI1MjI0LDE4LjA1ODM1OTggQzExLjI3MjUyMjQsMTcuOTUwNzA5NiAxMS4yNDUyOTQxLDE3Ljg1NjUxNTcgMTEuMjMxNjgsMTcuNzQ4ODY1NCBDMTEuMjMxNjgsMTcuNzIxOTUyOSAxMS4yMzE2OCwxNy43MDg0OTY2IDExLjI1ODkwODIsMTcuNjk1MDQwMyBDMTEuMjU4OTA4MiwxNy42OTUwNDAzIDIwLjkzODU0NTksMTMuNTYzOTYzNSAyMC45NTIxNiwxMy41NjM5NjM1IEMyMC45NTIxNiwxMy41NjM5NjM1IDIwLjk2NTc3NDEsMTMuNTYzOTYzNSAyMC45NzkzODgyLDEzLjU3NzQxOTcgQzIxLjA0NzQ1ODgsMTMuNjQ0NzAxMSAyMS4xMDE5MTUzLDEzLjY4NTA2OTkgMjEuMTU2MzcxOCwxMy43MjU0Mzg4IEMyMS4xODM2LDEzLjcyNTQzODggMjEuMTgzNiwxMy43NTIzNTEzIDIxLjE4MzYsMTMuNzY1ODA3NiBMMjAuMzM5NTI0NywxOC45NDY0NzQxIEMyMC4zMzk1MjQ3LDE4Ljk3MzM4NjYgMjAuMzI1OTEwNiwxOC45ODY4NDI5IDIwLjI5ODY4MjQsMTguOTg2ODQyOSBDMTkuODM1ODAyNCwxOS4wMTM3NTU0IDE5LjQyNzM3ODgsMTkuMjgyODgxIDE5LjE5NTkzODgsMTkuNjg2NTY5MyBDMTkuMTgyMzI0NywxOS43MDAwMjU1IDE5LjE2ODcxMDYsMTkuNzEzNDgxOCAxOS4xNDE0ODI0LDE5LjcxMzQ4MTggTDExLjMxMzM2NDcsMTguMDk4NzI4NiBaIE03Ljg2ODk3NzU4LDE5LjE4ODcyOTEgQzcuOTA5ODIwMywxOS4yNTYwMTExIDcuOTUwNjYzMDMsMTkuMzA5ODM2NyA3Ljk5MTUwNTc2LDE5LjM2MzY2MjMgQzguMDA1MTIsMTkuMzc3MTE4NyA4LjAwNTEyLDE5LjM5MDU3NTEgOC4wMDUxMiwxOS4zOTA1NzUxIEw2LjEzOTk2ODc5LDIyLjI4MzcwMDcgQzYuMTI2MzU0NTUsMjIuMjk3MTU3MSA2LjExMjc0MDMsMjIuMzEwNjEzNSA2LjA5OTEyNjA2LDIyLjMxMDYxMzUgQzYuMDk5MTI2MDYsMjIuMzEwNjEzNSA2LjA4NTUxMTgyLDIyLjMxMDYxMzUgNi4wNzE4OTc1OCwyMi4yOTcxNTcxIEw0LjQyNDU3NDI0LDIwLjY2ODkzMjkgQzQuNDEwOTYsMjAuNjU1NDc2NSA0LjQxMDk2LDIwLjY0MjAyMDEgNC40MTA5NiwyMC42Mjg1NjM3IEM0LjQxMDk2LDIwLjYxNTEwNzMgNC40MjQ1NzQyNCwyMC42MDE2NTA5IDQuNDM4MTg4NDgsMjAuNjAxNjUwOSBMNy44MTQ1MjA2MSwxOS4xNjE4MTYzIEw3LjgyODEzNDg1LDE5LjE2MTgxNjMgQzcuODQxNzQ5MDksMTkuMTYxODE2MyA3Ljg1NTM2MzMzLDE5LjE3NTI3MjcgNy44Njg5Nzc1OCwxOS4xODg3MjkxIFogTTEwLjE4MzMxOTEsMTkuODYxNTU3OSBDMTAuMTk2OTMzMiwxOS44NjE1NTc5IDEwLjIxMDU0NzMsMTkuODc1MDE0MiAxMC4yMjQxNjE0LDE5Ljg4ODQ3MDYgTDE3LjQzOTYyOTQsMzAuMzU3NDg3OCBDMTcuNDUzMjQzNSwzMC4zNzA5NDQxIDE3LjQ1MzI0MzUsMzAuMzk3ODU2NyAxNy40Mzk2Mjk0LDMwLjQxMTMxMzEgTDE1Ljg2MDM5NDksMzEuOTg1NzAyNSBDMTUuODYwMzk0OSwzMS45OTkxNTg5IDE1Ljg0Njc4MDgsMzEuOTk5MTU4OSAxNS44MDU5Mzg2LDMxLjk4NTcwMjUgTDYuNzkzNDEwNTcsMjMuMDY0MTYyMiBDNi43Nzk3OTY0OCwyMy4wNTA3MDU4IDYuNzc5Nzk2NDgsMjMuMDIzNzkzMiA2LjgwNzAyNDY2LDIyLjk5Njg4MDYgTDguNzY3NDUzNzEsMTkuOTU1NzUyMiBDOC43ODEwNjc4LDE5Ljk0MjI5NTggOC43OTQ2ODE4OSwxOS45Mjg4Mzk1IDguODIxOTEwMDcsMTkuOTI4ODM5NSBDOS4wMjYxMjE0MywxOS45OTYxMjExIDkuMjE2NzE4NywyMC4wMjMwMzM4IDkuNDIwOTMwMDYsMjAuMDIzMDMzOCBDOS42Nzk1OTc3OCwyMC4wMjMwMzM4IDkuOTI0NjUxNDEsMTkuOTY5MjA4NSAxMC4xODMzMTkxLDE5Ljg2MTU1NzkgWiBNOC45OTg5MTg1NiwxNi40MDMyMzIyIEM4Ljk4NTMwNDM5LDE2LjQwMzIzMjIgOC45NzE2OTAyMiwxNi4zODk3NzU5IDguOTU4MDc2MDQsMTYuMzc2MzE5NiBMNS4wOTE2NTA2MywxMC43MzgxMzg4IEM1LjA3ODAzNjQ2LDEwLjcyNDY4MjUgNS4wNzgwMzY0NiwxMC42OTc3NyA1LjA5MTY1MDYzLDEwLjY4NDMxMzcgTDguNTYzMjY1LDcuMjM5NTA2MzMgQzguNTYzMjY1LDcuMjI2MDUwMDYgOC41NzY4NzkxNyw3LjIyNjA1MDA2IDguNjA0MTA3NTIsNy4yMjYwNTAwNiBDOC42MDQxMDc1Miw3LjIzOTUwNjMzIDEyLjcwMTk3MzksOC45NjE5MTAwMiAxMy4xNjQ4NTU4LDkuMTYzNzU0MiBDMTMuMTc4NDcsOS4xNzcyMTA0OCAxMy4xOTIwODQyLDkuMTkwNjY2NzYgMTMuMTkyMDg0Miw5LjIxNzU3OTMyIEMxMy4xNjQ4NTU4LDkuMzM4Njg1ODMgMTMuMTUxMjQxNiw5LjQ1OTc5MjM0IDEzLjE1MTI0MTYsOS41ODA4OTg4NCBDMTMuMTUxMjQxNiw5Ljk5ODA0MzQ5IDEzLjMxNDYxMTcsMTAuMzg4Mjc1NiAxMy42MDA1MDk0LDEwLjY4NDMxMzcgQzEzLjYxNDEyMzUsMTAuNjk3NzcgMTMuNjE0MTIzNSwxMC43MjQ2ODI1IDEzLjYwMDUwOTQsMTAuNzM4MTM4OCBMOS45NTE5MTA3NCwxNi4zODk3NzU5IEM5LjkzODI5NjU3LDE2LjQwMzIzMjIgOS45MjQ2ODIzOSwxNi40MTY2ODg1IDkuODk3NDU0MDUsMTYuNDE2Njg4NSBDOS43NDc2OTgxMywxNi4zNzYzMTk2IDkuNTg0MzI4MDQsMTYuMzQ5NDA3MSA5LjQzNDU3MjEzLDE2LjM0OTQwNzEgQzkuMjk4NDMwMzksMTYuMzQ5NDA3MSA5LjE0ODY3NDQ4LDE2LjM3NjMxOTYgOC45OTg5MTg1NiwxNi40MDMyMzIyIFogTTEzLjY2ODYwMTksOC4zNTY0MjAzNCBDMTMuNDkxNjE4Niw4LjI3NTY4MTk4IDkuMzUyOTMzMjQsNi41MjYzNTA4MyA5LjM1MjkzMzI0LDYuNTI2MzUwODMgQzkuMzM5MzE5MTQsNi41MTI4OTQ0NCA5LjMyNTcwNTA1LDYuNTEyODk0NDQgOS4zMzkzMTkxNCw2LjQ4NTk4MTY1IEM5LjMzOTMxOTE0LDYuNDcyNTI1MjYgOS4zMzkzMTkxNCw2LjQ1OTA2ODg2IDkuMzUyOTMzMjQsNi40NDU2MTI0NyBMMTUuODMzMjQzMiwwLjAxMzQ1NjM5MzUgQzE1LjgzMzI0MzIsMCAxNS44NDY4NTczLDAgMTUuODYwNDcxNCwwIEMxNS44NzQwODU1LDAgMTUuODc0MDg1NSwwIDE1Ljg4NzY5OTYsMC4wMTM0NTYzOTM1IEwxOC42Nzg1ODk0LDIuNzcyMDE3MDUgQzE4LjY5MjIwMzUsMi43ODU0NzM0NSAxOC42OTIyMDM1LDIuODEyMzg2MjMgMTguNjc4NTg5NCwyLjgyNTg0MjYzIEwxNS4zMTU5MDc2LDguMDMzNDY2OSBDMTUuMzAyMjkzNSw4LjA0NjkyMzI5IDE1LjI4ODY3OTQsOC4wNjAzNzk2OSAxNS4yNjE0NTEyLDguMDYwMzc5NjkgQzE1LjA4NDQ2NzksOC4wMDY1NTQxMSAxNC45MDc0ODQ3LDcuOTc5NjQxMzMgMTQuNzMwNTAxNCw3Ljk3OTY0MTMzIEMxNC4zNjI5MjA4LDcuOTc5NjQxMzMgMTMuOTk1MzQwMiw4LjExNDIwNTI2IDEzLjcwOTQ0NDIsOC4zNDI5NjM5NSBDMTMuNjk1ODMwMSw4LjM1NjQyMDM0IDEzLjY5NTgzMDEsOC4zNTY0MjAzNCAxMy42Njg2MDE5LDguMzU2NDIwMzQgWiBNNy43ODcyODk5NSwxNy4zMzE3NTExIEM3Ljc3MzY3NTgxLDE3LjM0NTIwNzQgNy43NjAwNjE2NywxNy4zNTg2NjM3IDcuNzQ2NDQ3NTIsMTcuMzU4NjYzNyBMMC4wNDA4NDI0Mjk4LDE1Ljc0MzkwOCBDMC4wMTM2MTQxNDMzLDE1Ljc0MzkwOCAwLDE1LjczMDQ1MTcgMCwxNS43MTY5OTU0IEMwLDE1LjcwMzUzOTEgMCwxNS42OTAwODI4IDAuMDEzNjE0MTQzMywxNS42NzY2MjY1IEw0LjMxNTY4MzQyLDExLjQyNDQzNjMgQzQuMzE1NjgzNDIsMTEuNDEwOTgwMSA0LjMyOTI5NzU2LDExLjQxMDk4MDEgNC4zNDI5MTE3MSwxMS40MTA5ODAxIEM0LjM3MDEzOTk5LDExLjQyNDQzNjMgNC4zNzAxMzk5OSwxMS40MjQ0MzYzIDQuMzgzNzU0MTMsMTEuNDM3ODkyNiBDNC4zODM3NTQxMywxMS40NTEzNDg5IDguMDczMTg2OTYsMTYuNzgwMDQyOSA4LjExNDAyOTM5LDE2LjgzMzg2ODEgQzguMTI3NjQzNTQsMTYuODQ3MzI0NCA4LjEyNzY0MzU0LDE2Ljg3NDIzNyA4LjExNDAyOTM5LDE2Ljg4NzY5MzMgQzcuOTkxNTAyMSwxNy4wMjIyNTYzIDcuODY4OTc0ODEsMTcuMTcwMjc1NSA3Ljc4NzI4OTk1LDE3LjMzMTc1MTEgWiBNNy4zNTE1NTc4MywxOC4yNDY3NDY0IEM3LjM3ODc4NTk0LDE4LjI0Njc0NjQgNy4zOTI0LDE4LjI2MDIwMjcgNy4zOTI0LDE4LjI4NzExNTEgQzcuMzkyNCwxOC4zMDA1NzEzIDcuMzc4Nzg1OTQsMTguMzE0MDI3NSA3LjM1MTU1NzgzLDE4LjM0MDkzOTkgTDMuNjM0OTIsMTkuOTE1MzE2NSBDMy42MzQ5MiwxOS45MTUzMTY1IDMuNjIxMzA1OTQsMTkuOTE1MzE2NSAzLjYwNzY5MTg4LDE5LjkwMTg2MDMgTDAuNjI2MjEzMTg1LDE2Ljk0MTQ5NDEgQzAuNjEyNTk5MTI3LDE2LjkyODAzNzggMC41OTg5ODUwNjksMTYuOTAxMTI1NCAwLjYxMjU5OTEyNywxNi44ODc2NjkyIEMwLjYyNjIxMzE4NSwxNi44NzQyMTMgMC42Mzk4MjcyNDMsMTYuODYwNzU2OCAwLjY2NzA1NTM1OSwxNi44NjA3NTY4IEw3LjM1MTU1NzgzLDE4LjI0Njc0NjQgWiIvPjwvc3ZnPg==);\n}\n\n.visuallyHidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.subheader {\n  margin-top: 2em;\n  border-top: 1px solid rgb(14, 30, 37);\n\n  h3 {\n    padding-top: 1em;\n    text-align: center;\n  }\n}\n'
                    ],
                    sourceRoot: ""
                }
            ]), n.default = o;
        }
    ]).default;
});

});
parcelRegister("8dWjV", function(module, exports) {
// shim for using process in browser
var $5fccc6d11b1c7fac$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5fccc6d11b1c7fac$var$cachedSetTimeout;
var $5fccc6d11b1c7fac$var$cachedClearTimeout;
function $5fccc6d11b1c7fac$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5fccc6d11b1c7fac$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        else $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        else $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    }
})();
function $5fccc6d11b1c7fac$var$runTimeout(fun) {
    if ($5fccc6d11b1c7fac$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedSetTimeout === $5fccc6d11b1c7fac$var$defaultSetTimout || !$5fccc6d11b1c7fac$var$cachedSetTimeout) && setTimeout) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5fccc6d11b1c7fac$var$runClearTimeout(marker) {
    if ($5fccc6d11b1c7fac$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedClearTimeout === $5fccc6d11b1c7fac$var$defaultClearTimeout || !$5fccc6d11b1c7fac$var$cachedClearTimeout) && clearTimeout) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5fccc6d11b1c7fac$var$queue = [];
var $5fccc6d11b1c7fac$var$draining = false;
var $5fccc6d11b1c7fac$var$currentQueue;
var $5fccc6d11b1c7fac$var$queueIndex = -1;
function $5fccc6d11b1c7fac$var$cleanUpNextTick() {
    if (!$5fccc6d11b1c7fac$var$draining || !$5fccc6d11b1c7fac$var$currentQueue) return;
    $5fccc6d11b1c7fac$var$draining = false;
    if ($5fccc6d11b1c7fac$var$currentQueue.length) $5fccc6d11b1c7fac$var$queue = $5fccc6d11b1c7fac$var$currentQueue.concat($5fccc6d11b1c7fac$var$queue);
    else $5fccc6d11b1c7fac$var$queueIndex = -1;
    if ($5fccc6d11b1c7fac$var$queue.length) $5fccc6d11b1c7fac$var$drainQueue();
}
function $5fccc6d11b1c7fac$var$drainQueue() {
    if ($5fccc6d11b1c7fac$var$draining) return;
    var timeout = $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$cleanUpNextTick);
    $5fccc6d11b1c7fac$var$draining = true;
    var len = $5fccc6d11b1c7fac$var$queue.length;
    while(len){
        $5fccc6d11b1c7fac$var$currentQueue = $5fccc6d11b1c7fac$var$queue;
        $5fccc6d11b1c7fac$var$queue = [];
        while(++$5fccc6d11b1c7fac$var$queueIndex < len)if ($5fccc6d11b1c7fac$var$currentQueue) $5fccc6d11b1c7fac$var$currentQueue[$5fccc6d11b1c7fac$var$queueIndex].run();
        $5fccc6d11b1c7fac$var$queueIndex = -1;
        len = $5fccc6d11b1c7fac$var$queue.length;
    }
    $5fccc6d11b1c7fac$var$currentQueue = null;
    $5fccc6d11b1c7fac$var$draining = false;
    $5fccc6d11b1c7fac$var$runClearTimeout(timeout);
}
$5fccc6d11b1c7fac$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5fccc6d11b1c7fac$var$queue.push(new $5fccc6d11b1c7fac$var$Item(fun, args));
    if ($5fccc6d11b1c7fac$var$queue.length === 1 && !$5fccc6d11b1c7fac$var$draining) $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$drainQueue);
};
// v8 likes predictible objects
function $5fccc6d11b1c7fac$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5fccc6d11b1c7fac$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5fccc6d11b1c7fac$var$process.title = "browser";
$5fccc6d11b1c7fac$var$process.browser = true;
$5fccc6d11b1c7fac$var$process.env = {};
$5fccc6d11b1c7fac$var$process.argv = [];
$5fccc6d11b1c7fac$var$process.version = ""; // empty string to avoid regexp issues
$5fccc6d11b1c7fac$var$process.versions = {};
function $5fccc6d11b1c7fac$var$noop() {}
$5fccc6d11b1c7fac$var$process.on = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.addListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.once = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.off = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeAllListeners = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.emit = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependOnceListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.listeners = function(name) {
    return [];
};
$5fccc6d11b1c7fac$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5fccc6d11b1c7fac$var$process.cwd = function() {
    return "/";
};
$5fccc6d11b1c7fac$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5fccc6d11b1c7fac$var$process.umask = function() {
    return 0;
};

});


// ----- IMPORTS -----
// utilities
const $a868c52a55140070$export$bef1f36f5486a6a3 = (x)=>console.log(x);
const $a868c52a55140070$export$3988ae62b71be9a3 = (x)=>document.querySelector(x);
const $a868c52a55140070$export$2774c37398bee8b2 = (x)=>document.querySelectorAll(x);


function $24d13f4ab4978ead$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $24d13f4ab4978ead$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $24d13f4ab4978ead$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $24d13f4ab4978ead$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $24d13f4ab4978ead$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $24d13f4ab4978ead$var$CREATED = 1;
var $24d13f4ab4978ead$var$MOUNTED = 2;
var $24d13f4ab4978ead$var$IDLE = 3;
var $24d13f4ab4978ead$var$MOVING = 4;
var $24d13f4ab4978ead$var$SCROLLING = 5;
var $24d13f4ab4978ead$var$DRAGGING = 6;
var $24d13f4ab4978ead$var$DESTROYED = 7;
var $24d13f4ab4978ead$var$STATES = {
    CREATED: $24d13f4ab4978ead$var$CREATED,
    MOUNTED: $24d13f4ab4978ead$var$MOUNTED,
    IDLE: $24d13f4ab4978ead$var$IDLE,
    MOVING: $24d13f4ab4978ead$var$MOVING,
    SCROLLING: $24d13f4ab4978ead$var$SCROLLING,
    DRAGGING: $24d13f4ab4978ead$var$DRAGGING,
    DESTROYED: $24d13f4ab4978ead$var$DESTROYED
};
function $24d13f4ab4978ead$var$empty(array) {
    array.length = 0;
}
function $24d13f4ab4978ead$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $24d13f4ab4978ead$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($24d13f4ab4978ead$var$slice(arguments, 1)));
}
var $24d13f4ab4978ead$var$nextTick = setTimeout;
var $24d13f4ab4978ead$var$noop = function noop() {};
function $24d13f4ab4978ead$var$raf(func) {
    return requestAnimationFrame(func);
}
function $24d13f4ab4978ead$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $24d13f4ab4978ead$var$isObject(subject) {
    return !$24d13f4ab4978ead$var$isNull(subject) && $24d13f4ab4978ead$var$typeOf("object", subject);
}
var $24d13f4ab4978ead$var$isArray = Array.isArray;
var $24d13f4ab4978ead$var$isFunction = $24d13f4ab4978ead$var$apply($24d13f4ab4978ead$var$typeOf, "function");
var $24d13f4ab4978ead$var$isString = $24d13f4ab4978ead$var$apply($24d13f4ab4978ead$var$typeOf, "string");
var $24d13f4ab4978ead$var$isUndefined = $24d13f4ab4978ead$var$apply($24d13f4ab4978ead$var$typeOf, "undefined");
function $24d13f4ab4978ead$var$isNull(subject) {
    return subject === null;
}
function $24d13f4ab4978ead$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $24d13f4ab4978ead$var$toArray(value) {
    return $24d13f4ab4978ead$var$isArray(value) ? value : [
        value
    ];
}
function $24d13f4ab4978ead$var$forEach(values, iteratee) {
    $24d13f4ab4978ead$var$toArray(values).forEach(iteratee);
}
function $24d13f4ab4978ead$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $24d13f4ab4978ead$var$push(array, items) {
    array.push.apply(array, $24d13f4ab4978ead$var$toArray(items));
    return array;
}
function $24d13f4ab4978ead$var$toggleClass(elm, classes, add) {
    if (elm) $24d13f4ab4978ead$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $24d13f4ab4978ead$var$addClass(elm, classes) {
    $24d13f4ab4978ead$var$toggleClass(elm, $24d13f4ab4978ead$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $24d13f4ab4978ead$var$append(parent, children) {
    $24d13f4ab4978ead$var$forEach(children, parent.appendChild.bind(parent));
}
function $24d13f4ab4978ead$var$before(nodes, ref) {
    $24d13f4ab4978ead$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $24d13f4ab4978ead$var$matches(elm, selector) {
    return $24d13f4ab4978ead$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $24d13f4ab4978ead$var$children(parent, selector) {
    var children2 = parent ? $24d13f4ab4978ead$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $24d13f4ab4978ead$var$matches(child, selector);
    }) : children2;
}
function $24d13f4ab4978ead$var$child(parent, selector) {
    return selector ? $24d13f4ab4978ead$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $24d13f4ab4978ead$var$ownKeys = Object.keys;
function $24d13f4ab4978ead$var$forOwn(object, iteratee, right) {
    if (object) (right ? $24d13f4ab4978ead$var$ownKeys(object).reverse() : $24d13f4ab4978ead$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $24d13f4ab4978ead$var$assign(object) {
    $24d13f4ab4978ead$var$slice(arguments, 1).forEach(function(source) {
        $24d13f4ab4978ead$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $24d13f4ab4978ead$var$merge(object) {
    $24d13f4ab4978ead$var$slice(arguments, 1).forEach(function(source) {
        $24d13f4ab4978ead$var$forOwn(source, function(value, key) {
            if ($24d13f4ab4978ead$var$isArray(value)) object[key] = value.slice();
            else if ($24d13f4ab4978ead$var$isObject(value)) object[key] = $24d13f4ab4978ead$var$merge({}, $24d13f4ab4978ead$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $24d13f4ab4978ead$var$omit(object, keys) {
    $24d13f4ab4978ead$var$forEach(keys || $24d13f4ab4978ead$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $24d13f4ab4978ead$var$removeAttribute(elms, attrs) {
    $24d13f4ab4978ead$var$forEach(elms, function(elm) {
        $24d13f4ab4978ead$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $24d13f4ab4978ead$var$setAttribute(elms, attrs, value) {
    if ($24d13f4ab4978ead$var$isObject(attrs)) $24d13f4ab4978ead$var$forOwn(attrs, function(value2, name) {
        $24d13f4ab4978ead$var$setAttribute(elms, name, value2);
    });
    else $24d13f4ab4978ead$var$forEach(elms, function(elm) {
        $24d13f4ab4978ead$var$isNull(value) || value === "" ? $24d13f4ab4978ead$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $24d13f4ab4978ead$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $24d13f4ab4978ead$var$isString(attrs) ? $24d13f4ab4978ead$var$addClass(elm, attrs) : $24d13f4ab4978ead$var$setAttribute(elm, attrs);
    parent && $24d13f4ab4978ead$var$append(parent, elm);
    return elm;
}
function $24d13f4ab4978ead$var$style(elm, prop, value) {
    if ($24d13f4ab4978ead$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$24d13f4ab4978ead$var$isNull(value)) elm.style[prop] = "" + value;
}
function $24d13f4ab4978ead$var$display(elm, display2) {
    $24d13f4ab4978ead$var$style(elm, "display", display2);
}
function $24d13f4ab4978ead$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $24d13f4ab4978ead$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $24d13f4ab4978ead$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $24d13f4ab4978ead$var$rect(target) {
    return target.getBoundingClientRect();
}
function $24d13f4ab4978ead$var$remove(nodes) {
    $24d13f4ab4978ead$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $24d13f4ab4978ead$var$parseHtml(html) {
    return $24d13f4ab4978ead$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $24d13f4ab4978ead$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $24d13f4ab4978ead$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $24d13f4ab4978ead$var$queryAll(parent, selector) {
    return selector ? $24d13f4ab4978ead$var$slice(parent.querySelectorAll(selector)) : [];
}
function $24d13f4ab4978ead$var$removeClass(elm, classes) {
    $24d13f4ab4978ead$var$toggleClass(elm, classes, false);
}
function $24d13f4ab4978ead$var$timeOf(e) {
    return e.timeStamp;
}
function $24d13f4ab4978ead$var$unit(value) {
    return $24d13f4ab4978ead$var$isString(value) ? value : value ? value + "px" : "";
}
var $24d13f4ab4978ead$var$PROJECT_CODE = "splide";
var $24d13f4ab4978ead$var$DATA_ATTRIBUTE = "data-" + $24d13f4ab4978ead$var$PROJECT_CODE;
function $24d13f4ab4978ead$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $24d13f4ab4978ead$var$PROJECT_CODE + "] " + (message || ""));
}
var $24d13f4ab4978ead$var$min = Math.min, $24d13f4ab4978ead$var$max = Math.max, $24d13f4ab4978ead$var$floor = Math.floor, $24d13f4ab4978ead$var$ceil = Math.ceil, $24d13f4ab4978ead$var$abs = Math.abs;
function $24d13f4ab4978ead$var$approximatelyEqual(x, y, epsilon) {
    return $24d13f4ab4978ead$var$abs(x - y) < epsilon;
}
function $24d13f4ab4978ead$var$between(number, x, y, exclusive) {
    var minimum = $24d13f4ab4978ead$var$min(x, y);
    var maximum = $24d13f4ab4978ead$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $24d13f4ab4978ead$var$clamp(number, x, y) {
    var minimum = $24d13f4ab4978ead$var$min(x, y);
    var maximum = $24d13f4ab4978ead$var$max(x, y);
    return $24d13f4ab4978ead$var$min($24d13f4ab4978ead$var$max(minimum, number), maximum);
}
function $24d13f4ab4978ead$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $24d13f4ab4978ead$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $24d13f4ab4978ead$var$format(string, replacements) {
    $24d13f4ab4978ead$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $24d13f4ab4978ead$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $24d13f4ab4978ead$var$ids = {};
function $24d13f4ab4978ead$var$uniqueId(prefix) {
    return "" + prefix + $24d13f4ab4978ead$var$pad($24d13f4ab4978ead$var$ids[prefix] = ($24d13f4ab4978ead$var$ids[prefix] || 0) + 1);
}
function $24d13f4ab4978ead$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $24d13f4ab4978ead$var$forEach(targets, function(target) {
            target && $24d13f4ab4978ead$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $24d13f4ab4978ead$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $24d13f4ab4978ead$export$d300dc1a2634364b = "mounted";
var $24d13f4ab4978ead$export$d8dac49b4532735a = "ready";
var $24d13f4ab4978ead$export$2aa493d7c3275167 = "move";
var $24d13f4ab4978ead$export$fe5802204b967f0d = "moved";
var $24d13f4ab4978ead$export$5adb665701eda1ce = "click";
var $24d13f4ab4978ead$export$92e3eae133acac4c = "active";
var $24d13f4ab4978ead$export$6bcbb81035c12cea = "inactive";
var $24d13f4ab4978ead$export$6a5b3445e4066a53 = "visible";
var $24d13f4ab4978ead$export$8c5c7a21d54563e9 = "hidden";
var $24d13f4ab4978ead$export$7f4701ac5e05e39f = "refresh";
var $24d13f4ab4978ead$export$db40ab7c0855fa5c = "updated";
var $24d13f4ab4978ead$export$7e019dae5103a285 = "resize";
var $24d13f4ab4978ead$export$d637eba1e9e28482 = "resized";
var $24d13f4ab4978ead$export$e84bf5065c9087ac = "drag";
var $24d13f4ab4978ead$export$8e9f636d2c722196 = "dragging";
var $24d13f4ab4978ead$export$90ea576bd3fdeb60 = "dragged";
var $24d13f4ab4978ead$export$49801896908b5e33 = "scroll";
var $24d13f4ab4978ead$export$ff8164bff3202b9 = "scrolled";
var $24d13f4ab4978ead$export$6cbac5b662a31e1b = "overflow";
var $24d13f4ab4978ead$export$88c4cf7419e470cd = "destroy";
var $24d13f4ab4978ead$export$8647f6b043e04e9d = "arrows:mounted";
var $24d13f4ab4978ead$export$d467f9343b961f75 = "arrows:updated";
var $24d13f4ab4978ead$export$bf89a4e4349c9778 = "pagination:mounted";
var $24d13f4ab4978ead$export$eb2019082ed6de0b = "pagination:updated";
var $24d13f4ab4978ead$export$84015c33508f94ec = "navigation:mounted";
var $24d13f4ab4978ead$export$23663268a31b79e2 = "autoplay:play";
var $24d13f4ab4978ead$export$185723258309b608 = "autoplay:playing";
var $24d13f4ab4978ead$export$16a1e4f3d0368265 = "autoplay:pause";
var $24d13f4ab4978ead$export$9f64346e17f0ec8e = "lazyload:loaded";
var $24d13f4ab4978ead$export$6d5af59619d10e6a = "sk";
var $24d13f4ab4978ead$export$f0af896383d5adff = "sh";
var $24d13f4ab4978ead$export$28dea85f216954dc = "ei";
function $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $24d13f4ab4978ead$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $24d13f4ab4978ead$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $24d13f4ab4978ead$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $24d13f4ab4978ead$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($24d13f4ab4978ead$export$88c4cf7419e470cd, binder.destroy);
    return $24d13f4ab4978ead$var$assign(binder, {
        bus: bus,
        on: on,
        off: $24d13f4ab4978ead$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $24d13f4ab4978ead$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $24d13f4ab4978ead$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $24d13f4ab4978ead$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $24d13f4ab4978ead$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $24d13f4ab4978ead$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $24d13f4ab4978ead$var$includes($24d13f4ab4978ead$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $24d13f4ab4978ead$export$efff0f5979573c99(func, duration) {
    var interval = $24d13f4ab4978ead$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $24d13f4ab4978ead$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $24d13f4ab4978ead$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $24d13f4ab4978ead$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $24d13f4ab4978ead$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($24d13f4ab4978ead$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $24d13f4ab4978ead$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $24d13f4ab4978ead$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($24d13f4ab4978ead$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $24d13f4ab4978ead$var$merge(options, reducedMotion) : $24d13f4ab4978ead$var$omit(options, $24d13f4ab4978ead$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $24d13f4ab4978ead$var$merge(options, opts);
        base && $24d13f4ab4978ead$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($24d13f4ab4978ead$var$CREATED)) Splide2.emit($24d13f4ab4978ead$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $24d13f4ab4978ead$var$ARROW = "Arrow";
var $24d13f4ab4978ead$var$ARROW_LEFT = $24d13f4ab4978ead$var$ARROW + "Left";
var $24d13f4ab4978ead$var$ARROW_RIGHT = $24d13f4ab4978ead$var$ARROW + "Right";
var $24d13f4ab4978ead$var$ARROW_UP = $24d13f4ab4978ead$var$ARROW + "Up";
var $24d13f4ab4978ead$var$ARROW_DOWN = $24d13f4ab4978ead$var$ARROW + "Down";
var $24d13f4ab4978ead$export$373e92e0788ff06e = "ltr";
var $24d13f4ab4978ead$export$850f7749a2909601 = "rtl";
var $24d13f4ab4978ead$export$97170d9824b89709 = "ttb";
var $24d13f4ab4978ead$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $24d13f4ab4978ead$var$ARROW_UP,
        $24d13f4ab4978ead$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $24d13f4ab4978ead$var$ARROW_DOWN,
        $24d13f4ab4978ead$var$ARROW_LEFT
    ]
};
function $24d13f4ab4978ead$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $24d13f4ab4978ead$export$850f7749a2909601 && !axisOnly ? 1 : direction === $24d13f4ab4978ead$export$97170d9824b89709 ? 0 : -1;
        return $24d13f4ab4978ead$var$ORIENTATION_MAP[prop] && $24d13f4ab4978ead$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $24d13f4ab4978ead$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $24d13f4ab4978ead$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $24d13f4ab4978ead$var$ROLE = "role";
var $24d13f4ab4978ead$var$TAB_INDEX = "tabindex";
var $24d13f4ab4978ead$var$DISABLED = "disabled";
var $24d13f4ab4978ead$var$ARIA_PREFIX = "aria-";
var $24d13f4ab4978ead$var$ARIA_CONTROLS = $24d13f4ab4978ead$var$ARIA_PREFIX + "controls";
var $24d13f4ab4978ead$var$ARIA_CURRENT = $24d13f4ab4978ead$var$ARIA_PREFIX + "current";
var $24d13f4ab4978ead$var$ARIA_SELECTED = $24d13f4ab4978ead$var$ARIA_PREFIX + "selected";
var $24d13f4ab4978ead$var$ARIA_LABEL = $24d13f4ab4978ead$var$ARIA_PREFIX + "label";
var $24d13f4ab4978ead$var$ARIA_LABELLEDBY = $24d13f4ab4978ead$var$ARIA_PREFIX + "labelledby";
var $24d13f4ab4978ead$var$ARIA_HIDDEN = $24d13f4ab4978ead$var$ARIA_PREFIX + "hidden";
var $24d13f4ab4978ead$var$ARIA_ORIENTATION = $24d13f4ab4978ead$var$ARIA_PREFIX + "orientation";
var $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION = $24d13f4ab4978ead$var$ARIA_PREFIX + "roledescription";
var $24d13f4ab4978ead$var$ARIA_LIVE = $24d13f4ab4978ead$var$ARIA_PREFIX + "live";
var $24d13f4ab4978ead$var$ARIA_BUSY = $24d13f4ab4978ead$var$ARIA_PREFIX + "busy";
var $24d13f4ab4978ead$var$ARIA_ATOMIC = $24d13f4ab4978ead$var$ARIA_PREFIX + "atomic";
var $24d13f4ab4978ead$var$ALL_ATTRIBUTES = [
    $24d13f4ab4978ead$var$ROLE,
    $24d13f4ab4978ead$var$TAB_INDEX,
    $24d13f4ab4978ead$var$DISABLED,
    $24d13f4ab4978ead$var$ARIA_CONTROLS,
    $24d13f4ab4978ead$var$ARIA_CURRENT,
    $24d13f4ab4978ead$var$ARIA_LABEL,
    $24d13f4ab4978ead$var$ARIA_LABELLEDBY,
    $24d13f4ab4978ead$var$ARIA_HIDDEN,
    $24d13f4ab4978ead$var$ARIA_ORIENTATION,
    $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION
];
var $24d13f4ab4978ead$var$CLASS_PREFIX = $24d13f4ab4978ead$var$PROJECT_CODE + "__";
var $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX = "is-";
var $24d13f4ab4978ead$export$93b21159ad85c843 = $24d13f4ab4978ead$var$PROJECT_CODE;
var $24d13f4ab4978ead$export$7738b09ac0a98952 = $24d13f4ab4978ead$var$CLASS_PREFIX + "track";
var $24d13f4ab4978ead$export$19cc2a5451235cae = $24d13f4ab4978ead$var$CLASS_PREFIX + "list";
var $24d13f4ab4978ead$export$8d922915837a38d3 = $24d13f4ab4978ead$var$CLASS_PREFIX + "slide";
var $24d13f4ab4978ead$export$2c1ba4a4f1aa4947 = $24d13f4ab4978ead$export$8d922915837a38d3 + "--clone";
var $24d13f4ab4978ead$export$e9ba7e444ba60a12 = $24d13f4ab4978ead$export$8d922915837a38d3 + "__container";
var $24d13f4ab4978ead$export$a26cbd955fecf11e = $24d13f4ab4978ead$var$CLASS_PREFIX + "arrows";
var $24d13f4ab4978ead$export$516e7d18e13a2dca = $24d13f4ab4978ead$var$CLASS_PREFIX + "arrow";
var $24d13f4ab4978ead$export$58ea3db24c33b76 = $24d13f4ab4978ead$export$516e7d18e13a2dca + "--prev";
var $24d13f4ab4978ead$export$4885afd7098a65c2 = $24d13f4ab4978ead$export$516e7d18e13a2dca + "--next";
var $24d13f4ab4978ead$export$cbf8e5a0ab95eda3 = $24d13f4ab4978ead$var$CLASS_PREFIX + "pagination";
var $24d13f4ab4978ead$export$52f2cca6a5eee805 = $24d13f4ab4978ead$export$cbf8e5a0ab95eda3 + "__page";
var $24d13f4ab4978ead$export$4c82dc32b1c4ace5 = $24d13f4ab4978ead$var$CLASS_PREFIX + "progress";
var $24d13f4ab4978ead$export$2c9b091c749f4409 = $24d13f4ab4978ead$export$4c82dc32b1c4ace5 + "__bar";
var $24d13f4ab4978ead$export$a29701deef84b825 = $24d13f4ab4978ead$var$CLASS_PREFIX + "toggle";
var $24d13f4ab4978ead$export$d9d247d51b430dbb = $24d13f4ab4978ead$export$a29701deef84b825 + "__play";
var $24d13f4ab4978ead$export$3529f201a419925b = $24d13f4ab4978ead$export$a29701deef84b825 + "__pause";
var $24d13f4ab4978ead$export$3e5381ee3fab8374 = $24d13f4ab4978ead$var$CLASS_PREFIX + "spinner";
var $24d13f4ab4978ead$export$bb78d7c200da8960 = $24d13f4ab4978ead$var$CLASS_PREFIX + "sr";
var $24d13f4ab4978ead$export$7761661e2d5b9388 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "initialized";
var $24d13f4ab4978ead$export$72d36ecf3758cb4b = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "active";
var $24d13f4ab4978ead$export$e423ac4972f5e196 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "prev";
var $24d13f4ab4978ead$export$457a2d20827a2779 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "next";
var $24d13f4ab4978ead$export$53ca4621bbab9a = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "visible";
var $24d13f4ab4978ead$export$d22ec4ccb7996ba2 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "loading";
var $24d13f4ab4978ead$export$b6f202a162a09100 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "focus-in";
var $24d13f4ab4978ead$export$cd908cd1dd625e29 = $24d13f4ab4978ead$var$STATUS_CLASS_PREFIX + "overflow";
var $24d13f4ab4978ead$export$49f9eaea10ebf193 = [
    $24d13f4ab4978ead$export$72d36ecf3758cb4b,
    $24d13f4ab4978ead$export$53ca4621bbab9a,
    $24d13f4ab4978ead$export$e423ac4972f5e196,
    $24d13f4ab4978ead$export$457a2d20827a2779,
    $24d13f4ab4978ead$export$d22ec4ccb7996ba2,
    $24d13f4ab4978ead$export$b6f202a162a09100,
    $24d13f4ab4978ead$export$cd908cd1dd625e29
];
var $24d13f4ab4978ead$export$ba41d43e4a419565 = {
    slide: $24d13f4ab4978ead$export$8d922915837a38d3,
    clone: $24d13f4ab4978ead$export$2c1ba4a4f1aa4947,
    arrows: $24d13f4ab4978ead$export$a26cbd955fecf11e,
    arrow: $24d13f4ab4978ead$export$516e7d18e13a2dca,
    prev: $24d13f4ab4978ead$export$58ea3db24c33b76,
    next: $24d13f4ab4978ead$export$4885afd7098a65c2,
    pagination: $24d13f4ab4978ead$export$cbf8e5a0ab95eda3,
    page: $24d13f4ab4978ead$export$52f2cca6a5eee805,
    spinner: $24d13f4ab4978ead$export$3e5381ee3fab8374
};
function $24d13f4ab4978ead$var$closest(from, selector) {
    if ($24d13f4ab4978ead$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($24d13f4ab4978ead$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $24d13f4ab4978ead$var$FRICTION = 5;
var $24d13f4ab4978ead$var$LOG_INTERVAL = 200;
var $24d13f4ab4978ead$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $24d13f4ab4978ead$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $24d13f4ab4978ead$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $24d13f4ab4978ead$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($24d13f4ab4978ead$export$7f4701ac5e05e39f, destroy);
        on($24d13f4ab4978ead$export$7f4701ac5e05e39f, setup);
        on($24d13f4ab4978ead$export$db40ab7c0855fa5c, update);
        bind(document, $24d13f4ab4978ead$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $24d13f4ab4978ead$var$toggleClass(root, $24d13f4ab4978ead$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $24d13f4ab4978ead$var$ALL_ATTRIBUTES.concat("style");
        $24d13f4ab4978ead$var$empty(slides);
        $24d13f4ab4978ead$var$removeClass(root, rootClasses);
        $24d13f4ab4978ead$var$removeClass(track, trackClasses);
        $24d13f4ab4978ead$var$removeAttribute([
            track,
            list
        ], attrs);
        $24d13f4ab4978ead$var$removeAttribute(root, completely ? attrs : [
            "style",
            $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $24d13f4ab4978ead$var$removeClass(root, rootClasses);
        $24d13f4ab4978ead$var$removeClass(track, trackClasses);
        rootClasses = getClasses($24d13f4ab4978ead$export$93b21159ad85c843);
        trackClasses = getClasses($24d13f4ab4978ead$export$7738b09ac0a98952);
        $24d13f4ab4978ead$var$addClass(root, rootClasses);
        $24d13f4ab4978ead$var$addClass(track, trackClasses);
        $24d13f4ab4978ead$var$setAttribute(root, $24d13f4ab4978ead$var$ARIA_LABEL, options.label);
        $24d13f4ab4978ead$var$setAttribute(root, $24d13f4ab4978ead$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $24d13f4ab4978ead$export$7738b09ac0a98952);
        list = $24d13f4ab4978ead$var$child(track, "." + $24d13f4ab4978ead$export$19cc2a5451235cae);
        $24d13f4ab4978ead$var$assert(track && list, "A track/list element is missing.");
        $24d13f4ab4978ead$var$push(slides, $24d13f4ab4978ead$var$children(list, "." + $24d13f4ab4978ead$export$8d922915837a38d3 + ":not(." + $24d13f4ab4978ead$export$2c1ba4a4f1aa4947 + ")"));
        $24d13f4ab4978ead$var$forOwn({
            arrows: $24d13f4ab4978ead$export$a26cbd955fecf11e,
            pagination: $24d13f4ab4978ead$export$cbf8e5a0ab95eda3,
            prev: $24d13f4ab4978ead$export$58ea3db24c33b76,
            next: $24d13f4ab4978ead$export$4885afd7098a65c2,
            bar: $24d13f4ab4978ead$export$2c9b091c749f4409,
            toggle: $24d13f4ab4978ead$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $24d13f4ab4978ead$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $24d13f4ab4978ead$var$uniqueId($24d13f4ab4978ead$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$24d13f4ab4978ead$var$getAttribute(root, $24d13f4ab4978ead$var$ROLE) && root.tagName !== "SECTION" && role) $24d13f4ab4978ead$var$setAttribute(root, $24d13f4ab4978ead$var$ROLE, role);
        $24d13f4ab4978ead$var$setAttribute(root, $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $24d13f4ab4978ead$var$setAttribute(list, $24d13f4ab4978ead$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $24d13f4ab4978ead$var$query(root, selector);
        return elm && $24d13f4ab4978ead$var$closest(elm, "." + $24d13f4ab4978ead$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $24d13f4ab4978ead$export$93b21159ad85c843 && $24d13f4ab4978ead$export$72d36ecf3758cb4b
        ];
    }
    return $24d13f4ab4978ead$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $24d13f4ab4978ead$export$e5a58a5ee5b54c22 = "slide";
var $24d13f4ab4978ead$export$f42383286ed1223d = "loop";
var $24d13f4ab4978ead$export$742b62a5690c060 = "fade";
function $24d13f4ab4978ead$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $24d13f4ab4978ead$var$getAttribute(slide, "style");
    var label = $24d13f4ab4978ead$var$getAttribute(slide, $24d13f4ab4978ead$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $24d13f4ab4978ead$var$child(slide, "." + $24d13f4ab4978ead$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $24d13f4ab4978ead$var$pad(index + 1);
            $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ROLE, pagination ? "tabpanel" : "group");
            $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_LABEL, label || $24d13f4ab4978ead$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $24d13f4ab4978ead$var$apply(emit, $24d13f4ab4978ead$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $24d13f4ab4978ead$var$apply(emit, $24d13f4ab4978ead$export$6d5af59619d10e6a, self));
        on([
            $24d13f4ab4978ead$export$fe5802204b967f0d,
            $24d13f4ab4978ead$export$f0af896383d5adff,
            $24d13f4ab4978ead$export$ff8164bff3202b9
        ], update);
        on($24d13f4ab4978ead$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($24d13f4ab4978ead$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $24d13f4ab4978ead$var$removeClass(slide, $24d13f4ab4978ead$export$49f9eaea10ebf193);
        $24d13f4ab4978ead$var$removeAttribute(slide, $24d13f4ab4978ead$var$ALL_ATTRIBUTES);
        $24d13f4ab4978ead$var$setAttribute(slide, "style", styles);
        $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_LABEL, $24d13f4ab4978ead$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_CONTROLS, controls);
        $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $24d13f4ab4978ead$var$removeAttribute(slide, $24d13f4ab4978ead$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $24d13f4ab4978ead$var$toggleClass(slide, $24d13f4ab4978ead$export$e423ac4972f5e196, index === curr - 1);
            $24d13f4ab4978ead$var$toggleClass(slide, $24d13f4ab4978ead$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $24d13f4ab4978ead$var$hasClass(slide, $24d13f4ab4978ead$export$72d36ecf3758cb4b)) {
            $24d13f4ab4978ead$var$toggleClass(slide, $24d13f4ab4978ead$export$72d36ecf3758cb4b, active);
            $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $24d13f4ab4978ead$export$92e3eae133acac4c : $24d13f4ab4978ead$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $24d13f4ab4978ead$var$MOVING,
            $24d13f4ab4978ead$var$SCROLLING
        ])) $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$ARIA_HIDDEN, hidden || "");
        $24d13f4ab4978ead$var$setAttribute($24d13f4ab4978ead$var$queryAll(slide, options.focusableNodes || ""), $24d13f4ab4978ead$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $24d13f4ab4978ead$var$setAttribute(slide, $24d13f4ab4978ead$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $24d13f4ab4978ead$var$hasClass(slide, $24d13f4ab4978ead$export$53ca4621bbab9a)) {
            $24d13f4ab4978ead$var$toggleClass(slide, $24d13f4ab4978ead$export$53ca4621bbab9a, visible);
            emit(visible ? $24d13f4ab4978ead$export$6a5b3445e4066a53 : $24d13f4ab4978ead$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $24d13f4ab4978ead$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $24d13f4ab4978ead$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($24d13f4ab4978ead$export$742b62a5690c060)) return isActive();
        var trackRect = $24d13f4ab4978ead$var$rect(Components.Elements.track);
        var slideRect = $24d13f4ab4978ead$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $24d13f4ab4978ead$var$floor(trackRect[left]) <= $24d13f4ab4978ead$var$ceil(slideRect[left]) && $24d13f4ab4978ead$var$floor(slideRect[right]) <= $24d13f4ab4978ead$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $24d13f4ab4978ead$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($24d13f4ab4978ead$export$f42383286ed1223d))) diff = $24d13f4ab4978ead$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $24d13f4ab4978ead$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($24d13f4ab4978ead$export$7f4701ac5e05e39f, destroy);
        on($24d13f4ab4978ead$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $24d13f4ab4978ead$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $24d13f4ab4978ead$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $24d13f4ab4978ead$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $24d13f4ab4978ead$var$forEach(items, function(slide) {
            if ($24d13f4ab4978ead$var$isString(slide)) slide = $24d13f4ab4978ead$var$parseHtml(slide);
            if ($24d13f4ab4978ead$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $24d13f4ab4978ead$var$before(slide, ref) : $24d13f4ab4978ead$var$append(list, slide);
                $24d13f4ab4978ead$var$addClass(slide, options.classes.slide);
                observeImages(slide, $24d13f4ab4978ead$var$apply(emit, $24d13f4ab4978ead$export$7e019dae5103a285));
            }
        });
        emit($24d13f4ab4978ead$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $24d13f4ab4978ead$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($24d13f4ab4978ead$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($24d13f4ab4978ead$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $24d13f4ab4978ead$var$isString(matcher) ? $24d13f4ab4978ead$var$matches(Slide2.slide, matcher) : $24d13f4ab4978ead$var$includes($24d13f4ab4978ead$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $24d13f4ab4978ead$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $24d13f4ab4978ead$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $24d13f4ab4978ead$export$efff0f5979573c99($24d13f4ab4978ead$var$apply(emit, $24d13f4ab4978ead$export$7e019dae5103a285)));
        on([
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f
        ], init);
        on($24d13f4ab4978ead$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $24d13f4ab4978ead$export$97170d9824b89709;
        $24d13f4ab4978ead$var$style(root, "maxWidth", $24d13f4ab4978ead$var$unit(options.width));
        $24d13f4ab4978ead$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $24d13f4ab4978ead$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $24d13f4ab4978ead$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $24d13f4ab4978ead$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $24d13f4ab4978ead$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($24d13f4ab4978ead$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $24d13f4ab4978ead$var$toggleClass(root, $24d13f4ab4978ead$export$cd908cd1dd625e29, overflow);
                emit($24d13f4ab4978ead$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $24d13f4ab4978ead$var$unit(padding[prop] || ($24d13f4ab4978ead$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $24d13f4ab4978ead$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $24d13f4ab4978ead$var$unit(options.height || $24d13f4ab4978ead$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $24d13f4ab4978ead$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $24d13f4ab4978ead$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $24d13f4ab4978ead$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $24d13f4ab4978ead$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $24d13f4ab4978ead$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $24d13f4ab4978ead$var$rect(Slide.slide)[resolve("right")];
            var left = $24d13f4ab4978ead$var$rect(list)[resolve("left")];
            return $24d13f4ab4978ead$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($24d13f4ab4978ead$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($24d13f4ab4978ead$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($24d13f4ab4978ead$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $24d13f4ab4978ead$var$MULTIPLIER = 2;
function $24d13f4ab4978ead$var$Clones(Splide2, Components2, options) {
    var event = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($24d13f4ab4978ead$export$7f4701ac5e05e39f, remount);
        on([
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $24d13f4ab4978ead$var$remove(clones);
        $24d13f4ab4978ead$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($24d13f4ab4978ead$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$24d13f4ab4978ead$var$push(slides, slides);
            $24d13f4ab4978ead$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $24d13f4ab4978ead$var$before(clone, slides[0].slide) : $24d13f4ab4978ead$var$append(Elements.list, clone);
                $24d13f4ab4978ead$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $24d13f4ab4978ead$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $24d13f4ab4978ead$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($24d13f4ab4978ead$export$f42383286ed1223d)) clones2 = 0;
        else if ($24d13f4ab4978ead$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $24d13f4ab4978ead$var$ceil($24d13f4ab4978ead$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $24d13f4ab4978ead$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $24d13f4ab4978ead$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $24d13f4ab4978ead$export$d300dc1a2634364b,
            $24d13f4ab4978ead$export$d637eba1e9e28482,
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($24d13f4ab4978ead$var$MOVING);
        emit($24d13f4ab4978ead$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($24d13f4ab4978ead$var$IDLE);
            emit($24d13f4ab4978ead$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($24d13f4ab4978ead$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $24d13f4ab4978ead$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($24d13f4ab4978ead$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($24d13f4ab4978ead$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($24d13f4ab4978ead$var$ceil($24d13f4ab4978ead$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $24d13f4ab4978ead$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $24d13f4ab4978ead$var$rect(list)[left] - $24d13f4ab4978ead$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22)) position = $24d13f4ab4978ead$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $24d13f4ab4978ead$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $24d13f4ab4978ead$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $24d13f4ab4978ead$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($24d13f4ab4978ead$export$f42383286ed1223d);
    var isSlide = Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22);
    var getNext = $24d13f4ab4978ead$var$apply(getAdjacent, false);
    var getPrev = $24d13f4ab4978ead$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f,
            $24d13f4ab4978ead$export$28dea85f216954dc
        ], init);
        on($24d13f4ab4978ead$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $24d13f4ab4978ead$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($24d13f4ab4978ead$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $24d13f4ab4978ead$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($24d13f4ab4978ead$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $24d13f4ab4978ead$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$24d13f4ab4978ead$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($24d13f4ab4978ead$var$between(0, dest, from, true) || $24d13f4ab4978ead$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $24d13f4ab4978ead$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $24d13f4ab4978ead$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $24d13f4ab4978ead$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $24d13f4ab4978ead$var$min(index, endIndex) : $24d13f4ab4978ead$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $24d13f4ab4978ead$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$24d13f4ab4978ead$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $24d13f4ab4978ead$var$MOVING,
            $24d13f4ab4978ead$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $24d13f4ab4978ead$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $24d13f4ab4978ead$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $24d13f4ab4978ead$var$SIZE = 40;
function $24d13f4ab4978ead$var$Arrows(Splide2, Components2, options) {
    var event = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($24d13f4ab4978ead$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $24d13f4ab4978ead$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $24d13f4ab4978ead$var$display(wrapper, enabled ? "" : "none");
            $24d13f4ab4978ead$var$addClass(wrapper, wrapperClasses = $24d13f4ab4978ead$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $24d13f4ab4978ead$var$setAttribute([
                    prev,
                    next
                ], $24d13f4ab4978ead$var$ARIA_CONTROLS, track.id);
                emit($24d13f4ab4978ead$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $24d13f4ab4978ead$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $24d13f4ab4978ead$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $24d13f4ab4978ead$var$removeAttribute([
            prev,
            next
        ], $24d13f4ab4978ead$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $24d13f4ab4978ead$export$d300dc1a2634364b,
            $24d13f4ab4978ead$export$fe5802204b967f0d,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f,
            $24d13f4ab4978ead$export$ff8164bff3202b9,
            $24d13f4ab4978ead$export$28dea85f216954dc
        ], update);
        bind(next, "click", $24d13f4ab4978ead$var$apply(go, ">"));
        bind(prev, "click", $24d13f4ab4978ead$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $24d13f4ab4978ead$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $24d13f4ab4978ead$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $24d13f4ab4978ead$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $24d13f4ab4978ead$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $24d13f4ab4978ead$var$SIZE + " " + $24d13f4ab4978ead$var$SIZE + '" width="' + $24d13f4ab4978ead$var$SIZE + '" height="' + $24d13f4ab4978ead$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $24d13f4ab4978ead$var$PATH) + '" />';
        return $24d13f4ab4978ead$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $24d13f4ab4978ead$var$setAttribute(prev, $24d13f4ab4978ead$var$ARIA_LABEL, prevLabel);
            $24d13f4ab4978ead$var$setAttribute(next, $24d13f4ab4978ead$var$ARIA_LABEL, nextLabel);
            emit($24d13f4ab4978ead$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $24d13f4ab4978ead$var$INTERVAL_DATA_ATTRIBUTE = $24d13f4ab4978ead$var$DATA_ATTRIBUTE + "-interval";
function $24d13f4ab4978ead$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $24d13f4ab4978ead$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $24d13f4ab4978ead$var$setAttribute(toggle, $24d13f4ab4978ead$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $24d13f4ab4978ead$export$2aa493d7c3275167,
            $24d13f4ab4978ead$export$49801896908b5e33,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($24d13f4ab4978ead$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($24d13f4ab4978ead$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($24d13f4ab4978ead$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $24d13f4ab4978ead$var$toggleClass(toggle, $24d13f4ab4978ead$export$72d36ecf3758cb4b, !stopped);
            $24d13f4ab4978ead$var$setAttribute(toggle, $24d13f4ab4978ead$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $24d13f4ab4978ead$var$style(bar, "width", rate * 100 + "%");
        emit($24d13f4ab4978ead$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$24d13f4ab4978ead$var$getAttribute(Slide.slide, $24d13f4ab4978ead$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $24d13f4ab4978ead$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($24d13f4ab4978ead$export$9f64346e17f0ec8e, $24d13f4ab4978ead$var$apply(toggle, true));
            on([
                $24d13f4ab4978ead$export$d300dc1a2634364b,
                $24d13f4ab4978ead$export$db40ab7c0855fa5c,
                $24d13f4ab4978ead$export$7f4701ac5e05e39f
            ], $24d13f4ab4978ead$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $24d13f4ab4978ead$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $24d13f4ab4978ead$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $24d13f4ab4978ead$var$apply(cover, false)
    };
}
var $24d13f4ab4978ead$var$BOUNCE_DIFF_THRESHOLD = 10;
var $24d13f4ab4978ead$var$BOUNCE_DURATION = 600;
var $24d13f4ab4978ead$var$FRICTION_FACTOR = 0.6;
var $24d13f4ab4978ead$var$BASE_VELOCITY = 1.5;
var $24d13f4ab4978ead$var$MIN_DURATION = 800;
function $24d13f4ab4978ead$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($24d13f4ab4978ead$export$2aa493d7c3275167, clear);
        on([
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $24d13f4ab4978ead$var$sign(destination) * size * $24d13f4ab4978ead$var$floor($24d13f4ab4978ead$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $24d13f4ab4978ead$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $24d13f4ab4978ead$var$max($24d13f4ab4978ead$var$abs(destination - from) / $24d13f4ab4978ead$var$BASE_VELOCITY, $24d13f4ab4978ead$var$MIN_DURATION);
        callback = onScrolled;
        interval = $24d13f4ab4978ead$export$46ad21b25b6dccf0(duration, onEnd, $24d13f4ab4978ead$var$apply(update, from, destination, noConstrain), 1);
        set($24d13f4ab4978ead$var$SCROLLING);
        emit($24d13f4ab4978ead$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($24d13f4ab4978ead$var$IDLE);
        callback && callback();
        emit($24d13f4ab4978ead$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $24d13f4ab4978ead$var$FRICTION_FACTOR;
            if ($24d13f4ab4978ead$var$abs(diff) < $24d13f4ab4978ead$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $24d13f4ab4978ead$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $24d13f4ab4978ead$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $24d13f4ab4978ead$var$POINTER_MOVE_EVENTS, $24d13f4ab4978ead$var$noop, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $24d13f4ab4978ead$var$POINTER_UP_EVENTS, $24d13f4ab4978ead$var$noop, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $24d13f4ab4978ead$var$POINTER_DOWN_EVENTS, onPointerDown, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $24d13f4ab4978ead$var$prevent);
        on([
            $24d13f4ab4978ead$export$d300dc1a2634364b,
            $24d13f4ab4978ead$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $24d13f4ab4978ead$var$MOVING,
                        $24d13f4ab4978ead$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $24d13f4ab4978ead$var$POINTER_MOVE_EVENTS, onPointerMove, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $24d13f4ab4978ead$var$POINTER_UP_EVENTS, onPointerUp, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $24d13f4ab4978ead$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($24d13f4ab4978ead$var$DRAGGING)) {
            state.set($24d13f4ab4978ead$var$DRAGGING);
            emit($24d13f4ab4978ead$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $24d13f4ab4978ead$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($24d13f4ab4978ead$export$8e9f636d2c722196);
                $24d13f4ab4978ead$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $24d13f4ab4978ead$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($24d13f4ab4978ead$var$DRAGGING)) {
            state.set($24d13f4ab4978ead$var$IDLE);
            emit($24d13f4ab4978ead$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $24d13f4ab4978ead$var$prevent(e);
        }
        unbind(target, $24d13f4ab4978ead$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $24d13f4ab4978ead$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $24d13f4ab4978ead$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($24d13f4ab4978ead$export$742b62a5690c060)) Controller.go(orient($24d13f4ab4978ead$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $24d13f4ab4978ead$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $24d13f4ab4978ead$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $24d13f4ab4978ead$var$abs(diffCoord(e)) > $24d13f4ab4978ead$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($24d13f4ab4978ead$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $24d13f4ab4978ead$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $24d13f4ab4978ead$var$sign(velocity) * $24d13f4ab4978ead$var$min($24d13f4ab4978ead$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $24d13f4ab4978ead$var$timeOf(e) - $24d13f4ab4978ead$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22) ? $24d13f4ab4978ead$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$24d13f4ab4978ead$var$matches(target2, "." + $24d13f4ab4978ead$export$52f2cca6a5eee805 + ", ." + $24d13f4ab4978ead$export$516e7d18e13a2dca) && (!noDrag || !$24d13f4ab4978ead$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $24d13f4ab4978ead$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $24d13f4ab4978ead$var$ARROW_RIGHT,
    Left: $24d13f4ab4978ead$var$ARROW_LEFT,
    Up: $24d13f4ab4978ead$var$ARROW_UP,
    Down: $24d13f4ab4978ead$var$ARROW_DOWN
};
function $24d13f4ab4978ead$var$normalizeKey(key) {
    key = $24d13f4ab4978ead$var$isString(key) ? key : key.key;
    return $24d13f4ab4978ead$var$NORMALIZATION_MAP[key] || key;
}
var $24d13f4ab4978ead$var$KEYBOARD_EVENT = "keydown";
function $24d13f4ab4978ead$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($24d13f4ab4978ead$export$db40ab7c0855fa5c, destroy);
        on($24d13f4ab4978ead$export$db40ab7c0855fa5c, init);
        on($24d13f4ab4978ead$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $24d13f4ab4978ead$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $24d13f4ab4978ead$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $24d13f4ab4978ead$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $24d13f4ab4978ead$var$normalizeKey(e);
            if (key === resolve($24d13f4ab4978ead$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($24d13f4ab4978ead$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE = $24d13f4ab4978ead$var$DATA_ATTRIBUTE + "-lazy";
var $24d13f4ab4978ead$var$SRCSET_DATA_ATTRIBUTE = $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $24d13f4ab4978ead$var$IMAGE_SELECTOR = "[" + $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE + "], [" + $24d13f4ab4978ead$var$SRCSET_DATA_ATTRIBUTE + "]";
function $24d13f4ab4978ead$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $24d13f4ab4978ead$export$fe5802204b967f0d,
        $24d13f4ab4978ead$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($24d13f4ab4978ead$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $24d13f4ab4978ead$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $24d13f4ab4978ead$var$queryAll(Slide.slide, $24d13f4ab4978ead$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $24d13f4ab4978ead$var$getAttribute(img, $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE);
                var srcset = $24d13f4ab4978ead$var$getAttribute(img, $24d13f4ab4978ead$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $24d13f4ab4978ead$var$child(parent, "." + className) || $24d13f4ab4978ead$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $24d13f4ab4978ead$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $24d13f4ab4978ead$var$addClass(data[1].slide, $24d13f4ab4978ead$export$d22ec4ccb7996ba2);
        bind(img, "load error", $24d13f4ab4978ead$var$apply(onLoad, data));
        $24d13f4ab4978ead$var$setAttribute(img, "src", $24d13f4ab4978ead$var$getAttribute(img, $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE));
        $24d13f4ab4978ead$var$setAttribute(img, "srcset", $24d13f4ab4978ead$var$getAttribute(img, $24d13f4ab4978ead$var$SRCSET_DATA_ATTRIBUTE));
        $24d13f4ab4978ead$var$removeAttribute(img, $24d13f4ab4978ead$var$SRC_DATA_ATTRIBUTE);
        $24d13f4ab4978ead$var$removeAttribute(img, $24d13f4ab4978ead$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $24d13f4ab4978ead$var$removeClass(Slide.slide, $24d13f4ab4978ead$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $24d13f4ab4978ead$var$remove(data[2]);
            $24d13f4ab4978ead$var$display(img, "");
            emit($24d13f4ab4978ead$export$9f64346e17f0ec8e, img, Slide);
            emit($24d13f4ab4978ead$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $24d13f4ab4978ead$var$apply($24d13f4ab4978ead$var$empty, entries),
        check: check
    };
}
function $24d13f4ab4978ead$var$Pagination(Splide2, Components2, options) {
    var event = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $24d13f4ab4978ead$export$db40ab7c0855fa5c,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f,
            $24d13f4ab4978ead$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $24d13f4ab4978ead$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $24d13f4ab4978ead$export$2aa493d7c3275167,
                $24d13f4ab4978ead$export$49801896908b5e33,
                $24d13f4ab4978ead$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($24d13f4ab4978ead$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $24d13f4ab4978ead$var$remove(placeholder ? $24d13f4ab4978ead$var$slice(list.children) : list);
            $24d13f4ab4978ead$var$removeClass(list, paginationClasses);
            $24d13f4ab4978ead$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $24d13f4ab4978ead$var$ceil(length / perPage);
        list = placeholder || $24d13f4ab4978ead$var$create("ul", classes.pagination, Elements.track.parentElement);
        $24d13f4ab4978ead$var$addClass(list, paginationClasses = $24d13f4ab4978ead$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $24d13f4ab4978ead$var$setAttribute(list, $24d13f4ab4978ead$var$ROLE, "tablist");
        $24d13f4ab4978ead$var$setAttribute(list, $24d13f4ab4978ead$var$ARIA_LABEL, i18n.select);
        $24d13f4ab4978ead$var$setAttribute(list, $24d13f4ab4978ead$var$ARIA_ORIENTATION, getDirection() === $24d13f4ab4978ead$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $24d13f4ab4978ead$var$create("li", null, list);
            var button = $24d13f4ab4978ead$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $24d13f4ab4978ead$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $24d13f4ab4978ead$var$apply(onKeydown, i));
            $24d13f4ab4978ead$var$setAttribute(li, $24d13f4ab4978ead$var$ROLE, "presentation");
            $24d13f4ab4978ead$var$setAttribute(button, $24d13f4ab4978ead$var$ROLE, "tab");
            $24d13f4ab4978ead$var$setAttribute(button, $24d13f4ab4978ead$var$ARIA_CONTROLS, controls.join(" "));
            $24d13f4ab4978ead$var$setAttribute(button, $24d13f4ab4978ead$var$ARIA_LABEL, $24d13f4ab4978ead$var$format(text, i + 1));
            $24d13f4ab4978ead$var$setAttribute(button, $24d13f4ab4978ead$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $24d13f4ab4978ead$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($24d13f4ab4978ead$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($24d13f4ab4978ead$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $24d13f4ab4978ead$var$focus(item.button);
            go(">" + nextPage);
            $24d13f4ab4978ead$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $24d13f4ab4978ead$var$removeClass(button, $24d13f4ab4978ead$export$72d36ecf3758cb4b);
            $24d13f4ab4978ead$var$removeAttribute(button, $24d13f4ab4978ead$var$ARIA_SELECTED);
            $24d13f4ab4978ead$var$setAttribute(button, $24d13f4ab4978ead$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $24d13f4ab4978ead$var$addClass(_button, $24d13f4ab4978ead$export$72d36ecf3758cb4b);
            $24d13f4ab4978ead$var$setAttribute(_button, $24d13f4ab4978ead$var$ARIA_SELECTED, true);
            $24d13f4ab4978ead$var$setAttribute(_button, $24d13f4ab4978ead$var$TAB_INDEX, "");
        }
        emit($24d13f4ab4978ead$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $24d13f4ab4978ead$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $24d13f4ab4978ead$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $24d13f4ab4978ead$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $24d13f4ab4978ead$export$f188226459c8a3ff(splide);
        event.on($24d13f4ab4978ead$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($24d13f4ab4978ead$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($24d13f4ab4978ead$export$5adb665701eda1ce, onClick);
        on($24d13f4ab4978ead$export$6d5af59619d10e6a, onKeydown);
        on([
            $24d13f4ab4978ead$export$d300dc1a2634364b,
            $24d13f4ab4978ead$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($24d13f4ab4978ead$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $24d13f4ab4978ead$var$setAttribute(Components2.Elements.list, $24d13f4ab4978ead$var$ARIA_ORIENTATION, options.direction === $24d13f4ab4978ead$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($24d13f4ab4978ead$var$includes($24d13f4ab4978ead$var$TRIGGER_KEYS, $24d13f4ab4978ead$var$normalizeKey(e))) {
            onClick(Slide);
            $24d13f4ab4978ead$var$prevent(e);
        }
    }
    return {
        setup: $24d13f4ab4978ead$var$apply(Components2.Media.set, {
            slideFocus: $24d13f4ab4978ead$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $24d13f4ab4978ead$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $24d13f4ab4978ead$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $24d13f4ab4978ead$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($24d13f4ab4978ead$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $24d13f4ab4978ead$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($24d13f4ab4978ead$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $24d13f4ab4978ead$var$SR_REMOVAL_DELAY = 90;
function $24d13f4ab4978ead$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $24d13f4ab4978ead$var$create("span", $24d13f4ab4978ead$export$bb78d7c200da8960);
    var interval = $24d13f4ab4978ead$export$46ad21b25b6dccf0($24d13f4ab4978ead$var$SR_REMOVAL_DELAY, $24d13f4ab4978ead$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $24d13f4ab4978ead$var$setAttribute(track, $24d13f4ab4978ead$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($24d13f4ab4978ead$export$23663268a31b79e2, $24d13f4ab4978ead$var$apply(disable, true));
            on($24d13f4ab4978ead$export$16a1e4f3d0368265, $24d13f4ab4978ead$var$apply(disable, false));
            on([
                $24d13f4ab4978ead$export$fe5802204b967f0d,
                $24d13f4ab4978ead$export$ff8164bff3202b9
            ], $24d13f4ab4978ead$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $24d13f4ab4978ead$var$setAttribute(track, $24d13f4ab4978ead$var$ARIA_BUSY, active);
        if (active) {
            $24d13f4ab4978ead$var$append(track, sr);
            interval.start();
        } else {
            $24d13f4ab4978ead$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $24d13f4ab4978ead$var$removeAttribute(track, [
            $24d13f4ab4978ead$var$ARIA_LIVE,
            $24d13f4ab4978ead$var$ARIA_ATOMIC,
            $24d13f4ab4978ead$var$ARIA_BUSY
        ]);
        $24d13f4ab4978ead$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $24d13f4ab4978ead$var$setAttribute(track, $24d13f4ab4978ead$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $24d13f4ab4978ead$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $24d13f4ab4978ead$var$Media,
    Direction: $24d13f4ab4978ead$var$Direction,
    Elements: $24d13f4ab4978ead$var$Elements,
    Slides: $24d13f4ab4978ead$var$Slides,
    Layout: $24d13f4ab4978ead$var$Layout,
    Clones: $24d13f4ab4978ead$var$Clones,
    Move: $24d13f4ab4978ead$var$Move,
    Controller: $24d13f4ab4978ead$var$Controller,
    Arrows: $24d13f4ab4978ead$var$Arrows,
    Autoplay: $24d13f4ab4978ead$var$Autoplay,
    Cover: $24d13f4ab4978ead$var$Cover,
    Scroll: $24d13f4ab4978ead$var$Scroll,
    Drag: $24d13f4ab4978ead$var$Drag,
    Keyboard: $24d13f4ab4978ead$var$Keyboard,
    LazyLoad: $24d13f4ab4978ead$var$LazyLoad,
    Pagination: $24d13f4ab4978ead$var$Pagination,
    Sync: $24d13f4ab4978ead$var$Sync,
    Wheel: $24d13f4ab4978ead$var$Wheel,
    Live: $24d13f4ab4978ead$var$Live
});
var $24d13f4ab4978ead$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $24d13f4ab4978ead$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $24d13f4ab4978ead$export$ba41d43e4a419565,
    i18n: $24d13f4ab4978ead$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $24d13f4ab4978ead$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2).on([
            $24d13f4ab4978ead$export$d300dc1a2634364b,
            $24d13f4ab4978ead$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $24d13f4ab4978ead$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $24d13f4ab4978ead$var$noop
    };
}
function $24d13f4ab4978ead$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $24d13f4ab4978ead$var$apply($24d13f4ab4978ead$var$style, list, "transition");
    var endCallback;
    function mount() {
        $24d13f4ab4978ead$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($24d13f4ab4978ead$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($24d13f4ab4978ead$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $24d13f4ab4978ead$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $24d13f4ab4978ead$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $24d13f4ab4978ead$export$7254cc27399e90bd($24d13f4ab4978ead$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $24d13f4ab4978ead$var$isString(target) ? $24d13f4ab4978ead$var$query(document, target) : target;
        $24d13f4ab4978ead$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $24d13f4ab4978ead$var$merge({
            label: $24d13f4ab4978ead$var$getAttribute(root, $24d13f4ab4978ead$var$ARIA_LABEL) || "",
            labelledby: $24d13f4ab4978ead$var$getAttribute(root, $24d13f4ab4978ead$var$ARIA_LABELLEDBY) || ""
        }, $24d13f4ab4978ead$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $24d13f4ab4978ead$var$merge(options, JSON.parse($24d13f4ab4978ead$var$getAttribute(root, $24d13f4ab4978ead$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $24d13f4ab4978ead$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($24d13f4ab4978ead$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $24d13f4ab4978ead$var$assert(state.is([
            $24d13f4ab4978ead$var$CREATED,
            $24d13f4ab4978ead$var$DESTROYED
        ]), "Already mounted!");
        state.set($24d13f4ab4978ead$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($24d13f4ab4978ead$export$742b62a5690c060) ? $24d13f4ab4978ead$var$Fade : $24d13f4ab4978ead$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $24d13f4ab4978ead$var$assign({}, $24d13f4ab4978ead$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $24d13f4ab4978ead$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $24d13f4ab4978ead$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($24d13f4ab4978ead$export$d300dc1a2634364b);
        $24d13f4ab4978ead$var$addClass(this.root, $24d13f4ab4978ead$export$7761661e2d5b9388);
        state.set($24d13f4ab4978ead$var$IDLE);
        this.emit($24d13f4ab4978ead$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($24d13f4ab4978ead$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($24d13f4ab4978ead$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($24d13f4ab4978ead$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($24d13f4ab4978ead$var$CREATED)) $24d13f4ab4978ead$export$f188226459c8a3ff(this).on($24d13f4ab4978ead$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $24d13f4ab4978ead$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($24d13f4ab4978ead$export$88c4cf7419e470cd);
            event.destroy();
            completely && $24d13f4ab4978ead$var$empty(this.splides);
            state.set($24d13f4ab4978ead$var$DESTROYED);
        }
        return this;
    };
    $24d13f4ab4978ead$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $24d13f4ab4978ead$export$24494c7438c070bf = $24d13f4ab4978ead$var$_Splide;
$24d13f4ab4978ead$export$24494c7438c070bf.defaults = {};
$24d13f4ab4978ead$export$24494c7438c070bf.STATES = $24d13f4ab4978ead$var$STATES;
var $24d13f4ab4978ead$var$CLASS_RENDERED = "is-rendered";
var $24d13f4ab4978ead$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $24d13f4ab4978ead$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $24d13f4ab4978ead$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $24d13f4ab4978ead$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $24d13f4ab4978ead$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $24d13f4ab4978ead$var$merge($24d13f4ab4978ead$export$f484e977a69c6ba6, defaults || {});
        $24d13f4ab4978ead$var$merge($24d13f4ab4978ead$var$merge(this.options, $24d13f4ab4978ead$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $24d13f4ab4978ead$var$assign({}, $24d13f4ab4978ead$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $24d13f4ab4978ead$var$uniqueId("splide");
        this.Style = new $24d13f4ab4978ead$var$Style(this.id, this.options);
        this.Direction = $24d13f4ab4978ead$var$Direction(null, null, this.options);
        $24d13f4ab4978ead$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $24d13f4ab4978ead$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $24d13f4ab4978ead$var$queryAll(root, "." + $24d13f4ab4978ead$export$2c1ba4a4f1aa4947);
        on($24d13f4ab4978ead$export$d300dc1a2634364b, function() {
            $24d13f4ab4978ead$var$remove($24d13f4ab4978ead$var$child(root, "style"));
        });
        $24d13f4ab4978ead$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $24d13f4ab4978ead$var$push(this.slides, this.contents.map(function(content, index) {
            content = $24d13f4ab4978ead$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $24d13f4ab4978ead$export$72d36ecf3758cb4b : "");
            $24d13f4ab4978ead$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $24d13f4ab4978ead$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $24d13f4ab4978ead$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $24d13f4ab4978ead$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $24d13f4ab4978ead$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $24d13f4ab4978ead$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $24d13f4ab4978ead$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $24d13f4ab4978ead$var$unit(padding[prop] || ($24d13f4ab4978ead$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $24d13f4ab4978ead$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $24d13f4ab4978ead$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $24d13f4ab4978ead$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $24d13f4ab4978ead$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $24d13f4ab4978ead$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($24d13f4ab4978ead$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $24d13f4ab4978ead$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $24d13f4ab4978ead$var$merge($24d13f4ab4978ead$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $24d13f4ab4978ead$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $24d13f4ab4978ead$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $24d13f4ab4978ead$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $24d13f4ab4978ead$export$93b21159ad85c843,
            $24d13f4ab4978ead$export$93b21159ad85c843 + "--" + options.type,
            $24d13f4ab4978ead$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $24d13f4ab4978ead$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $24d13f4ab4978ead$export$93b21159ad85c843 + "--nav",
            $24d13f4ab4978ead$export$72d36ecf3758cb4b,
            !this.config.hidden && $24d13f4ab4978ead$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $24d13f4ab4978ead$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $24d13f4ab4978ead$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $24d13f4ab4978ead$var$forOwn(styles, function(value, key) {
            style += " " + $24d13f4ab4978ead$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$24d13f4ab4978ead$var$push(slides, slides);
        $24d13f4ab4978ead$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $24d13f4ab4978ead$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $24d13f4ab4978ead$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $24d13f4ab4978ead$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $24d13f4ab4978ead$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $24d13f4ab4978ead$var$SIZE + " " + $24d13f4ab4978ead$var$SIZE + '" width="' + $24d13f4ab4978ead$var$SIZE + '" height="' + $24d13f4ab4978ead$var$SIZE + '"><path d="' + (this.options.arrowPath || $24d13f4ab4978ead$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/** Keeps track of raw listeners added to the base elements to avoid duplication */ const $fdef4c60a39fd294$var$ledger = new WeakMap();
function $fdef4c60a39fd294$var$editLedger(wanted, baseElement, callback, setup) {
    if (!wanted && !$fdef4c60a39fd294$var$ledger.has(baseElement)) return false;
    const elementMap = $fdef4c60a39fd294$var$ledger.get(baseElement) ?? new WeakMap();
    $fdef4c60a39fd294$var$ledger.set(baseElement, elementMap);
    const setups = elementMap.get(callback) ?? new Set();
    elementMap.set(callback, setups);
    const existed = setups.has(setup);
    if (wanted) setups.add(setup);
    else setups.delete(setup);
    return existed && wanted;
}
function $fdef4c60a39fd294$var$safeClosest(event, selector) {
    let target = event.target;
    if (target instanceof Text) target = target.parentElement;
    if (target instanceof Element && event.currentTarget instanceof Element) {
        // `.closest()` may match ancestors of `currentTarget` but we only need its children
        const closest = target.closest(selector);
        if (closest && event.currentTarget.contains(closest)) return closest;
    }
}
// This type isn't exported as a declaration, so it needs to be duplicated above
function $fdef4c60a39fd294$var$delegate(selector, type, callback, options = {}) {
    const { signal: signal, base: base = document } = options;
    if (signal?.aborted) return;
    // Don't pass `once` to `addEventListener` because it needs to be handled in `delegate-it`
    const { once: once, ...nativeListenerOptions } = options;
    // `document` should never be the base, it's just an easy way to define "global event listeners"
    const baseElement = base instanceof Document ? base.documentElement : base;
    // Handle the regular Element usage
    const capture = Boolean(typeof options === "object" ? options.capture : options);
    const listenerFn = (event)=>{
        const delegateTarget = $fdef4c60a39fd294$var$safeClosest(event, selector);
        if (delegateTarget) {
            const delegateEvent = Object.assign(event, {
                delegateTarget: delegateTarget
            });
            callback.call(baseElement, delegateEvent);
            if (once) {
                baseElement.removeEventListener(type, listenerFn, nativeListenerOptions);
                $fdef4c60a39fd294$var$editLedger(false, baseElement, callback, setup);
            }
        }
    };
    const setup = JSON.stringify({
        selector: selector,
        type: type,
        capture: capture
    });
    const isAlreadyListening = $fdef4c60a39fd294$var$editLedger(true, baseElement, callback, setup);
    if (!isAlreadyListening) baseElement.addEventListener(type, listenerFn, nativeListenerOptions);
    signal?.addEventListener("abort", ()=>{
        $fdef4c60a39fd294$var$editLedger(false, baseElement, callback, setup);
    });
}
var $fdef4c60a39fd294$export$2e2bcd8739ae039 = $fdef4c60a39fd294$var$delegate;



// This type isn't exported as a declaration, so it needs to be duplicated above
async function $3e4f7e8fe66510c0$var$oneEvent(selector, type, options = {}) {
    return new Promise((resolve)=>{
        options.once = true;
        if (options.signal?.aborted) resolve(undefined);
        options.signal?.addEventListener("abort", ()=>{
            resolve(undefined);
        });
        (0, $fdef4c60a39fd294$export$2e2bcd8739ae039)(selector, type, // @ts-expect-error Seems to work fine
        resolve, options);
    });
}
var $3e4f7e8fe66510c0$export$2e2bcd8739ae039 = $3e4f7e8fe66510c0$var$oneEvent;




/**
 * Tokenize input string.
 */ function $750664052680d915$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $750664052680d915$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $750664052680d915$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat($750664052680d915$var$escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $750664052680d915$export$ef7acd7185315e22(str, options) {
    return $750664052680d915$export$5b9bad9e403cf3d9($750664052680d915$export$98e6a39c04603d36(str, options), options);
}
function $750664052680d915$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $750664052680d915$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $750664052680d915$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $750664052680d915$export$71304158c7e35877(str, keys, options);
    return $750664052680d915$export$968e97c88708237a(re, keys, options);
}
function $750664052680d915$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $750664052680d915$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $750664052680d915$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $750664052680d915$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $750664052680d915$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $750664052680d915$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $750664052680d915$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $750664052680d915$var$stringToRegexp(path, keys, options) {
    return $750664052680d915$export$9a9303716def6456($750664052680d915$export$98e6a39c04603d36(path, options), keys, options);
}
function $750664052680d915$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($750664052680d915$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($750664052680d915$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $750664052680d915$var$escapeString(encode(token));
        else {
            var prefix = $750664052680d915$var$escapeString(encode(token.prefix));
            var suffix = $750664052680d915$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $750664052680d915$var$flags(options));
}
function $750664052680d915$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $750664052680d915$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $750664052680d915$var$arrayToRegexp(path, keys, options);
    return $750664052680d915$var$stringToRegexp(path, keys, options);
}


const $40ae24e1b9804100$export$b04d9b8d414ba5e8 = (t, e)=>String(t).toLowerCase().replace(/[\s/_.]+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "") || e || "", $40ae24e1b9804100$export$dc90482e4ef07afd = ({ hash: t } = {})=>window.location.pathname + window.location.search + (t ? window.location.hash : ""), $40ae24e1b9804100$export$c38a4311235454af = (t, e = {})=>{
    const n = {
        url: t = t || $40ae24e1b9804100$export$dc90482e4ef07afd({
            hash: !0
        }),
        random: Math.random(),
        source: "swup",
        ...e
    };
    window.history.pushState(n, "", t);
}, $40ae24e1b9804100$export$9dd2847e0d2d8b0 = (t = null, e = {})=>{
    t = t || $40ae24e1b9804100$export$dc90482e4ef07afd({
        hash: !0
    });
    const n = {
        ...window.history.state || {},
        url: t,
        random: Math.random(),
        source: "swup",
        ...e
    };
    window.history.replaceState(n, "", t);
}, $40ae24e1b9804100$export$b93d41a1bb659592 = (e, n, o, r)=>{
    const i = new AbortController;
    return r = {
        ...r,
        signal: i.signal
    }, (0, $fdef4c60a39fd294$export$2e2bcd8739ae039)(e, n, o, r), {
        destroy: ()=>i.abort()
    };
};
class $40ae24e1b9804100$export$18a2be9195644f38 extends URL {
    constructor(t, e = document.baseURI){
        super(t.toString(), e), Object.setPrototypeOf(this, $40ae24e1b9804100$export$18a2be9195644f38.prototype);
    }
    get url() {
        return this.pathname + this.search;
    }
    static fromElement(t) {
        const e = t.getAttribute("href") || t.getAttribute("xlink:href") || "";
        return new $40ae24e1b9804100$export$18a2be9195644f38(e);
    }
    static fromUrl(t) {
        return new $40ae24e1b9804100$export$18a2be9195644f38(t);
    }
}
const $40ae24e1b9804100$export$81336c211d5ff295 = (t, n)=>{
    try {
        return (0, $750664052680d915$export$4659b591c19bdf3d)(t, n);
    } catch (e) {
        throw new Error(`[swup] Error parsing path "${String(t)}":\n${String(e)}`);
    }
}, $40ae24e1b9804100$var$l = function(t, e = {}) {
    try {
        const o = this;
        function n(n) {
            const { status: i, url: s } = u;
            return Promise.resolve(u.text()).then(function(n) {
                if (500 === i) throw o.hooks.call("fetch:error", r, {
                    status: i,
                    response: u,
                    url: s
                }), new $40ae24e1b9804100$var$h(`Server error: ${s}`, {
                    status: i,
                    url: s
                });
                if (!n) throw new $40ae24e1b9804100$var$h(`Empty response: ${s}`, {
                    status: i,
                    url: s
                });
                const { url: c } = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(s), l = {
                    url: c,
                    html: n
                };
                return !r.cache.write || e.method && "GET" !== e.method || t !== c || o.cache.set(l.url, l), l;
            });
        }
        t = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(t).url;
        const { visit: r = o.visit } = e, i = {
            ...o.options.requestHeaders,
            ...e.headers
        }, s = e.timeout ?? o.options.timeout, c = new AbortController, { signal: l } = c;
        e = {
            ...e,
            headers: i,
            signal: l
        };
        let u, d = !1, m = null;
        s && s > 0 && (m = setTimeout(()=>{
            d = !0, c.abort("timeout");
        }, s));
        const f = function(n, i) {
            try {
                var s = Promise.resolve(o.hooks.call("fetch:request", r, {
                    url: t,
                    options: e
                }, (t, { url: e, options: n })=>fetch(e, n))).then(function(t) {
                    u = t, m && clearTimeout(m);
                });
            } catch (t) {
                return i(t);
            }
            return s && s.then ? s.then(void 0, i) : s;
        }(0, function(e) {
            if (d) throw o.hooks.call("fetch:timeout", r, {
                url: t
            }), new $40ae24e1b9804100$var$h(`Request timed out: ${t}`, {
                url: t,
                timedOut: d
            });
            if ("AbortError" === e?.name || l.aborted) throw new $40ae24e1b9804100$var$h(`Request aborted: ${t}`, {
                url: t,
                aborted: !0
            });
            throw e;
        });
        return Promise.resolve(f && f.then ? f.then(n) : n());
    } catch (p) {
        return Promise.reject(p);
    }
};
class $40ae24e1b9804100$var$h extends Error {
    constructor(t, e){
        super(t), this.url = void 0, this.status = void 0, this.aborted = void 0, this.timedOut = void 0, this.name = "FetchError", this.url = e.url, this.status = e.status, this.aborted = e.aborted || !1, this.timedOut = e.timedOut || !1;
    }
}
class $40ae24e1b9804100$var$u {
    constructor(t){
        this.swup = void 0, this.pages = new Map, this.swup = t;
    }
    get size() {
        return this.pages.size;
    }
    get all() {
        const t = new Map;
        return this.pages.forEach((e, n)=>{
            t.set(n, {
                ...e
            });
        }), t;
    }
    has(t) {
        return this.pages.has(this.resolve(t));
    }
    get(t) {
        const e = this.pages.get(this.resolve(t));
        return e ? {
            ...e
        } : e;
    }
    set(t, e) {
        t = this.resolve(t), e = {
            ...e,
            url: t
        }, this.pages.set(t, e), this.swup.hooks.callSync("cache:set", void 0, {
            page: e
        });
    }
    update(t, e) {
        t = this.resolve(t);
        const n = {
            ...this.get(t),
            ...e,
            url: t
        };
        this.pages.set(t, n);
    }
    delete(t) {
        this.pages.delete(this.resolve(t));
    }
    clear() {
        this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
    }
    prune(t) {
        this.pages.forEach((e, n)=>{
            t(n, e) && this.delete(n);
        });
    }
    resolve(t) {
        const { url: e } = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(t);
        return this.swup.resolveUrl(e);
    }
}
const $40ae24e1b9804100$export$2fa187e846a241c4 = (t, e = document)=>e.querySelector(t), $40ae24e1b9804100$export$dcd0d083aa86c355 = (t, e = document)=>Array.from(e.querySelectorAll(t)), $40ae24e1b9804100$export$bdd553fddd433dcb = ()=>new Promise((t)=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                t();
            });
        });
    });
function $40ae24e1b9804100$export$4369c812aac99591(t) {
    return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then;
}
function $40ae24e1b9804100$export$8586fbe018c72b76(t, e = []) {
    return new Promise((n, o)=>{
        const r = t(...e);
        $40ae24e1b9804100$export$4369c812aac99591(r) ? r.then(n, o) : n(r);
    });
}
function $40ae24e1b9804100$export$7d26bbb1236dafd6(t) {
    t = t || document.body, t?.getBoundingClientRect();
}
class $40ae24e1b9804100$var$w {
    constructor(t){
        this.swup = void 0, this.swupClasses = [
            "to-",
            "is-changing",
            "is-rendering",
            "is-popstate",
            "is-animating",
            "is-leaving"
        ], this.swup = t;
    }
    get selectors() {
        const { scope: t } = this.swup.visit.animation;
        return "containers" === t ? this.swup.visit.containers : "html" === t ? [
            "html"
        ] : Array.isArray(t) ? t : [];
    }
    get selector() {
        return this.selectors.join(",");
    }
    get targets() {
        return this.selector.trim() ? $40ae24e1b9804100$export$dcd0d083aa86c355(this.selector) : [];
    }
    add() {
        this.targets.forEach((t)=>t.classList.add(...[].slice.call(arguments)));
    }
    remove() {
        this.targets.forEach((t)=>t.classList.remove(...[].slice.call(arguments)));
    }
    clear() {
        this.targets.forEach((t)=>{
            const e = t.className.split(" ").filter((t)=>this.isSwupClass(t));
            t.classList.remove(...e);
        });
    }
    isSwupClass(t) {
        return this.swupClasses.some((e)=>t.startsWith(e));
    }
}
class $40ae24e1b9804100$var$y {
    constructor(t, e){
        this.id = void 0, this.state = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.animation = void 0, this.trigger = void 0, this.cache = void 0, this.history = void 0, this.scroll = void 0;
        const { to: n, from: o = t.currentPageUrl, hash: r, el: i, event: s } = e;
        this.id = Math.random(), this.state = 1, this.from = {
            url: o
        }, this.to = {
            url: n,
            hash: r
        }, this.containers = t.options.containers, this.animation = {
            animate: !0,
            wait: !1,
            name: void 0,
            native: t.options.native,
            scope: t.options.animationScope,
            selector: t.options.animationSelector
        }, this.trigger = {
            el: i,
            event: s
        }, this.cache = {
            read: t.options.cache,
            write: t.options.cache
        }, this.history = {
            action: "push",
            popstate: !1,
            direction: void 0
        }, this.scroll = {
            reset: !0,
            target: void 0
        };
    }
    advance(t) {
        this.state < t && (this.state = t);
    }
    abort() {
        this.state = 8;
    }
    get done() {
        return this.state >= 7;
    }
}
function $40ae24e1b9804100$var$P(t) {
    return new $40ae24e1b9804100$var$y(this, t);
}
const $40ae24e1b9804100$var$k = "undefined" != typeof Symbol ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function $40ae24e1b9804100$var$b(t, e, n) {
    if (!t.s) {
        if (n instanceof $40ae24e1b9804100$var$S) {
            if (!n.s) return void (n.o = $40ae24e1b9804100$var$b.bind(null, t, e));
            1 & e && (e = n.s), n = n.v;
        }
        if (n && n.then) return void n.then($40ae24e1b9804100$var$b.bind(null, t, e), $40ae24e1b9804100$var$b.bind(null, t, 2));
        t.s = e, t.v = n;
        const o = t.o;
        o && o(t);
    }
}
const $40ae24e1b9804100$var$S = /*#__PURE__*/ function() {
    function t() {}
    return t.prototype.then = function(e, n) {
        const o = new t, r = this.s;
        if (r) {
            const t = 1 & r ? e : n;
            if (t) {
                try {
                    $40ae24e1b9804100$var$b(o, 1, t(this.v));
                } catch (t) {
                    $40ae24e1b9804100$var$b(o, 2, t);
                }
                return o;
            }
            return this;
        }
        return this.o = function(t) {
            try {
                const r = t.v;
                1 & t.s ? $40ae24e1b9804100$var$b(o, 1, e ? e(r) : r) : n ? $40ae24e1b9804100$var$b(o, 1, n(r)) : $40ae24e1b9804100$var$b(o, 2, r);
            } catch (t) {
                $40ae24e1b9804100$var$b(o, 2, t);
            }
        }, o;
    }, t;
}();
function $40ae24e1b9804100$var$E(t) {
    return t instanceof $40ae24e1b9804100$var$S && 1 & t.s;
}
class $40ae24e1b9804100$var$U {
    constructor(t){
        this.swup = void 0, this.registry = new Map, this.hooks = [
            "animation:out:start",
            "animation:out:await",
            "animation:out:end",
            "animation:in:start",
            "animation:in:await",
            "animation:in:end",
            "animation:skip",
            "cache:clear",
            "cache:set",
            "content:replace",
            "content:scroll",
            "enable",
            "disable",
            "fetch:request",
            "fetch:error",
            "fetch:timeout",
            "history:popstate",
            "link:click",
            "link:self",
            "link:anchor",
            "link:newtab",
            "page:load",
            "page:view",
            "scroll:top",
            "scroll:anchor",
            "visit:start",
            "visit:transition",
            "visit:abort",
            "visit:end"
        ], this.swup = t, this.init();
    }
    init() {
        this.hooks.forEach((t)=>this.create(t));
    }
    create(t) {
        this.registry.has(t) || this.registry.set(t, new Map);
    }
    exists(t) {
        return this.registry.has(t);
    }
    get(t) {
        const e = this.registry.get(t);
        if (e) return e;
        console.error(`Unknown hook '${t}'`);
    }
    clear() {
        this.registry.forEach((t)=>t.clear());
    }
    on(t, e, n = {}) {
        const o = this.get(t);
        if (!o) return console.warn(`Hook '${t}' not found.`), ()=>{};
        const r = {
            ...n,
            id: o.size + 1,
            hook: t,
            handler: e
        };
        return o.set(e, r), ()=>this.off(t, e);
    }
    before(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            before: !0
        });
    }
    replace(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            replace: !0
        });
    }
    once(t, e, n = {}) {
        return this.on(t, e, {
            ...n,
            once: !0
        });
    }
    off(t, e) {
        const n = this.get(t);
        n && e ? n.delete(e) || console.warn(`Handler for hook '${t}' not found.`) : n && n.clear();
    }
    call(t, e, n, o) {
        try {
            const r = this, [i, s, a] = r.parseCallArgs(t, e, n, o), { before: c, handler: l, after: h } = r.getHandlers(t, a);
            return Promise.resolve(r.run(c, i, s)).then(function() {
                return Promise.resolve(r.run(l, i, s, !0)).then(function([e]) {
                    return Promise.resolve(r.run(h, i, s)).then(function() {
                        return r.dispatchDomEvent(t, i, s), e;
                    });
                });
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    callSync(t, e, n, o) {
        const [r, i, s] = this.parseCallArgs(t, e, n, o), { before: a, handler: c, after: l } = this.getHandlers(t, s);
        this.runSync(a, r, i);
        const [h] = this.runSync(c, r, i, !0);
        return this.runSync(l, r, i), this.dispatchDomEvent(t, r, i), h;
    }
    parseCallArgs(t, e, n, o) {
        return e instanceof $40ae24e1b9804100$var$y || "object" != typeof e && "function" != typeof n ? [
            e,
            n,
            o
        ] : [
            void 0,
            e,
            n
        ];
    }
    run(t, e, n, o = !1) {
        try {
            let r;
            const i = this;
            void 0 === e && (e = i.swup.visit);
            const s = [], a = function(t, e, n) {
                if ("function" == typeof t[$40ae24e1b9804100$var$k]) {
                    var o, r, i, s = t[$40ae24e1b9804100$var$k]();
                    if (function t(a) {
                        try {
                            for(; !((o = s.next()).done || n && n());)if ((a = e(o.value)) && a.then) {
                                if (!$40ae24e1b9804100$var$E(a)) return void a.then(t, i || (i = $40ae24e1b9804100$var$b.bind(null, r = new $40ae24e1b9804100$var$S, 2)));
                                a = a.v;
                            }
                            r ? $40ae24e1b9804100$var$b(r, 1, a) : r = a;
                        } catch (t) {
                            $40ae24e1b9804100$var$b(r || (r = new $40ae24e1b9804100$var$S), 2, t);
                        }
                    }(), s.return) {
                        var a = function(t) {
                            try {
                                o.done || s.return();
                            } catch (t) {}
                            return t;
                        };
                        if (r && r.then) return r.then(a, function(t) {
                            throw a(t);
                        });
                        a();
                    }
                    return r;
                }
                if (!("length" in t)) throw new TypeError("Object is not iterable");
                for(var c = [], l = 0; l < t.length; l++)c.push(t[l]);
                return function(t, e, n) {
                    var o, r, i = -1;
                    return function s(a) {
                        try {
                            for(; ++i < t.length && (!n || !n());)if ((a = e(i)) && a.then) {
                                if (!$40ae24e1b9804100$var$E(a)) return void a.then(s, r || (r = $40ae24e1b9804100$var$b.bind(null, o = new $40ae24e1b9804100$var$S, 2)));
                                a = a.v;
                            }
                            o ? $40ae24e1b9804100$var$b(o, 1, a) : o = a;
                        } catch (t) {
                            $40ae24e1b9804100$var$b(o || (o = new $40ae24e1b9804100$var$S), 2, t);
                        }
                    }(), o;
                }(c, function(t) {
                    return e(c[t]);
                }, n);
            }(t, function({ hook: t, handler: r, defaultHandler: a, once: c }) {
                if (!e?.done) return c && i.off(t, r), function(t, o) {
                    try {
                        var i = Promise.resolve($40ae24e1b9804100$export$8586fbe018c72b76(r, [
                            e,
                            n,
                            a
                        ])).then(function(t) {
                            s.push(t);
                        });
                    } catch (t) {
                        return o(t);
                    }
                    return i && i.then ? i.then(void 0, o) : i;
                }(0, function(e) {
                    if (o) throw e;
                    console.error(`Error in hook '${t}':`, e);
                });
            }, function() {
                return r;
            });
            return Promise.resolve(a && a.then ? a.then(function(t) {
                return r ? t : s;
            }) : r ? a : s);
        } catch (t) {
            return Promise.reject(t);
        }
    }
    runSync(t, e = this.swup.visit, n, o = !1) {
        const r = [];
        for (const { hook: i, handler: s, defaultHandler: a, once: c } of t)if (!e?.done) {
            c && this.off(i, s);
            try {
                const t = s(e, n, a);
                r.push(t), $40ae24e1b9804100$export$4369c812aac99591(t) && console.warn(`Swup will not await Promises in handler for synchronous hook '${i}'.`);
            } catch (t) {
                if (o) throw t;
                console.error(`Error in hook '${i}':`, t);
            }
        }
        return r;
    }
    getHandlers(t, e) {
        const n = this.get(t);
        if (!n) return {
            found: !1,
            before: [],
            handler: [],
            after: [],
            replaced: !1
        };
        const o = Array.from(n.values()), r = this.sortRegistrations, i = o.filter(({ before: t, replace: e })=>t && !e).sort(r), s = o.filter(({ replace: t })=>t).filter((t)=>!0).sort(r), a = o.filter(({ before: t, replace: e })=>!t && !e).sort(r), c = s.length > 0;
        let l = [];
        if (e && (l = [
            {
                id: 0,
                hook: t,
                handler: e
            }
        ], c)) {
            const n = s.length - 1, o = (t)=>{
                const n = s[t - 1];
                return n ? (e, r)=>n.handler(e, r, o(t - 1)) : e;
            };
            l = [
                {
                    id: 0,
                    hook: t,
                    handler: s[n].handler,
                    defaultHandler: o(n)
                }
            ];
        }
        return {
            found: !0,
            before: i,
            handler: l,
            after: a,
            replaced: c
        };
    }
    sortRegistrations(t, e) {
        return (t.priority ?? 0) - (e.priority ?? 0) || t.id - e.id || 0;
    }
    dispatchDomEvent(t, e, n) {
        if (e?.done) return;
        const o = {
            hook: t,
            args: n,
            visit: e || this.swup.visit
        };
        document.dispatchEvent(new CustomEvent("swup:any", {
            detail: o,
            bubbles: !0
        })), document.dispatchEvent(new CustomEvent(`swup:${t}`, {
            detail: o,
            bubbles: !0
        }));
    }
}
const $40ae24e1b9804100$var$C = (t)=>{
    if (t && "#" === t.charAt(0) && (t = t.substring(1)), !t) return null;
    const e = decodeURIComponent(t);
    let n = document.getElementById(t) || document.getElementById(e) || $40ae24e1b9804100$export$2fa187e846a241c4(`a[name='${CSS.escape(t)}']`) || $40ae24e1b9804100$export$2fa187e846a241c4(`a[name='${CSS.escape(e)}']`);
    return n || "top" !== t || (n = document.body), n;
}, $40ae24e1b9804100$var$$ = function({ elements: t, selector: e }) {
    try {
        if (!1 === e && !t) return Promise.resolve();
        let n = [];
        if (t) n = Array.from(t);
        else if (e && (n = $40ae24e1b9804100$export$dcd0d083aa86c355(e, document.body), !n.length)) return console.warn(`[swup] No elements found matching animationSelector \`${e}\``), Promise.resolve();
        const o = n.map((t)=>(function(t) {
                const { type: e, timeout: n, propCount: o } = function(t) {
                    const e = window.getComputedStyle(t), n = $40ae24e1b9804100$var$H(e, `${$40ae24e1b9804100$var$x}Delay`), o = $40ae24e1b9804100$var$H(e, `${$40ae24e1b9804100$var$x}Duration`), r = $40ae24e1b9804100$var$j(n, o), i = $40ae24e1b9804100$var$H(e, `${$40ae24e1b9804100$var$A}Delay`), s = $40ae24e1b9804100$var$H(e, `${$40ae24e1b9804100$var$A}Duration`), a = $40ae24e1b9804100$var$j(i, s), c = Math.max(r, a), l = c > 0 ? r > a ? $40ae24e1b9804100$var$x : $40ae24e1b9804100$var$A : null;
                    return {
                        type: l,
                        timeout: c,
                        propCount: l ? l === $40ae24e1b9804100$var$x ? o.length : s.length : 0
                    };
                }(t);
                return !(!e || !n) && new Promise((r)=>{
                    const i = `${e}end`, s = performance.now();
                    let a = 0;
                    const c = ()=>{
                        t.removeEventListener(i, l), r();
                    }, l = (e)=>{
                        if (e.target === t) {
                            if (!function(t) {
                                return [
                                    `${$40ae24e1b9804100$var$x}end`,
                                    `${$40ae24e1b9804100$var$A}end`
                                ].includes(t.type);
                            }(e)) throw new Error("Not a transition or animation event.");
                            (performance.now() - s) / 1e3 < e.elapsedTime || ++a >= o && c();
                        }
                    };
                    setTimeout(()=>{
                        a < o && c();
                    }, n + 1), t.addEventListener(i, l);
                });
            })(t));
        return o.filter(Boolean).length > 0 ? Promise.resolve(Promise.all(o)).then(function() {}) : (e && console.warn(`[swup] No CSS animation duration defined on elements matching \`${e}\``), Promise.resolve());
    } catch (t) {
        return Promise.reject(t);
    }
}, $40ae24e1b9804100$var$x = "transition", $40ae24e1b9804100$var$A = "animation";
function $40ae24e1b9804100$var$H(t, e) {
    return (t[e] || "").split(", ");
}
function $40ae24e1b9804100$var$j(t, e) {
    for(; t.length < e.length;)t = t.concat(t);
    return Math.max(...e.map((e, n)=>$40ae24e1b9804100$var$V(e) + $40ae24e1b9804100$var$V(t[n])));
}
function $40ae24e1b9804100$var$V(t) {
    return 1e3 * parseFloat(t);
}
const $40ae24e1b9804100$var$I = function(t, e = {}) {
    try {
        let a;
        const c = this;
        function s(s) {
            if (a) return s;
            c.navigating = !0, c.visit = t;
            const { el: l } = t.trigger;
            e.referrer = e.referrer || c.currentPageUrl, !1 === e.animate && (t.animation.animate = !1), t.animation.animate || c.classes.clear();
            const h = e.history || l?.getAttribute("data-swup-history") || void 0;
            h && [
                "push",
                "replace"
            ].includes(h) && (t.history.action = h);
            const u = e.animation || l?.getAttribute("data-swup-animation") || void 0;
            return u && (t.animation.name = u), "object" == typeof e.cache ? (t.cache.read = e.cache.read ?? t.cache.read, t.cache.write = e.cache.write ?? t.cache.write) : void 0 !== e.cache && (t.cache = {
                read: !!e.cache,
                write: !!e.cache
            }), delete e.cache, function(s, a) {
                try {
                    var l = function(s, a) {
                        try {
                            var l = Promise.resolve(c.hooks.call("visit:start", t, void 0)).then(function() {
                                function s() {
                                    if (!t.done) return Promise.resolve(c.hooks.call("visit:transition", t, void 0, function() {
                                        try {
                                            let n;
                                            function e(e) {
                                                return n ? e : (t.advance(4), Promise.resolve(c.animatePageOut(t)).then(function() {
                                                    function e() {
                                                        return Promise.resolve(c.animatePageIn(t)).then(function() {});
                                                    }
                                                    const n = function() {
                                                        if (t.animation.native && document.startViewTransition) return Promise.resolve(document.startViewTransition(function() {
                                                            try {
                                                                const e = c.renderPage;
                                                                return Promise.resolve(a).then(function(n) {
                                                                    return Promise.resolve(e.call(c, t, n));
                                                                });
                                                            } catch (t) {
                                                                return Promise.reject(t);
                                                            }
                                                        }).finished).then(function() {});
                                                        {
                                                            const e = c.renderPage;
                                                            return Promise.resolve(a).then(function(n) {
                                                                return Promise.resolve(e.call(c, t, n)).then(function() {});
                                                            });
                                                        }
                                                    }();
                                                    return n && n.then ? n.then(e) : e();
                                                }));
                                            }
                                            const o = function() {
                                                if (!t.animation.animate) return Promise.resolve(c.hooks.call("animation:skip", void 0)).then(function() {
                                                    const e = c.renderPage;
                                                    return Promise.resolve(a).then(function(o) {
                                                        return Promise.resolve(e.call(c, t, o)).then(function() {
                                                            n = 1;
                                                        });
                                                    });
                                                });
                                            }();
                                            return Promise.resolve(o && o.then ? o.then(e) : e(o));
                                        } catch (r) {
                                            return Promise.reject(r);
                                        }
                                    })).then(function() {
                                        if (!t.done) return Promise.resolve(c.hooks.call("visit:end", t, void 0, ()=>c.classes.clear())).then(function() {
                                            t.state = 7, c.navigating = !1, c.onVisitEnd && (c.onVisitEnd(), c.onVisitEnd = void 0);
                                        });
                                    });
                                }
                                t.state = 3;
                                const a = c.hooks.call("page:load", t, {
                                    options: e
                                }, function(t, e) {
                                    try {
                                        function n(t) {
                                            return e.page = t, e.cache = !!o, e.page;
                                        }
                                        let o;
                                        return t.cache.read && (o = c.cache.get(t.to.url)), Promise.resolve(o ? n(o) : Promise.resolve(c.fetchPage(t.to.url, e.options)).then(n));
                                    } catch (r) {
                                        return Promise.reject(r);
                                    }
                                });
                                if (a.then(({ html: e })=>{
                                    t.advance(5), t.to.html = e, t.to.document = (new DOMParser).parseFromString(e, "text/html");
                                }), !t.history.popstate) {
                                    const e = t.to.url + t.to.hash;
                                    "replace" === t.history.action || t.to.url === c.currentPageUrl ? $40ae24e1b9804100$export$9dd2847e0d2d8b0(e) : (c.currentHistoryIndex++, $40ae24e1b9804100$export$c38a4311235454af(e, {
                                        index: c.currentHistoryIndex
                                    }));
                                }
                                c.currentPageUrl = $40ae24e1b9804100$export$dc90482e4ef07afd(), t.history.popstate && c.classes.add("is-popstate"), t.animation.name && c.classes.add(`to-${$40ae24e1b9804100$export$b04d9b8d414ba5e8(t.animation.name)}`);
                                const l = function() {
                                    if (t.animation.wait) return Promise.resolve(a).then(function() {});
                                }();
                                return l && l.then ? l.then(s) : s();
                            });
                        } catch (t) {
                            return a(t);
                        }
                        return l && l.then ? l.then(void 0, a) : l;
                    }(0, function(e) {
                        e && !e?.aborted ? (t.state = 9, console.error(e), c.options.skipPopStateHandling = ()=>(window.location.assign(t.to.url + t.to.hash), !0), window.history.back()) : t.state = 8;
                    });
                } catch (t) {
                    return a(!0, t);
                }
                return l && l.then ? l.then(a.bind(null, !1), a.bind(null, !0)) : a(!1, l);
            }(0, function(e, n) {
                if (delete t.to.document, e) throw n;
                return n;
            });
        }
        const l = function() {
            if (c.navigating) return function() {
                if (!(c.visit.state >= 6)) return Promise.resolve(c.hooks.call("visit:abort", c.visit, void 0)).then(function() {
                    delete c.visit.to.document, c.visit.state = 8;
                });
                t.state = 2, c.onVisitEnd = ()=>c.performNavigation(t, e), a = 1;
            }();
        }();
        return Promise.resolve(l && l.then ? l.then(s) : s(l));
    } catch (h) {
        return Promise.reject(h);
    }
};
function $40ae24e1b9804100$var$L(t, e = {}, n = {}) {
    if ("string" != typeof t) throw new Error("swup.navigate() requires a URL parameter");
    if (this.shouldIgnoreVisit(t, {
        el: n.el,
        event: n.event
    })) return void window.location.assign(t);
    const { url: o, hash: r } = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(t), i = this.createVisit({
        ...n,
        to: o,
        hash: r
    });
    this.performNavigation(i, e);
}
const $40ae24e1b9804100$var$T = function(t) {
    try {
        const e = this;
        return Promise.resolve(e.hooks.call("animation:out:start", t, void 0, ()=>{
            e.classes.add("is-changing", "is-animating", "is-leaving");
        })).then(function() {
            return Promise.resolve(e.hooks.call("animation:out:await", t, {
                skip: !1
            }, (t, { skip: n })=>{
                if (!n) return e.awaitAnimations({
                    selector: t.animation.selector
                });
            })).then(function() {
                return Promise.resolve(e.hooks.call("animation:out:end", t, void 0)).then(function() {});
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $40ae24e1b9804100$var$q = function(t) {
    const e = t.to.document;
    if (!e) return !1;
    const n = e.querySelector("title")?.innerText || "";
    document.title = n;
    const o = $40ae24e1b9804100$export$dcd0d083aa86c355('[data-swup-persist]:not([data-swup-persist=""])'), r = t.containers.map((t)=>{
        const n = document.querySelector(t), o = e.querySelector(t);
        return n && o ? (n.replaceWith(o.cloneNode(!0)), !0) : (n || console.warn(`[swup] Container missing in current document: ${t}`), o || console.warn(`[swup] Container missing in incoming document: ${t}`), !1);
    }).filter(Boolean);
    return o.forEach((t)=>{
        const e = t.getAttribute("data-swup-persist"), n = $40ae24e1b9804100$export$2fa187e846a241c4(`[data-swup-persist="${e}"]`);
        n && n !== t && n.replaceWith(t);
    }), r.length === t.containers.length;
}, $40ae24e1b9804100$var$R = function(t) {
    const e = {
        behavior: "auto"
    }, { target: n, reset: o } = t.scroll, r = n ?? t.to.hash;
    let i = !1;
    return r && (i = this.hooks.callSync("scroll:anchor", t, {
        hash: r,
        options: e
    }, (t, { hash: e, options: n })=>{
        const o = this.getAnchorElement(e);
        return o && o.scrollIntoView(n), !!o;
    })), o && !i && (i = this.hooks.callSync("scroll:top", t, {
        options: e
    }, (t, { options: e })=>(window.scrollTo({
            top: 0,
            left: 0,
            ...e
        }), !0))), i;
}, $40ae24e1b9804100$var$N = function(t) {
    try {
        const e = this;
        if (t.done) return Promise.resolve();
        const n = e.hooks.call("animation:in:await", t, {
            skip: !1
        }, (t, { skip: n })=>{
            if (!n) return e.awaitAnimations({
                selector: t.animation.selector
            });
        });
        return Promise.resolve($40ae24e1b9804100$export$bdd553fddd433dcb()).then(function() {
            return Promise.resolve(e.hooks.call("animation:in:start", t, void 0, ()=>{
                e.classes.remove("is-animating");
            })).then(function() {
                return Promise.resolve(n).then(function() {
                    return Promise.resolve(e.hooks.call("animation:in:end", t, void 0)).then(function() {});
                });
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $40ae24e1b9804100$var$D = function(t, e) {
    try {
        const r = this;
        if (t.done) return Promise.resolve();
        t.advance(6);
        const { url: s } = e;
        return r.isSameResolvedUrl($40ae24e1b9804100$export$dc90482e4ef07afd(), s) || ($40ae24e1b9804100$export$9dd2847e0d2d8b0(s), r.currentPageUrl = $40ae24e1b9804100$export$dc90482e4ef07afd(), t.to.url = r.currentPageUrl), Promise.resolve(r.hooks.call("content:replace", t, {
            page: e
        }, (t, {})=>{
            if (r.classes.remove("is-leaving"), t.animation.animate && r.classes.add("is-rendering"), !r.replaceContent(t)) throw new Error("[swup] Container mismatch, aborting");
            t.animation.animate && (r.classes.add("is-changing", "is-animating", "is-rendering"), t.animation.name && r.classes.add(`to-${$40ae24e1b9804100$export$b04d9b8d414ba5e8(t.animation.name)}`));
        })).then(function() {
            return Promise.resolve(r.hooks.call("content:scroll", t, void 0, ()=>r.scrollToContent(t))).then(function() {
                return Promise.resolve(r.hooks.call("page:view", t, {
                    url: r.currentPageUrl,
                    title: document.title
                })).then(function() {});
            });
        });
    } catch (t) {
        return Promise.reject(t);
    }
}, $40ae24e1b9804100$var$M = function(t) {
    var e;
    if (e = t, Boolean(e?.isSwupPlugin)) {
        if (t.swup = this, !t._checkRequirements || t._checkRequirements()) return t._beforeMount && t._beforeMount(), t.mount(), this.plugins.push(t), this.plugins;
    } else console.error("Not a swup plugin instance", t);
};
function $40ae24e1b9804100$var$O(t) {
    const e = this.findPlugin(t);
    if (e) return e.unmount(), e._afterUnmount && e._afterUnmount(), this.plugins = this.plugins.filter((t)=>t !== e), this.plugins;
    console.error("No such plugin", e);
}
function $40ae24e1b9804100$var$W(t) {
    return this.plugins.find((e)=>e === t || e.name === t || e.name === `Swup${String(t)}`);
}
function $40ae24e1b9804100$var$B(t) {
    if ("function" != typeof this.options.resolveUrl) return console.warn("[swup] options.resolveUrl expects a callback function."), t;
    const e = this.options.resolveUrl(t);
    return e && "string" == typeof e ? e.startsWith("//") || e.startsWith("http") ? (console.warn("[swup] options.resolveUrl needs to return a relative url"), t) : e : (console.warn("[swup] options.resolveUrl needs to return a url"), t);
}
function $40ae24e1b9804100$var$_(t, e) {
    return this.resolveUrl(t) === this.resolveUrl(e);
}
const $40ae24e1b9804100$var$F = {
    animateHistoryBrowsing: !1,
    animationSelector: '[class*="transition-"]',
    animationScope: "html",
    cache: !0,
    containers: [
        "#swup"
    ],
    ignoreVisit: (t, { el: e } = {})=>!!e?.closest("[data-no-swup]"),
    linkSelector: "a[href]",
    linkToSelf: "scroll",
    native: !1,
    plugins: [],
    resolveUrl: (t)=>t,
    requestHeaders: {
        "X-Requested-With": "swup",
        Accept: "text/html, application/xhtml+xml"
    },
    skipPopStateHandling: (t)=>"swup" !== t.state?.source,
    timeout: 0
};
class $40ae24e1b9804100$export$2e2bcd8739ae039 {
    constructor(t = {}){
        this.version = "4.6.1", this.options = void 0, this.defaults = $40ae24e1b9804100$var$F, this.plugins = [], this.visit = void 0, this.cache = void 0, this.hooks = void 0, this.classes = void 0, this.currentPageUrl = $40ae24e1b9804100$export$dc90482e4ef07afd(), this.currentHistoryIndex = void 0, this.clickDelegate = void 0, this.navigating = !1, this.onVisitEnd = void 0, this.use = $40ae24e1b9804100$var$M, this.unuse = $40ae24e1b9804100$var$O, this.findPlugin = $40ae24e1b9804100$var$W, this.log = ()=>{}, this.navigate = $40ae24e1b9804100$var$L, this.performNavigation = $40ae24e1b9804100$var$I, this.createVisit = $40ae24e1b9804100$var$P, this.delegateEvent = $40ae24e1b9804100$export$b93d41a1bb659592, this.fetchPage = $40ae24e1b9804100$var$l, this.awaitAnimations = $40ae24e1b9804100$var$$, this.renderPage = $40ae24e1b9804100$var$D, this.replaceContent = $40ae24e1b9804100$var$q, this.animatePageIn = $40ae24e1b9804100$var$N, this.animatePageOut = $40ae24e1b9804100$var$T, this.scrollToContent = $40ae24e1b9804100$var$R, this.getAnchorElement = $40ae24e1b9804100$var$C, this.getCurrentUrl = $40ae24e1b9804100$export$dc90482e4ef07afd, this.resolveUrl = $40ae24e1b9804100$var$B, this.isSameResolvedUrl = $40ae24e1b9804100$var$_, this.options = {
            ...this.defaults,
            ...t
        }, this.handleLinkClick = this.handleLinkClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.cache = new $40ae24e1b9804100$var$u(this), this.classes = new $40ae24e1b9804100$var$w(this), this.hooks = new $40ae24e1b9804100$var$U(this), this.visit = this.createVisit({
            to: ""
        }), this.currentHistoryIndex = window.history.state?.index ?? 1, this.enable();
    }
    enable() {
        try {
            const t = this, { linkSelector: e } = t.options;
            return t.clickDelegate = t.delegateEvent(e, "click", t.handleLinkClick), window.addEventListener("popstate", t.handlePopState), t.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), t.options.native = t.options.native && !!document.startViewTransition, t.options.plugins.forEach((e)=>t.use(e)), "swup" !== window.history.state?.source && $40ae24e1b9804100$export$9dd2847e0d2d8b0(null, {
                index: t.currentHistoryIndex
            }), Promise.resolve($40ae24e1b9804100$export$bdd553fddd433dcb()).then(function() {
                return Promise.resolve(t.hooks.call("enable", void 0, void 0, ()=>{
                    const e = document.documentElement;
                    e.classList.add("swup-enabled"), e.classList.toggle("swup-native", t.options.native);
                })).then(function() {});
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    destroy() {
        try {
            const t = this;
            return t.clickDelegate.destroy(), window.removeEventListener("popstate", t.handlePopState), t.cache.clear(), t.options.plugins.forEach((e)=>t.unuse(e)), Promise.resolve(t.hooks.call("disable", void 0, void 0, ()=>{
                const t = document.documentElement;
                t.classList.remove("swup-enabled"), t.classList.remove("swup-native");
            })).then(function() {
                t.hooks.clear();
            });
        } catch (t) {
            return Promise.reject(t);
        }
    }
    shouldIgnoreVisit(t, { el: e, event: n } = {}) {
        const { origin: o, url: r, hash: i } = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(t);
        return o !== window.location.origin || !(!e || !this.triggerWillOpenNewWindow(e)) || !!this.options.ignoreVisit(r + i, {
            el: e,
            event: n
        });
    }
    handleLinkClick(t) {
        const e = t.delegateTarget, { href: n, url: o, hash: r } = $40ae24e1b9804100$export$18a2be9195644f38.fromElement(e);
        if (this.shouldIgnoreVisit(n, {
            el: e,
            event: t
        })) return;
        if (this.navigating && o === this.visit.to.url) return void t.preventDefault();
        const s = this.createVisit({
            to: o,
            hash: r,
            el: e,
            event: t
        });
        t.metaKey || t.ctrlKey || t.shiftKey || t.altKey ? this.hooks.callSync("link:newtab", s, {
            href: n
        }) : 0 === t.button && this.hooks.callSync("link:click", s, {
            el: e,
            event: t
        }, ()=>{
            const e = s.from.url ?? "";
            t.preventDefault(), o && o !== e ? this.isSameResolvedUrl(o, e) || this.performNavigation(s) : r ? this.hooks.callSync("link:anchor", s, {
                hash: r
            }, ()=>{
                $40ae24e1b9804100$export$9dd2847e0d2d8b0(o + r), this.scrollToContent(s);
            }) : this.hooks.callSync("link:self", s, void 0, ()=>{
                "navigate" === this.options.linkToSelf ? this.performNavigation(s) : ($40ae24e1b9804100$export$9dd2847e0d2d8b0(o), this.scrollToContent(s));
            });
        });
    }
    handlePopState(t) {
        const e = t.state?.url ?? window.location.href;
        if (this.options.skipPopStateHandling(t)) return;
        if (this.isSameResolvedUrl($40ae24e1b9804100$export$dc90482e4ef07afd(), this.currentPageUrl)) return;
        const { url: n, hash: r } = $40ae24e1b9804100$export$18a2be9195644f38.fromUrl(e), i = this.createVisit({
            to: n,
            hash: r,
            event: t
        });
        i.history.popstate = !0;
        const s = t.state?.index ?? 0;
        s && s !== this.currentHistoryIndex && (i.history.direction = s - this.currentHistoryIndex > 0 ? "forwards" : "backwards", this.currentHistoryIndex = s), i.animation.animate = !1, i.scroll.reset = !1, i.scroll.target = !1, this.options.animateHistoryBrowsing && (i.animation.animate = !0, i.scroll.reset = !0), this.hooks.callSync("history:popstate", i, {
            event: t
        }, ()=>{
            this.performNavigation(i);
        });
    }
    triggerWillOpenNewWindow(t) {
        return !!t.matches('[download], [target="_blank"]');
    }
}


parcelRequire("lXx6D");
// init swup
const $87c77ca5d14cabfc$var$swup = new (0, $40ae24e1b9804100$export$2e2bcd8739ae039)({
    // options
    plugins: []
});
let $87c77ca5d14cabfc$var$page;
const $87c77ca5d14cabfc$var$checkPath = (callback)=>{
    const path = window.location.pathname;
    const length = path.split("/").length;
    if (path.includes("/cv/")) $87c77ca5d14cabfc$var$page = "cv";
    else if (path.includes("/imprint/")) $87c77ca5d14cabfc$var$page = "imprint";
    else if ((path.includes("/projects/") || path.includes("/projektek/") || path.includes("/projekte/")) && length == 4) $87c77ca5d14cabfc$var$page = "projects";
    else if ((path.includes("/projects/") || path.includes("/projektek/") || path.includes("/projekte/")) && length == 5) $87c77ca5d14cabfc$var$page = "project";
    else if (path === "/en/" || path === "/de/" || path === "/hu/") $87c77ca5d14cabfc$var$page = "home";
    callback();
};
const $87c77ca5d14cabfc$var$initListeners = ()=>{
    if ($87c77ca5d14cabfc$var$page === "home") // init splide
    new (0, $24d13f4ab4978ead$export$24494c7438c070bf)(".splide", {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
        autoplay: true,
        interval: 5000,
        speed: 1000
    }).mount();
    else if ($87c77ca5d14cabfc$var$page === "project") ;
    else if ($87c77ca5d14cabfc$var$page === "projects") {
        // highlight active sidebar element
        const sidebarElems = (0, $a868c52a55140070$export$2774c37398bee8b2)(".projectsSidebarElem");
        const headerHeight = (0, $a868c52a55140070$export$3988ae62b71be9a3)("header").offsetHeight;
        const viewportHeight = window.innerHeight;
        const highlightActiveSidebarElem = ()=>{
            sidebarElems.forEach((item)=>{
                const projectSlug = item.getAttribute("data-project-slug");
                const projectElement = (0, $a868c52a55140070$export$3988ae62b71be9a3)(`.projectElem[data-project-slug="${projectSlug}"]`);
                if (projectElement) {
                    if (!projectElement.classList.contains("hidden")) {
                        if (projectElement.getBoundingClientRect().top - headerHeight <= viewportHeight / 2) {
                            sidebarElems.forEach((item)=>{
                                item.classList.remove("active");
                            });
                            item.classList.add("active");
                        }
                    }
                }
            });
        };
        // hide filters that don't have any projects
        const hideEmptyFilters = ()=>{
            const projectFilters = (0, $a868c52a55140070$export$2774c37398bee8b2)(".projectFilter");
            const projectElems = (0, $a868c52a55140070$export$2774c37398bee8b2)(".projectElem");
            projectFilters.forEach((filter)=>{
                const filterValue = filter.getAttribute("data-filter");
                if (filterValue !== "projects") {
                    const projects = [
                        ...projectElems
                    ].filter((elem)=>elem.getAttribute("data-filter").includes(filterValue));
                    if (projects.length === 0) filter.style.display = "none";
                }
            });
        };
        // initial check
        highlightActiveSidebarElem();
        hideEmptyFilters();
        // check on scroll
        window.addEventListener("scroll", ()=>{
            highlightActiveSidebarElem();
        });
        // filter projects by category
        const projectFilters = (0, $a868c52a55140070$export$2774c37398bee8b2)(".projectFilter");
        const projectElems = (0, $a868c52a55140070$export$2774c37398bee8b2)(".projectElem");
        projectFilters.forEach((filter)=>{
            filter.addEventListener("click", ()=>{
                const filterValue = filter.getAttribute("data-filter");
                // filter the projects
                projectElems.forEach((elem)=>{
                    if (filterValue === "projects") {
                        elem.style.display = "block";
                        elem.classList.remove("hidden");
                    } else if (elem.getAttribute("data-filter").includes(filterValue)) {
                        elem.style.display = "block";
                        elem.classList.remove("hidden");
                    } else {
                        elem.style.display = "none";
                        elem.classList.add("hidden");
                    }
                });
                // hide the sidebar elements of the hidden projects
                sidebarElems.forEach((elem)=>{
                    elem.classList.remove("active");
                    if (filterValue === "projects") elem.style.display = "block";
                    else if (elem.getAttribute("data-filter").includes(filterValue)) elem.style.display = "block";
                    else elem.style.display = "none";
                });
                // underline the active filter
                projectFilters.forEach((filter)=>{
                    filter.classList.remove("active");
                });
                filter.classList.add("active");
                // re-check the active sidebar element
                highlightActiveSidebarElem();
            });
        });
    }
    // hide/show header on scroll
    const header = (0, $a868c52a55140070$export$3988ae62b71be9a3)("header");
    const projectsSidebar = (0, $a868c52a55140070$export$3988ae62b71be9a3)(".projectsSidebar");
    let lastScrollTop = 0;
    const threshold = 20;
    const minScroll = 100;
    window.addEventListener("scroll", function() {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        let scrollDifference = Math.abs(scrollTop - lastScrollTop);
        if (scrollTop > minScroll && scrollDifference > threshold && window.innerWidth > 1000) {
            if (scrollTop > lastScrollTop) {
                header.style.transform = "translateY(-100%)";
                if (projectsSidebar) projectsSidebar.classList.add("scrolled");
            } else {
                header.style.transform = "translateY(0)";
                if (projectsSidebar) projectsSidebar.classList.remove("scrolled");
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        }
    }, {
        passive: true
    });
    // mobile menu
    const hamburgerButton = (0, $a868c52a55140070$export$3988ae62b71be9a3)(".hamburgerButton");
    const body = (0, $a868c52a55140070$export$3988ae62b71be9a3)(".body");
    hamburgerButton.addEventListener("click", ()=>{
        body.classList.toggle("mobileMenuActive");
    });
    (0, $a868c52a55140070$export$3988ae62b71be9a3)(".mobileMenuElems").addEventListener("click", ()=>{
        body.classList.remove("mobileMenuActive");
    });
};
document.addEventListener("DOMContentLoaded", function() {
    // first load
    $87c77ca5d14cabfc$var$checkPath($87c77ca5d14cabfc$var$initListeners);
    // swup page load (all loads but the first)
    $87c77ca5d14cabfc$var$swup.hooks.on("page:view", (visit)=>{
        $87c77ca5d14cabfc$var$checkPath($87c77ca5d14cabfc$var$initListeners);
    });
});
// ----- NETLIFY & DECAP CMS -----
// netlify identity widget
const $87c77ca5d14cabfc$var$netlifyIdentity = ()=>{
    if (window.netlifyIdentity) window.netlifyIdentity.on("init", (user)=>{
        if (!user) window.netlifyIdentity.on("login", ()=>{
            document.location.href = "/admin/";
        });
    });
};
$87c77ca5d14cabfc$var$netlifyIdentity();

})();
//# sourceMappingURL=main.js.map
